<template>
  <v-container>
    <!-- Poznámky pro soutěž -->
    <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
    <!-- <div v-if="isLoadingEvent">
      <v-skeleton-loader type="chip,chip,chip,chip,chip,chip" />
      <v-row>
        <v-col cols="12" md="4" v-for="n in 3" :key="n">
          <v-skeleton-loader type="list-item-three-line, list-item-three-line, paragraph" />
        </v-col>
      </v-row>
      <v-skeleton-loader type="actions" />
      <v-skeleton-loader width="100%" height="40px" />
    </div> -->
    <v-card v-if="isOrganizer">
      <v-toolbar flat dense>
        <v-tabs v-model="main" class="flex-grow-1" bg-color="primary" slider-color="#F1A829" center-active show-arrows>
          <!-- Zachování původní záložky eventu -->
          <v-tab value="event">{{ event.event_name }}</v-tab>
          <v-divider :thickness="10" class="border-opacity-100" vertical color="tab-divider" />
          <!-- Dynamické generování záložek pro etapy získané z API a generace obsahu podle Race ID -->
          <v-tab v-for="(race, etap) in races" :key="race.id" :value="`race-${race.id}`">
            E{{ etap + 1 }}: {{ race.race_name }}
          </v-tab>
          <!-- Tlačítko pro přidání další etapy se spuštěním dialogového okna -->
          <v-tooltip location="top center" origin="auto" :text="$t('event_settings.add_stage_hint')" v-if="!event.event_closed">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" text @click="dialogAddRace = true" color="green" style="height:100%;"><v-icon size="28">mdi-plus-circle</v-icon></v-btn>
            </template>
          </v-tooltip>  
            <!-- Dialog pro přidání Race -->
            <v-dialog v-model="dialogAddRace" persistent max-width="400px">
            <v-card>
              <v-card-title class="text-h5">{{ $t('event_settings.add_stage') }}</v-card-title>
              <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
            <v-card-text>
              <v-form @submit.prevent="addRace">
                <v-text-field v-model="newRace.race_name" :label="$t('event_settings.stage.name')" :rules="eventTitle"></v-text-field>
                <v-text-field v-model="newRace.race_date" :label="$t('event_settings.stage.date')" type="date" :rules="eventDate"></v-text-field>
                <v-select :items="raceLevel" v-model="newRace.race_level" :label="$t('event_settings.stage.level')" :rules="eventType"></v-select>
                <v-card-actions>
                <v-btn color="blue darken-1" @click="dialogAddRace = false">{{ $t('general.cancel') }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="addRace">{{ $t('event_settings.add_stage') }}</v-btn>
              </v-card-actions>

              </v-form>
            </v-card-text>
            </v-card>
          </v-dialog>
        </v-tabs>
        <!-- Zachování tlačítka nastavení -->
        <v-btn text :to="'/soutez/' + event.id" style="height:100%;margin-inline-end: 0px"><v-icon size="28">mdi-arrow-left-circle</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-window v-model="main">
          <v-window-item value="event">
            <v-card v-if="event && event.event_organizer">
              <v-form ref="form" @submit.prevent="saveEvent">
              <v-row>
              <!-- První sloupec -->
                <v-col cols="12" md="6">
                  <v-card-title>{{ event.event_name }} <span v-if="event.event_date_start">{{ $formatDate(event.event_date_start) }}</span> <span v-if="event.event_date_end">- {{ $formatDate(event.event_date_end) }}</span></v-card-title>
                    <v-col cold="12">
                      {{ $t('event_settings.event_id') }}: {{ event.id }} <v-icon v-if="event.event_closed" color="warning" size="x-large">mdi-lock</v-icon><span v-if="event.event_closed" class="text-caption text-warning">{{ $t('event_settings.event_closed') }}</span><v-icon v-if="event.event_closed" color="warning" size="x-large">mdi-lock</v-icon>
                    </v-col>
                    <v-text-field :label="$t('event_settings.event_name')" v-model="event.event_name" :rules="eventTitle" maxlength="50" counter density="comfortable" />
                    <v-text-field v-model="event.event_date_start" :label="$t('event_settings.date_start')" type="date" :rules="eventDate" density="comfortable" />
                    <v-text-field :label="$t('event_settings.date_end')" v-model="event.event_date_end" type="date" density="comfortable" />
                    <!-- <v-text-field label="Start 00" v-if="races.length === 0 & isRace0" v-model="race0.race_startTime" type="time" :value="race0.race_start ? $formatTime(race0.race_start) : ''" @input="updaterace_startTime(race0)" clearable density="comfortable"></v-text-field> -->
                    <v-tooltip location="top center" origin="auto" :text="$t('event_settings.editors_tooltip')">
                      <template v-slot:activator="{ props }">
                        <v-autocomplete :readonly="event.author !== Number(authStore.userID)" v-bind="props" v-model="selectedEditors" :items="editors" :label="$t('event_settings.editors')" multiple item-value="id" item-title="fullName" :hint="selectedEditors.length === 0 ? $t('event_settings.editors_hint') : ''" :persistent-hint="selectedEditors.length === 0" density="comfortable" />
                      </template>
                    </v-tooltip>
                    <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-title color="primary">{{ $t('event_settings.more_settings') }}</v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <v-select :label="$t('event_settings.event_type')" v-model="event.event_type" :items="eventTypes" :rules="eventType" density="comfortable" />
                          
                          <v-tooltip location="top center" origin="auto" :text="$t('event_settings.location_coords_hint')">
                            <template v-slot:activator="{ props }">
                              <v-text-field v-bind="props" :label="$t('event_settings.location_coords')" v-model="event.event_location" maxlength="30" counter density="comfortable" />
                            </template>
                          </v-tooltip>

                          <v-tooltip location="top center" origin="auto" :text="$t('event_settings.visibility_hint')">
                            <template v-slot:activator="{ props }">
                              <v-select v-bind="props" :label="$t('event_settings.visibility')" v-model="event.visibility" :items="visibilityTypes" :rules="visibilityType" density="comfortable" />
                            </template>
                          </v-tooltip>
                          <v-select :label="$t('event_settings.event_currency')" v-model="event.event_currency" :items="CURRENCY_ITEMS" density="comfortable" />
                          <v-tooltip location="top center" origin="auto" :text="$t('event_settings.only_registered_hint')">
                            <template v-slot:activator="{ props }">
                              <v-switch v-bind="props" v-model="event.auth_entry_only" :label="$t('event_settings.auth_entry_only')" color="primary" hide-details />
                            </template>
                          </v-tooltip>
                          <v-tooltip location="top center" origin="auto" :text="$t('event_settings.deadline_hint')">
                            <template v-slot:activator="{ props }">
                              <v-switch v-bind="props" v-model="event.allow_start_choice" color="primary" :label="$t('event_settings.allow_start_choice')" hide-details />
                            </template>
                          </v-tooltip>
                          <v-switch v-model="event.acc_all_only" color="primary" :label="$t('event_settings.acc_all_only')" hide-details />
                          <v-switch v-model="event.disable_si_cards" color="primary" :label="$t('event_settings.disable_si')" hide-details />
                          <v-switch v-model="event.disable_automodule" color="primary" :label="$t('event_settings.disable_automodule')" hide-details />
                          <v-tooltip location="top center" origin="auto" :text="$t('event_settings.canceled_hint')">
                            <template v-slot:activator="{ props }">
                              <v-switch v-bind="props" v-model="event.canceled" :label="$t('event_settings.canceled')" color="primary" density="comfortable" />
                            </template>
                          </v-tooltip>
                          <v-text-field :label="$t('event_settings.contact')" v-model="event.contact" maxlength="100" counter density="comfortable" />
                          <v-text-field :label="$t('event_settings.message_entry')" v-model="race0.message_entry" maxlength="500" counter density="comfortable" />
                          <v-text-field :label="$t('event_settings.message_info')" v-model="race0.message_info" maxlength="500" counter density="comfortable" />
                          <v-text-field :label="$t('event_settings.message_warning')" v-model="race0.message_warning" maxlength="500" counter density="comfortable" />
                          <v-textarea :label="$t('event_settings.note')" v-model="event.event_note" maxlength="1000" counter />
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  

                    <!-- Dialog pro potvrzení smazání Eventu -->
                    <v-dialog v-model="dialogDeleteEvent" persistent max-width="600px">
                      <v-card>
                        <v-card-title class="text-h5">{{ $t('event_settings.title_delete') }}</v-card-title>
                        <v-card-text>
                          <i18n-t keypath="event_settings.text_delete">
                            <strong>{{ event.event_name }}</strong>
                          </i18n-t>
                      </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="dialogDeleteEvent = false">{{ $t('general.cancel') }}</v-btn>
                          <v-btn color="red darken-1" text @click="deleteEvent">{{ $t('general.delete') }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                </v-col>

                  <!-- Druhý sloupec -->
                  <v-col cols="12" md="3">
                    <v-card-title>{{ $t('event_settings.login_settings') }}</v-card-title>
                    <v-tooltip location="top center" origin="auto" :text="$t('event_settings.entry_switch')">
                      <template v-slot:activator="{ props }">
                        <v-switch v-bind="props" v-model="event.entry_is_open" :label="$t('event_settings.entry_is_open')" color="primary" hide-details />
                      </template>
                    </v-tooltip>
                    <v-text-field v-model="race0.entry_deadline_1" type="datetime-local" :label="$t('event_settings.entry_deadline_1')" density="comfortable" />
                    <v-text-field hide-details v-model="race0.entry_deadline_2" type="datetime-local" :label="$t('event_settings.entry_deadline_2')" density="comfortable" />
                    <v-tooltip location="top center" origin="auto" :text="$t('event_settings.restrict_services_tooltip')">
                      <template v-slot:activator="{ props }">
                        <v-switch v-bind="props" v-model="event.restrict_services" :label="$t('event_settings.restrict_services')" color="primary" class="mb-2" hide-details />
                      </template>
                    </v-tooltip>

                    <v-btn
                      color="primary"
                      class="w-100 mb-2 btn-text-wrap"
                      @click="dialogCategory = true"
                      :title="$t('event_settings.manage_categories_title')"
                    >
                      {{ $t('event_settings.manage_categories') }}
                    </v-btn>

                    <!-- Dialogové okno pro správu kategorií -->
                    <v-dialog v-model="dialogCategory" max-width="1000px">
                      <v-card>
                        <v-card-title>
                          {{ $t('event_settings.categories.dialog_title') }}
                          <v-btn color="green darken-1" @click="addNewCategory" style="float:right">{{ $t('event_settings.categories.add') }}</v-btn>
                        </v-card-title>
                        <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="bulkFee" :label="$t('event_settings.categories.bulk_fee')" @change="applyBulkFee" :suffix="`${currencySymbol(event?.event_currency)}`" />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="bulkIncreasedFee" :label="$t('event_settings.categories.bulk_increased_fee')" @change="applyBulkIncreasedFee" :suffix="`${currencySymbol(event?.event_currency)}`" />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field v-model="bulkFeeEvent" :label="$t('event_settings.categories.bulk_fee_event')" @change="applyBulkFeeEvent" :suffix="`${currencySymbol(event?.event_currency)}`" />
                          </v-col>
                        </v-row>

                        <v-data-table
                            :items="categories"
                            :items-per-page="-1"
                            :headers="categoryHeaders"
                            item-key="id"
                            class="elevation-1"
                            :sort-by="[{ key: 'option'}]"
                            hide-default-footer>

                            <template v-slot:item="{ item }">

                              <tr>

                                <td>
                                  <v-select v-model="item.option" :items="CategoryType" solo style="min-width: 160px" :rules="optionRules" />
                                </td>
                                <td><v-text-field v-model="item.category_name" solo :rules="nameRules" maxlength="20" counter /></td>
                                <!-- <td>
                                  <v-select
                                    v-model="item.sex"
                                    :items="[ { title: 'Žena', value: 'F' }, { title: 'Muž', value: 'M' }]"
                                    dense flat solo
                                    style="min-width: 100px;"
                                    :rules="sexRules"
                                    ></v-select>
                                </td> -->
                                <td><v-text-field v-model="item.fee" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                                <td><v-text-field v-model="item.increased_fee" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                                <td><v-text-field v-model="item.fee_event" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                                <td style="min-width: 50px;"><v-icon color="red" small @click="markCategoryForDeletion(item)">mdi-delete</v-icon></td>

                              </tr>
                            </template>
                          </v-data-table>
                          <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn color="grey" @click="dialogCategory = false">{{ $t('general.close') }}</v-btn>
                          <v-spacer></v-spacer>
                          <v-switch
                            v-model="change_allcategories"
                            color="primary"
                            :label="$t('event_settings.categories.apply_to_all_races')"
                            hide-details
                          ></v-switch>
                          <v-btn color="green darken-1" @click="dialogCategoryRace0show" :disabled="!NotNameOption() || event.event_closed" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                          >
                            {{ $t('general.save') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <!-- Dialog pro potvrzení uložení a přepsání všech kategorií -->
                    <v-dialog v-model="dialogCategoryRace0" max-width="600px" class="dialog-over-dialog">
                      <v-card>
                        <v-card-title class="text-h5">{{ $t('event_settings.categories.confirm_title') }}</v-card-title>
                        <v-card-text>
                          <i18n-t keypath="event_settings.categories.confirm_text">
                            <strong>{{ event.event_name }}</strong>
                          </i18n-t>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="dialogCategoryRace0 = false">{{ $t('general.cancel') }}</v-btn>
                          <v-btn color="green darken-1" text @click="updateCategory" :loading="loadingUpdateCatgory">{{ $t('event_settings.categories.confirm_overwrite') }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    
                    <v-btn
                      color="secondary"
                      class="w-100 my-3 btn-text-wrap"
                      @click="dialogOracon = true"
                    >
                      {{ $t('event_settings.oracon_manage') }}
                    </v-btn>
                    
                    
                    <v-dialog
                        v-model="dialogOracon"
                        max-width="1600"
                        height="100%"
                        scrollable
                        :retain-focus="false" 
                      >
                        <v-card class="overflow-hidden">
                          <v-toolbar density="compact">
                            <v-spacer />
                            <v-btn icon @click="dialogOracon = false"><v-icon>mdi-close</v-icon></v-btn>
                          </v-toolbar>

                          <v-card-text class="pa-0">
                            
                              <RadioControlPage />
                            
                          </v-card-text>
                        </v-card>
                      </v-dialog>


                  </v-col>

                <!-- Třetí sloupec -->
                <v-col cols="12" md="3">
                  <v-card>
                  <v-card-title>
                    {{ $t('event_settings.files') }}
                    <v-icon color="green" size="35" style="float:right" @click="showAddFileSection = !showAddFileSection">mdi-file-plus</v-icon>
                  </v-card-title>
                  <v-card-text>

                    <!-- Formulář pro přidání nového souboru -->
                    <div v-if="showAddFileSection">
                      <v-card>
                        <v-card-text>
                          <v-text-field v-model="newFile.name" :label="$t('event_settings.file_name')" maxlength="30" counter :placeholder="$t('event_settings.file_placeholder')" :rules="fileName" />
                          <v-select :label="$t('event_settings.file_type')" v-model="newFile.specific" :items="fileTypes" clearable />
                          <v-file-input :label="$t('event_settings.select_file')" name="location" @change="handleNewFileChange" :error-messages="fileError" show-size />
                          <v-btn color="success" @click="addNewFile">{{ $t('general.upload') }}</v-btn>
                        </v-card-text>
                      </v-card>
                    </div>

                      <v-list  v-for="file in filesWithLocation" :key="file.id">

                        <div v-if="!file.editing" class="d-flex justify-space-between">
                          <v-list-item-title>
                            <a :href="`${BaseUrl}${file.location}`" target="_blank" class="font-weight-bold">{{ file.name }}</a>
                          </v-list-item-title>

                        <v-list-item-action>
                          <!-- Ikona pro editaci -->
                          <v-icon color="blue" size="x-large" @click="editFile(file)" class="mr-2">mdi-pencil</v-icon>
                          <!-- Delete File Button -->
                          <v-icon color="red" size="x-large" @click="file.dialogDeleteFile = true">mdi-delete</v-icon>
                        </v-list-item-action>

                          <!-- Dialog pro potvrzení smazání Souboru -->
                          <v-dialog v-model="file.dialogDeleteFile" persistent max-width="600px">
                            <v-card>
                              <v-card-title class="text-h5">{{ $t('event_settings.delete_dialog_title') }}</v-card-title>
                              <v-card-text>{{ $t('event_settings.delete_dialog_text', { name: file.name, location: file.location }) }}</v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="file.dialogDeleteFile = false">{{ $t('general.cancel') }}</v-btn>
                                <v-btn color="red darken-1" text @click="deleteFile(file.id, file)">{{ $t('general.delete') }}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>

                        </div>

                        <div v-else>
                          <!-- Editace souboru -->
                          <v-text-field v-model="file.name" :label="$t('event_settings.edit_name')" counter maxlength="30" :placeholder="$t('event_settings.file_placeholder')" :rules="fileName"></v-text-field>
                          <!-- Výběr kategorie -->
                          <v-select :label="$t('event_settings.file_type')" v-model="file.specific" :items="fileTypes" density="comfortable" clearable/>
                          <!-- File Upload Input -->
                          <v-file-input :label="$t('event_settings.insert_file')" @change="handleNewFileChange($event, file)" outlined dense density="compact" :error-messages="fileError" show-size />
                          <div>{{ file.location }}</div>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                          <!-- Uložení změn -->
                          <v-icon color="blue" @click="updateFiles(file)" size="34">mdi-content-save</v-icon>
                          </v-card-actions>
                        </div>
                      </v-list>
                  </v-card-text>
                  </v-card>

                  <v-card class="mt-2">
                    <v-card-title>
                      {{ $t('event_settings.links') }}
                      <v-icon color="green" size="35" style="float:right" @click="showAddLinkSection = !showAddLinkSection">mdi-link-plus</v-icon>
                    </v-card-title>
                    <v-card-text>
                      <!-- Formulář pro přidání nového odkazu -->
                      <div v-if="showAddLinkSection">
                        <v-card>
                          <v-card-text>
                            <v-text-field v-model="newLink.name" :label="$t('event_settings.name_link')" maxlength="30" counter :placeholder="$t('event_settings.link_placeholder')" :rules="linkName"></v-text-field>
                            <v-text-field v-model="newLink.url" :label="$t('event_settings.url')" placeholder="https://"></v-text-field>

                            <v-btn color="success" @click="addNewLink">{{ $t('event_settings.add') }}</v-btn>
                          </v-card-text>
                        </v-card>
                      </div>
                      <v-list v-for="file in filesWithLinks" :key="file.id">
                        <div v-if="!file.editing" class="d-flex justify-space-between">
                          <v-list-item-title><a :href="file.url" target="_blank" class="font-weight-bold">{{ file.name }}</a></v-list-item-title>
                          <v-list-item-action>
                            <v-icon color="blue" size="x-large" @click="editLink(file)" class="mr-2">mdi-pencil</v-icon>
                            <v-icon color="red" size="x-large" @click="file.dialogDeleteFile = true" >mdi-delete</v-icon>
                          </v-list-item-action>
                          <!-- Dialog pro potvrzení smazání Odkazu -->
                          <v-dialog v-model="file.dialogDeleteFile" persistent max-width="600px">
                              <v-card>
                                <v-card-title class="text-h5">{{ $t('event_settings.delete_dialog_title_link') }}</v-card-title>
                                <v-card-text>{{ $t('event_settings.confirm_delete_text_link', { name: file.name, url: file.url }) }}</v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="blue darken-1" text @click="file.dialogDeleteFile = false">{{ $t('general.cancel') }}</v-btn>
                                  <v-btn color="red darken-1" text @click="deleteFile(file.id, file)">{{ $t('general.delete') }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                        </div>
                        <div v-else>
                            <!-- Editace souboru -->
                            <v-text-field v-model="file.name" :label="$t('event_settings.name_link')" maxlength="30" counter :placeholder="$t('event_settings.link_placeholder')" :rules="linkName"></v-text-field>
                            <v-text-field v-model="file.url" :label="$t('event_settings.url')" :placeholder="$t('event_settings.link_placeholder')"></v-text-field>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                            <!-- Uložení změn -->
                            <v-icon color="blue" @click="updateFiles(file)" size="34">mdi-content-save</v-icon>
                            </v-card-actions>
                          </div>

                      </v-list>
                    </v-card-text>
                  </v-card>
                <!-- Konec třetího sloupce -->
                </v-col>

              </v-row>

              <v-row class="d-flex justify-end">
                <v-col cols="12" md="auto" class="d-flex flex-column flex-md-row align-items-md-end">
                  <v-btn color="success" type="submit" class="mb-2 w-100 w-md-auto order-1 order-md-5" :disabled="event.event_closed" :loading="isLoading" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined">
                     {{ $t('general.save_changes') }}
                  </v-btn>
                  <v-btn :loading="loadingDocx" @click="downloadProtocol" v-if="event.event_date_start && new Date(event.event_date_start) <= new Date()" color="secondary" :href="`${BaseUrl}/export/?type=docx&event_id=${event.id}`" class="mb-2 mr-md-5 w-100 w-md-auto order-4 order-md-3">
                    {{ $t('event_settings.download_protocol') }}
                  </v-btn>
                  <v-tooltip location="top center" origin="auto">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" color="primary"
                        v-if="event.event_date_start && new Date(event.event_date_start) <= new Date() && races.length > 0"
                        :loading="loadingRecalculate"
                        @click="recalculateVtRank"
                        :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed"
                        class="mb-2 mr-md-5 w-100 w-md-auto order-3 order-md-4"
                      >
                        {{ $t('event_settings.recalc_vt') }}
                      </v-btn>
                    </template>
                    {{ $t('event_settings.recalc_vt_tooltip') }}
                  </v-tooltip>

                  <v-tooltip location="top center" origin="auto" v-if="event.event_date_start && new Date(event.event_date_start) <= new Date()">
                    <template v-slot:activator="{ props }">
                      <v-btn v-bind="props" color="warning" @click="CloseEventDialog" prepend-icon="mdi-lock"
                        class="mb-2 mr-0 mr-md-5 w-100 w-md-auto order-4 order-md-2"
                        :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed"
                        >
                        {{ $t('event_settings.closed_button')}}
                      </v-btn>
                    </template>
                    {{ $t('event_settings.closed_tooltip')}}
                  </v-tooltip>
                  <v-btn color="error" @click="dialogDeleteEvent = true" class="mb-2 mr-0 mr-md-5 w-100 w-md-auto order-5 order-md-1" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined" :disabled="event.event_closed">
                    {{ $t('event_settings.delete_event') }}
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Potvrzení pro uzamčení soutěže -->
              <v-dialog v-model="confirmCloseDialog" max-width="800" persistent>
                <v-card>
                  <v-card-title class="text-h6">{{ $t('event_settings.closed_dialog_title') }}</v-card-title>
                  <v-card-text>
                    {{ $t('event_settings.closed_dialog_message') }}
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn variant="text" @click="confirmCloseDialog = false" :disabled="loadingCloseEvent">{{ $t('general.cancel') }}</v-btn>
                    <v-btn color="warning" :loading="loadingCloseEvent" prepend-icon="mdi-lock" @click="CloseEvent">
                      {{ $t('event_settings.closed_button')}}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-form>

            </v-card>
          </v-window-item>

<!-- ***************************************
 *******************************************
 ********          ETAPY          **********
 *******************************************
 ****************************************-->

          <!-- Dynamické generování obsahu pro etapy -->
          <v-window-item v-for="(race, etap) in races" :key="race.id" :value="`race-${race.id}`">
          <v-form ref="form" @submit.prevent="saveEvent">
          <v-row>
            <v-col cols="12" md="6">
              <v-card-title>Etapa {{ etap + 1 }}: {{ race.race_name }}</v-card-title>
                <v-col>ID: {{ race.id }}</v-col>
                <v-text-field v-model="race.race_name" :label="$t('event_settings.stage.name')" :rules="eventTitle" maxlength="40" counter density="comfortable"></v-text-field>
                <v-text-field v-model="race.race_date" :label="$t('event_settings.stage.date')" type="date" required :rules="eventDate" density="comfortable" @update:modelValue="updateRaceStartDate(race)"></v-text-field>
                <v-text-field v-model="race.race_startTime" type="time" :label="$t('event_settings.stage.start00')" :value="race.race_start ? $formatTime(race.race_start) : ''" @input="updaterace_startTime(race)" clearable density="comfortable"></v-text-field>
                <v-expansion-panels>
                      <v-expansion-panel>
                        <v-expansion-panel-title color="primary">{{ $t('event_settings.stage.more_settings') }}</v-expansion-panel-title>
                        <v-expansion-panel-text>
                          <v-select :items="raceLevel" v-model="race.race_level" :label="$t('event_settings.stage.level')" :rules="eventType"></v-select>
                          <v-select v-model="race.race_band" :items="race_bands" clearable :label="$t('event_settings.stage.band')"></v-select>
                          <v-select v-model="race.race_type" :items="RACE_TYPE_ITEMS" clearable :label="$t('event_settings.stage.type')"></v-select>
                          <v-text-field v-model="race.race_time_limit" type="number" :label="$t('event_settings.stage.time_limit')"></v-text-field>
                          <v-text-field v-model="race.message_info" :label="$t('event_settings.stage.message_info')" maxlength="500" counter></v-text-field>
                          <v-text-field v-model="race.message_warning" :label="$t('event_settings.stage.message_warning')" maxlength="500" counter></v-text-field>
                          <v-textarea v-model="race.race_note" :label="$t('event_settings.stage.note')" maxlength="1000" counter></v-textarea>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>

              <!-- Dialog pro potvrzení smazání Etapy -->
              <v-dialog v-model="race.dialogDeleteRace" persistent max-width="600px">
                <v-card>
                  <v-card-title class="text-h5">{{ $t('event_settings.stage.delete_conf') }}</v-card-title>
                  <v-card-text>
                    <i18n-t keypath="event_settings.stage.delete_conf_text">
                      <strong>{{ race.race_name }}</strong>
                    </i18n-t>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="race.dialogDeleteRace = false">{{ $t('general.cancel') }}</v-btn>
                    <v-btn color="red darken-1" text @click="deleteRace(event.id, race.id, race), race.dialogDeleteRace = false">{{ $t('general.delete') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


            </v-col>


                <!-- Druhý sloupec -->
                <v-col cols="12" md="3" class="mt-3">
                  <!-- <v-card-title>Termín přihlášky pro Etapu</v-card-title>
                  <v-text-field v-model="race.entry_deadline_1" type="datetime-local" label="1. termín přihlášek pro etapu"></v-text-field>
                  <v-text-field v-model="race.entry_deadline_2" type="datetime-local" label="2. termín přihlášek pro etapu"></v-text-field> -->


                  <div cols="12" md="12" class="text-center">
                  <v-btn color="primary" @click="openCategoryDialog(race.id)" class="w-100">{{ $t('event_settings.stage.manage_categories') }}</v-btn>
                  </div>
                  <!-- Dialogové okno pro správu kategorií   - přemístěné mimo loop
                  <v-dialog v-model="dialogCategoryRace" max-width="1200px">
                    <v-card>
                      <v-card-title>
                        {{ $t('event_settings.categories.dialog_title') }}
                        <v-btn color="green darken-1" @click="addNewCategory" style="float: right;">{{ $t('event_settings.categories.add') }}</v-btn>
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                        <v-col cols="6">
                          <v-text-field v-model="bulkFee" :label="$t('event_settings.categories.bulk_fee')" @change="applyBulkFee" :suffix="`${currencySymbol(event?.event_currency)}`"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field v-model="bulkIncreasedFee" :label="$t('event_settings.categories.bulk_increased_fee')" @change="applyBulkIncreasedFee" :suffix="`${currencySymbol(event?.event_currency)}`"></v-text-field>
                        </v-col>
                      </v-row>
                        <v-data-table
                          :items="categories"
                          :items-per-page="-1"
                          :headers="categoryHeadersEvents"
                          item-key="id"
                          class="elevation-1"
                          :sort-by="[{ key: 'option'}]"
                          fixed-header
                          density="compact"
                          hide-default-footer>

                          <template v-slot:item="{ item }">
                            <tr>
                              <td>
                                <v-select v-model="item.option" :items="CategoryType" solo style="min-width: 160px;" :rules="optionRules" />
                              </td>
                              <td><v-text-field v-model="item.category_name" solo :rules="nameRules" maxlength="20" counter /></td>
                              <td><v-text-field v-model="item.fee" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                              <td><v-text-field v-model="item.increased_fee" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                              <td><v-text-field v-model="item.category_control_points" hint="např. 1, F2, 3, M" solo /></td>
                              <td><v-select v-model="item.category_level" :items="CategoryLevelOptions" item-title="title" item-value="value" /></td>
                              <td style="min-width: 50px;">
                                <v-tooltip location="top center" origin="auto" :text="$t('event_settings.categories.ranked_tooltip')">
                                  <template v-slot:activator="{ props }">
                                    <v-checkbox v-bind="props" v-model="item.enable_ranking" hide-details />
                                  </template>
                                </v-tooltip>
                              </td>
                              <td style="min-width: 50px;"><v-icon color="red" small @click="markCategoryForDeletion(item)">mdi-delete</v-icon></td>
                            </tr>
                          </template>
                        </v-data-table>
                        <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="grey" @click="dialogCategoryRace = false">{{ $t('general.close') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" @click="updateCategory" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed" :loading="loadingUpdateCatgory">{{ $t('general.save') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog> -->

                  <v-text-field
                    :label="$t('event_settings.label_api')"
                    variant="outlined"
                    density="compact"
                    v-model="race.race_api_key"
                    :append-inner-icon="copiedApiKey ? 'mdi-check' : 'mdi-content-copy'"
                    :icon-color="copiedApiKey ? 'success' : undefined"
                    @click:append-inner="copyKey(race)"
                    class="my-6"
                    hide-details
                    readonly
                  ></v-text-field>

                    
                  <div cols="12" md="12" class="text-center" v-if="event.event_type !== 'repre' && event.event_type !== 'scm'">
                    <v-btn color="secondary" @click="dialogOrganizersList = true" class="w-100">{{ $t('event_settings.org_dialog.title') }}</v-btn>
                  </div>

                  <v-dialog v-model="dialogOrganizersList" max-width="800px" persistent>
                    <v-card>
                      <v-card-title class="text-h5">{{ $t('event_settings.org_dialog.title') }}</v-card-title>
                      <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
                      <v-card-text>
                        <v-autocomplete
                          v-model="currentRace.director"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.director')"
                          multiple
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="currentRace.main_referee"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.main_referee')"
                          multiple
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="currentRace.course_setter"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.course_setter')"
                          multiple
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="currentRace.other_referee"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.other_referee')"
                          multiple
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="currentRace.jury_members"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.jury_members')"
                          multiple
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="currentRace.delegate"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.delegate')"
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="currentRace.organizers_avg"
                          :items="officials"
                          :label="$t('event_settings.org_dialog.organizers_avg')"
                          multiple
                          item-value="id"
                          item-title="fullName"
                          density="comfortable"
                        ></v-autocomplete>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="grey" @click="dialogOrganizersListCancel">{{ $t('general.cancel') }}</v-btn>
                        <v-spacer></v-spacer>

                        <!-- COPY menu button -->
                        <v-tooltip location="top center" origin="auto" :text="$t('event_settings.org_dialog.tooltip')" v-if="raceOptions.length > 0">
                        <template #activator="{ props: tipProps }">
                        <v-menu
                          v-model="copyMenuOpen"
                          location="top center"
                          :close-on-content-click="true"
                        >
                          <template #activator="{ props: menuProps }">
                            <v-btn size="large" variant="text" v-bind="{ ...tipProps, ...menuProps }">
                              <v-icon size="x-large" color="primary">mdi-table-large</v-icon>
                              <v-icon size="default" color="primary">mdi-arrow-right-bold</v-icon>
                              <v-icon size="default" color="primary">mdi-content-copy</v-icon>
                            </v-btn>
                          </template>

                          <v-list density="compact" style="min-width: 260px;">
                            <v-list-subheader>{{ $t('event_settings.org_dialog.copy_to') }}</v-list-subheader>

                            <v-list-item
                              v-for="r in raceOptions"
                              :key="r.value"
                              @click="onPickTargetRace(r.value)"
                            >
                              <v-list-item-title>{{ r.title }}</v-list-item-title>
                            </v-list-item>

                            <v-list-item v-if="raceOptions.length === 0" disabled>
                              <v-list-item-title>{{ $t('event_settings.org_dialog.no_race') }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        </template>
                        </v-tooltip>

                        <!-- potvrzení přepsání -->
                        <v-dialog v-model="dialogConfirmOverwrite" max-width="520px">
                          <v-card>
                            <v-card-title class="text-h6">{{ $t('event_settings.org_dialog.overwrite_confirm') }}</v-card-title>
                            <v-card-text>
                              <i18n-t keypath="event_settings.org_dialog.overwrite_confirm_text">
                                <strong>{{ targetRaceTitle }}</strong>
                              </i18n-t>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="grey" @click="dialogConfirmOverwrite = false">{{ $t('general.cancel') }}</v-btn>
                              <v-spacer />
                              <v-btn color="red" :loading="loadingCopy" @click="copyOrganizersToTargetRace">
                                {{ $t('event_settings.org_dialog.overwrite_confirm_button') }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>

                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" @click="saveEvent" :loading="isLoading" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('general.save') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>


                  <v-radio-group
                    v-model="race.result_publishing"
                    class="mt-6"
                    :label="$t('event_settings.results_publishing')"
                    color="primary"
                    inline
                  >
                    <!-- Password (kompaktní) -->
                    <div class="d-flex align-center mb-2 ga-2">
                      <v-text-field
                        v-model="race.result_password"
                        :label="$t('event_settings.label_password')"
                        variant="outlined"
                        density="compact"
                        hide-details
                        readonly
                        :append-inner-icon="copiedPassword ? 'mdi-check' : 'mdi-content-copy'"
                        :icon-color="copiedPassword ? 'success' : undefined"
                        @click:append-inner="copyPassword(race)"
                        style="width: 140px;"
                        class="shrink"
                      />
                    </div>

                    <v-radio :label="$t('event_settings.whenever')" value="WHENEVER" />
                    <v-radio :label="$t('event_settings.last_start')" value="LAST_START" />

                    <div class="d-flex align-center ga-3">
                      <v-radio :label="$t('event_settings.time')" value="DAY_TIME" />

                      <v-text-field
                        :disabled="race.result_publishing !== 'DAY_TIME'"
                        v-model="race.result_publish_at"
                        type="time"
                        step="60"
                        :label="$t('event_settings.time_label')"
                        density="compact"
                        variant="outlined"
                        style="max-width: 120px;"
                        :rules="timeRules"
                      />
                    </div>
                  </v-radio-group>
                  
                </v-col>

                <!-- Třetí sloupec -->
                <v-col cols="12" md="3">
                  <v-card>
                  <v-card-title>
                    {{ $t('event_settings.files') }}
                    <v-icon color="green" size="35" style="float:right" @click="showAddFileSection = !showAddFileSection">mdi-file-plus</v-icon>
                  </v-card-title>
                  <v-card-text>

                    <!-- Formulář pro přidání nového souboru -->
                    <div v-if="showAddFileSection">
                      <v-card>
                        <v-card-text>
                          <v-text-field v-model="newFile.name" :label="$t('event_settings.file_name')" maxlength="30" counter :placeholder="$t('event_settings.file_placeholder')" :rules="fileName" />
                          <v-select :label="$t('event_settings.file_type')" v-model="newFile.specific" :items="fileTypes" clearable />
                          <v-file-input :label="$t('event_settings.select_file')" name="location" @change="handleNewFileChange" :error-messages="fileError" show-size />
                          <v-btn color="success" @click="addNewFile">{{ $t('general.upload') }}</v-btn>
                        </v-card-text>
                      </v-card>
                    </div>

                      <v-list  v-for="file in filesWithLocation" :key="file.id">

                        <div v-if="!file.editing" class="d-flex justify-space-between">
                          <v-list-item-title>
                            <a :href="`${BaseUrl}${file.location}`" target="_blank" class="font-weight-bold">{{ file.name }}</a>
                          </v-list-item-title>

                        <v-list-item-action>
                          <!-- Ikona pro editaci -->
                          <v-icon color="blue" size="x-large" @click="editFile(file)" class="mr-2">mdi-pencil</v-icon>
                          <!-- Delete File Button -->
                          <v-icon color="red" size="x-large" @click="file.dialogDeleteFile = true">mdi-delete</v-icon>
                        </v-list-item-action>

                          <!-- Dialog pro potvrzení smazání Souboru -->
                          <v-dialog v-model="file.dialogDeleteFile" persistent max-width="600px">
                            <v-card>
                              <v-card-title class="text-h5">{{ $t('event_settings.delete_dialog_title') }}</v-card-title>
                              <v-card-text>
                                <i18n-t keypath="event_settings.delete_dialog_text">
                                  <strong>{{ file?.name }} - {{ file?.location }}</strong>
                                </i18n-t>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="file.dialogDeleteFile = false">{{ $t('general.cancel') }}</v-btn>
                                <v-btn color="red darken-1" text @click="deleteFile(file.id, file)">{{ $t('general.delete') }}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>

                        </div>

                        <div v-else>
                          <!-- Editace souboru -->
                          <v-text-field v-model="file.name" :label="$t('event_settings.edit_name')" counter maxlength="30" :placeholder="$t('event_settings.file_placeholder')" :rules="fileName"></v-text-field>
                          <!-- Výběr kategorie -->
                          <v-select :label="$t('event_settings.file_type')" v-model="file.specific" :items="fileTypes" density="comfortable" clearable />
                          <!-- File Upload Input -->
                          <v-file-input :label="$t('event_settings.insert_file')" @change="handleNewFileChange($event, file)" outlined dense density="compact" :error-messages="fileError" show-size />
                          <div style="margin-top: -18px;">{{ file.location }}</div>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                          <!-- Uložení změn -->
                          <v-icon color="blue" @click="updateFiles(file)" size="34">mdi-content-save</v-icon>
                          </v-card-actions>
                        </div>
                      </v-list>
                  </v-card-text>
                  </v-card>

                  <v-card class="mt-2">
                    <v-card-title>
                      {{ $t('event_settings.links') }}
                      <v-icon color="green" size="35" style="float:right" @click="showAddLinkSection = !showAddLinkSection">mdi-link-plus</v-icon>
                    </v-card-title>
                    <v-card-text>
                      <!-- Formulář pro přidání nového odkazu -->
                      <div v-if="showAddLinkSection">
                        <v-card>
                          <v-card-text>
                            <v-text-field v-model="newLink.name" :label="$t('event_settings.name_link')" maxlength="30" counter :placeholder="$t('event_settings.link_placeholder')" :rules="linkName"></v-text-field>
                            <v-text-field v-model="newLink.url" :label="$t('event_settings.url')" placeholder="https://"></v-text-field>

                            <v-btn color="success" @click="addNewLink">{{ $t('event_settings.add') }}</v-btn>
                          </v-card-text>
                        </v-card>
                      </div>
                      <v-list v-for="file in filesWithLinks" :key="file.id">
                        <div v-if="!file.editing" class="d-flex justify-space-between">
                          <v-list-item-title><a :href="file.url" target="_blank" class="font-weight-bold">{{ file.name }}</a></v-list-item-title>
                          <v-list-item-action>
                            <v-icon color="blue" size="x-large" @click="editLink(file)" class="mr-2">mdi-pencil</v-icon>
                            <v-icon color="red" size="x-large" @click="file.dialogDeleteFile = true" >mdi-delete</v-icon>
                          </v-list-item-action>
                          <!-- Dialog pro potvrzení smazání Odkazu -->
                          <v-dialog v-model="file.dialogDeleteFile" persistent max-width="600px">
                              <v-card>
                                <v-card-title class="text-h5">{{ $t('event_settings.delete_dialog_title_link') }}</v-card-title>
                                <v-card-text>
                                  <i18n-t keypath="event_settings.delete_dialog_text_link">
                                    <strong>{{ file?.name }} - {{ file?.url }}</strong>
                                  </i18n-t>
                                  </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="blue darken-1" text @click="file.dialogDeleteFile = false">{{ $t('general.cancel') }}</v-btn>
                                  <v-btn color="red darken-1" text @click="deleteFile(file.id, file)">{{ $t('general.delete') }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                        </div>
                        <div v-else>
                            <!-- Editace souboru -->
                            <v-text-field v-model="file.name" :label="$t('event_settings.name_link')" maxlength="30" counter :placeholder="$t('event_settings.link_placeholder')" :rules="linkName"></v-text-field>
                            <v-text-field v-model="file.url" :label="$t('event_settings.url')" placeholder="https://"></v-text-field>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                            <!-- Uložení změn -->
                            <v-icon color="blue" @click="updateFiles(file)" size="34">mdi-content-save</v-icon>
                            </v-card-actions>
                          </div>

                      </v-list>
                    </v-card-text>
                  </v-card>
            <!-- Konec třetího sloupce -->
                </v-col>
              </v-row>

              <v-row class="d-flex justify-end">
                <v-col cols="12" md="auto" class="d-flex flex-column flex-md-row align-items-md-end">
                  <v-btn color="success" type="submit" class="mb-2 w-100 w-md-auto order-md-1" :loading="isLoading" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('general.save_changes') }}</v-btn>
                  <v-btn color="error" @click="race.dialogDeleteRace = true" class="w-100 w-md-auto mr-5" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('event_settings.stage.delete_race') }}</v-btn>
                </v-col>
              </v-row>

              </v-form>

          </v-window-item>

          <!-- Dialogové okno pro správu kategorií -->
          <v-dialog
            :key="currentRaceId"               
            v-model="dialogCategoryOpen"
            max-width="1200px"
            :retain-focus="false"               
          >
            <v-card>
              <v-card-title>
                {{ $t('event_settings.categories.dialog_title') }}
                <v-btn color="green darken-1" @click="addNewCategory" style="float:right">
                  {{ $t('event_settings.categories.add') }}
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="6">
                    <v-text-field v-model="bulkFee" :label="$t('event_settings.categories.bulk_fee')" @change="applyBulkFee" :suffix="`${currencySymbol(event?.event_currency)}`"></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field v-model="bulkIncreasedFee" :label="$t('event_settings.categories.bulk_increased_fee')" @change="applyBulkIncreasedFee" :suffix="`${currencySymbol(event?.event_currency)}`"></v-text-field>
                  </v-col>
                </v-row>
                <v-data-table
                  :items="categories"
                  :items-per-page="-1"
                  :headers="categoryHeadersEvents"
                  item-key="id"
                  class="elevation-1"
                  :sort-by="[{ key: 'option'}]"
                  fixed-header
                  density="compact"
                  hide-default-footer>

                  <template v-slot:item="{ item }">
                    <tr>
                      <td>
                        <v-select v-model="item.option" :items="CategoryType" solo style="min-width: 160px;" :rules="optionRules" />
                      </td>
                      <td><v-text-field v-model="item.category_name" solo :rules="nameRules" maxlength="20" counter /></td>
                      <td><v-text-field v-model="item.fee" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                      <td><v-text-field v-model="item.increased_fee" type="number" solo :suffix="`${currencySymbol(event?.event_currency)}`" /></td>
                      <td><v-text-field v-model="item.category_control_points" hint="např. 1, F2, 3, M" solo /></td>
                      <td><v-select v-model="item.category_level" :items="CategoryLevelOptions" item-title="title" item-value="value" /></td>
                      <td style="min-width: 50px;">
                        <v-tooltip location="top center" origin="auto" :text="$t('event_settings.categories.ranked_tooltip')">
                          <template v-slot:activator="{ props }">
                            <v-checkbox v-bind="props" v-model="item.enable_ranking" hide-details />
                          </template>
                        </v-tooltip>
                      </td>
                      <td style="min-width: 50px;"><v-icon color="red" small @click="markCategoryForDeletion(item)">mdi-delete</v-icon></td>
                    </tr>
                  </template>
                </v-data-table>
                <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
              </v-card-text>

              <v-card-actions>
                <v-btn color="grey" @click="dialogCategoryOpen = false">{{ $t('general.close') }}</v-btn>
                <v-spacer />
                <v-btn color="green darken-1"
                  @click="updateCategory"
                  :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                  :disabled="event.event_closed"
                  :loading="loadingUpdateCatgory">
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-window>
      </v-card-text>

        <!-- Další záložky, které jsou pro celý event -->

        <v-tabs v-model="second" bg-color="primary" fixed-tabs slider-color="#F1A829">
          <v-tab value="entries" v-if="isRace0">{{ $t('event_settings.entries.title') }}</v-tab>
          <v-tab value="acc_food" v-if="isRace0">{{ $t('event_settings.acc_food.title') }}</v-tab>
          <v-tab value="services" v-if="isRace0">{{ $t('event_settings.services.title') }}</v-tab>
          <v-tab value="startlist" v-if="!isRace0">{{ $t('event_settings.startlist.title') }}</v-tab>
          <v-tab value="results" v-if="!isRace0">{{ $t('event_settings.results.tab') }}</v-tab>
        </v-tabs>
        
      <v-card-text>


        <!-- ***************************************
 *******************************************
 ********  Správa přihlášených    **********
 *******************************************
 ****************************************-->



        <v-window v-model="second" disabled>

          <v-window-item value="entries" v-if="isRace0">


            <v-row class="align-center justify-space-between">

              <v-col cols="6" md="2" class="order-1 order-md-1" v-if="isRace0 && entries.length > 0 || searchSurname">
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ props }">
                    <v-btn color="green" text v-bind="props">
                        {{ $t('event_settings.entries.exports') }} <v-icon right>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :href="`${BaseUrl}/export/?type=xlsx&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.xlsx') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_matula&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.csv_matula') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_ardf_manager&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.csv_ardf_manager') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_ocm&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.csv_ocm') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=entry_fjww&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.csv_fjww') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=xml&name=entry_xml&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.ardf_xml') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=json&name=entry_json&event_id=${event.id}`"><v-list-item-title>{{ $t('event_settings.entries.ardf_json') }}</v-list-item-title></v-list-item>
                      <v-list-item :href="`${BaseUrl}/export/?type=csv&name=si_droid_race&race_id=${currentRaceId}`"><v-list-item-title>{{ $t('event_settings.startlist.export.si_droid') }}</v-list-item-title></v-list-item>

                    </v-list>
                  </v-menu>

              </v-col>
              <v-col cols="12" md="3" v-if="isRace0 && entries.length > 0" class="order-3 order-md-2">
                <v-tooltip location="top center" origin="auto" :text="$t('event_settings.entries.copy_emails_tooltip')">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" color="primary" @click="saveEmailsToClipboard">{{ $t('event_settings.entries.copy_emails') }}</v-btn>
                  </template>
                </v-tooltip>
              </v-col>

              <!--   Příhlásit nového závodníka    -->
              <v-col cols="6" md="2" class="order-2 order-md-3 text-right">
                <v-btn color="green" @click="dialogCreateEntryForm = true" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                  :disabled="event.event_closed">{{ $t('event_settings.entries.add_entry') }}</v-btn>
              </v-col>

              <v-dialog v-model="dialogCreateEntryForm" max-width="1200px" :persistent="false">
                <v-card>
                  <v-row>
                    <v-card-title class="ma-4">{{ $t('event_settings.entries.create_dialog_title') }}</v-card-title>
                      <!-- Přepínač pro výběr mezi zobrazeními -->
                    <v-col cols="12" md="8">
                      <v-btn-toggle
                        v-model="entryCreateSource"
                        mandatory
                        density="comfortable"
                        color="primary"
                        divided
                      >
                        <v-btn value="database">{{ $t('event_settings.entries.switch_source_option_database') }}</v-btn>
                        <v-btn value="unregistered">{{ $t('event_settings.entries.switch_source_option_unregistered') }}</v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-form ref="entryForm">
                      <div v-if="registeredUsersForm">
                        <v-row>
                          <!-- Vyhledání v databázi a vyplění polí -->
                          <v-col cols="12" md="4">
                            <v-autocomplete
                            v-model="selectedEntryId"
                            :items="filteredEntries"
                            :item-title="getFullName"
                            item-value="id"
                            :label="$t('event_settings.entries.search_by_last_name')"
                            :loading="isLoading"
                            no-data-text="event_settings.entries.no_data_in_db"
                            clearable
                            @update:search="onlast_nameChange"
                            @change="onEntrySelected"
                            class="ma-1"
                            hide-details
                            ></v-autocomplete>
                          </v-col>

                          <v-col cols="12" md="3">
                            <!-- Kategorie pro hlavní soutěž -->
                            <v-select
                              v-model="newEntry.main_category_id"
                              :items="mainCategories"
                              item-title="category_name"
                              item-value="id"
                              :label="$t('event_settings.entries.main_category')"
                              :error-messages="errors.main_category_id"
                            ></v-select>
                          </v-col>
                          
                          <!-- Poznámka -->
                          <v-col cols="12" md="3">
                            <v-text-field
                              :label="$t('event_settings.entries.note')"
                              v-model="newEntry.note"
                              counter
                              maxlength="80"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="2" v-if="si_rent.length > 0 && si_rent[0].price !== null">
                            <v-checkbox
                            v-model="selectedServices.si_rent"
                            :label="$t('event_settings.entries.si_rent')"
                            hide-details
                            density="compact"
                            />
                          </v-col>
                    
                        </v-row>
                      </div>

                      <div v-else>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-text-field :label="$t('event_settings.entries.last_name')" v-model="newEntry.last_name" :error-messages="errors.last_name"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field :label="$t('event_settings.entries.first_name')" v-model="newEntry.first_name" :error-messages="errors.first_name"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field :label="$t('event_settings.entries.si_number')" v-model="newEntry.si_number" type="number" hide-details></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="3">
                            <v-text-field :label="$t('event_settings.entries.birth_year')" v-model="newEntry.birth_year" type="number" hide-details></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select :label="$t('event_settings.entries.gender')" v-model="newEntry.competitor_gender" :items="gender" hide-details></v-select>
                          </v-col>
                          <v-col cols="12" md="2">
                            <CountrySelect v-model="newEntry.country" :label="$t('event_settings.entries.country')" />
                          </v-col>

                          <v-col cols="12" md="4">
                            <!-- Kategorie pro hlavní soutěž -->
                            <v-select
                              v-model="newEntry.main_category_id"
                              :items="mainCategories"
                              item-title="category_name"
                              item-value="id"
                              :label="$t('event_settings.entries.main_category')"
                              :error-messages="errors.main_category_id"
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row>
                        <!--
                          <v-col cols="12" md="3">
                            <v-select
                            :label="$t('event_settings.entries.termin_prihl')"
                            v-model="newEntry.termin_prihl"
                            :items="terminPrihlOptions"
                            item-title="text"
                            item-value="value"
                            ></v-select>
                          </v-col>
                        -->

                          <v-col cols="12" md="4">
                            <v-text-field :label="$t('event_settings.entries.email')" v-model="newEntry.email" :error-messages="errors.email"></v-text-field>
                          </v-col>

                          <!-- Poznámka -->
                          <v-col cols="12" md="5">
                            <v-text-field
                              :label="$t('event_settings.entries.note')"
                              v-model="newEntry.note"
                              counter
                              maxlength="80"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3" v-if="si_rent.length > 0 && si_rent[0].price !== null">
                            <v-checkbox
                              v-model="selectedServices.si_rent"
                              :label="$t('event_settings.entries.si_rent')"
                              hide-details
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <!-- Kategorie pro jednotlivé etapy (races) -->
                      <v-row justify="center">
                        <v-col v-for="(race) in races" :key="race.id" cols="12" md="3" class="bg-entry-surface">
                          <v-card class="pa-2">
                            <v-card-title>{{ race.race_name }}</v-card-title>
                            <v-select
                              v-model="newEntry.race_categories[race.id]"
                              :items="race.categories"
                              item-title="category_name"
                              item-value="id"
                              :label="`${$t('event_settings.entries.race_category_label')} ${race.race_name}`"
                              clearable
                            ></v-select>
                            <v-select v-if="event.allow_start_choice" density="comfortable" :items="startGroups" item-title="text" item-value="value" v-model="newEntry.start_preference[race.id]" :label="$t('event_settings.entries.start_group')" ></v-select>
                          </v-card>
                        </v-col>
                      </v-row>


                          <!-- Sekce pro výběr ubytování podle dnů -->
                      <h3 v-if="availableAccommodations && Object.keys(availableAccommodations).length > 0" class="py-2 my-1 mt-5 bg-entry-surface">{{ $t('event_settings.entries.accommodation_title') }}</h3>

                      <div v-for="variant in accommodationVariants" :key="variant.variant">
                        <span :style="{ color: variant.limit && variant.count >= variant.limit ? 'red' : 'inherit' }">
                          {{ $t('event_settings.entries.accommodation_variant', { variant: variant.variant, count: variant.count }) }} <span v-if="variant.limit">{{ $t('event_settings.entries.accommodation_variant_limit', { limit: variant.limit }) }}</span>
                        </span>
                      </div>


                      <!-- Zobrazení ubytování podle dat -->
                      <v-row>
                        <v-col v-for="(accommodations, date) in availableAccommodations" :key="date" cols="12" md="3">
                          <h4>{{ accommodationDayRangeLabel(date) }}</h4>
                          <v-select
                            v-if="accommodations.length > 1"
                            v-model="selectedServices.accommodations[date]"
                            :items="accommodations"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.accommodation_select')"
                            clearable
                            hide-details
                          ></v-select>
                          <div v-else v-for="accommodation in accommodations" :key="accommodation.id">
                            <v-checkbox
                              v-model="selectedServices.accommodations[date]"
                              :value="accommodation.id"
                              :label="`${accommodation.name} - ${accommodation.price} ${currencySymbol(event?.event_currency)}`"
                              hide-details
                            ></v-checkbox>
                          </div>
                        </v-col>
                      </v-row>

                      <!-- Zobrazení stravy -->
                      <h3 v-if="Object.keys(availableFood).length > 0" class="py-2 my-1 bg-entry-surface">{{ $t('event_settings.entries.food_title') }}</h3>
                      <v-row>
                      <v-col v-for="(meals, date) in availableFood" :key="date">
                        <h4>{{ $formatDate(date) }}</h4>

                        <!-- Snídaně -->
                        <span v-if="meals.breakfasts && meals.breakfasts.length">{{ $t('event_settings.entries.breakfast') }}</span>
                        <div v-if="meals.breakfasts && meals.breakfasts.length > 1">
                          <v-select
                            v-model="selectedServices.breakfasts[date]"
                            :items="meals.breakfasts"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.select_breakfast')"
                            @change="onFoodChange(date, 'breakfast', selectedServices.breakfasts[date])"
                            clearable
                            hide-details
                          ></v-select>
                        </div>
                        <div v-else-if="meals.breakfasts && meals.breakfasts.length === 1">
                          <v-checkbox
                            v-for="meal in meals.breakfasts"
                            :key="meal.id"
                            v-model="selectedServices.breakfasts[date]"
                            :value="meal.id"
                            :label="`${meal.name} - ${meal.price} ${currencySymbol(event?.event_currency)}`"
                            @change="onFoodChange(date, 'breakfast', selectedServices.breakfasts[date])"
                            hide-details
                          />
                        </div>

                        <!-- Obědy -->
                        <span v-if="meals.lunches && meals.lunches.length">{{ $t('event_settings.entries.lunch') }}</span>
                        <div v-if="meals.lunches && meals.lunches.length > 1">
                          <v-select
                            v-model="selectedServices.lunches[date]"
                            :items="meals.lunches"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.select_lunch')"
                            @change="onFoodChange(date, 'lunch', selectedServices.lunches[date])"
                            clearable
                            hide-details
                          ></v-select>
                        </div>
                        <div v-else-if="meals.lunches && meals.lunches.length === 1">
                          <v-checkbox
                            v-for="meal in meals.lunches"
                            :key="meal.id"
                            v-model="selectedServices.lunches[date]"
                            :value="meal.id"
                            :label="`${meal.name} - ${meal.price} ${currencySymbol(event?.event_currency)}`"
                            @change="onFoodChange(date, 'lunch', selectedServices.lunches[date])"
                            hide-details
                          />
                        </div>

                        <!-- Večeře -->
                        <span v-if="meals.dinners && meals.dinners.length">{{ $t('event_settings.entries.dinner') }}</span>
                        <div v-if="meals.dinners && meals.dinners.length > 1">
                          <v-select
                            v-model="selectedServices.dinners[date]"
                            :items="meals.dinners"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.select_dinner')"
                            clearable
                            @change="onFoodChange(date, 'dinner', selectedServices.dinners[date])"
                            hide-details
                          ></v-select>
                        </div>
                        <div v-else-if="meals.dinners && meals.dinners.length === 1">
                          <v-checkbox
                            v-for="meal in meals.dinners"
                            :key="meal.id"
                            v-model="selectedServices.dinners[date]"
                            :value="meal.id"
                            :label="`${meal.name} - ${meal.price} ${currencySymbol(event?.event_currency)}`"
                            @change="onFoodChange(date, 'dinner', selectedServices.dinners[date])"
                            hide-details
                          />
                        </div>
                      </v-col>
                    </v-row>
                    
                    <!-- SLUŽBY -->
                    <h3 v-if="Object.keys(groupedOtherServices).length" class="py-2 bg-entry-surface">
                      {{ $t('event_settings.entries.other_services') }}
                    </h3>
                    <v-row class="mb-4">
                        <v-col
                          v-for="(variants, key, groupIndex) in groupedOtherServices"
                          :key="key"
                          cols="12"
                          md="4"
                        >
                          <h4>{{ $t('event_settings.entries.service') }} #{{ groupIndex + 1 }}</h4>

                          <v-select
                            v-if="variants.length > 1"
                            :items="variants"
                            item-title="name"
                            item-value="id"
                            v-model="selectedServices.other[key]"
                            :label="$t('event_settings.entries.select_variant')"
                            clearable
                            hide-details
                          ></v-select>

                          <v-checkbox
                            v-else
                            v-model="selectedServices.other[key]"
                            :true-value="variants[0].id"
                            :false-value="null"
                            :label="variants[0].name"
                            hide-details
                          ></v-checkbox>

                          <div v-if="variants.length" class="text-body-2">
                            {{ (variants.find(v => v.id === selectedServices.other[key]) || variants[0]).description }}
                          </div>
                        </v-col>
                      </v-row>

                    </v-form>
                    <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="grey" text @click="dialogCreateEntryForm = false">{{ $t('general.cancel') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" :loading="isFormLoading" text @click="submitEntry">{{ $t('event_settings.entries.submit') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!--   Konec příhlásit nového závodníka    -->

              <v-col cols="12" md="3" class="text-right order-4 order-md-4" v-if="isRace0 && entries.length > 0 || searchSurname">
                <v-text-field
                  v-model="searchSurname"
                  :label="$t('event_settings.entries.search_by_last_name')"
                  @input="fetchEntries"
                  @click:clear="resetSearch"
                  solo
                  clearable
                  hide-details
                  density="comfortable"
                  style="max-width: 300px; margin-left: auto;"
                ></v-text-field>
              </v-col>
            </v-row>


              <v-data-table
                :headers="entryHeaders"
                :items="entries"
                item-key="id"
                class="elevation-1"
                density="comfortable"
                :items-per-page="100"
                :sort-by="sortByEntries"
                @touchstart.stop
                @touchmove.stop
                :loading="isLoadingEntries"
                loading-text="general.loading"
                hover
                v-if="isRace0 && entries.length > 0 || searchSurname"
              >
                <template v-slot:[`item.last_name`]="{ item }">
                  <div class="d-flex align-center">
                  {{ item.last_name }}
                  <v-tooltip location="top center" origin="auto" :text="$t('event_settings.entries.unverified_hint')">
                    <template v-slot:activator="{ props }">
                      <v-icon v-bind="props" v-if="!item.auth_user" color="red darken-1" class="ml-1">mdi-alert-circle</v-icon>
                    </template>
                  </v-tooltip>
                  </div>
                </template>
                <template v-slot:[`item.first_name`]="{ item }">
                  {{ item.first_name }}
                </template>
                <template v-slot:[`item.competitor_index`]="{ item }">
                  {{ item.competitor_index }}
                </template>
                <template v-slot:[`item.si_number`]="{ item }">
                  {{ item.si_number }}
                </template>
                <template v-slot:[`item.category_name`]="{ item }">
                  {{ item.category_name }}
                </template>
                <template v-slot:[`item.termin_prihl`]="{ item }">
                  {{ item.termin_prihl }}
                </template>
                <template v-slot:[`item.note`]="{ item }">
                  {{ item.note }}
                </template>
                <template v-slot:[`item.timestamp`]="{ item }">
                  {{ $formatDateTime(item.timestamp) }}
                </template>


                <template v-slot:[`item.actions`]="{ item }">

                    <v-list-item-action>
                    <v-icon @click="openEditDialog(item)" color="blue" size="x-large" class="mr-2" :disabled="event.event_closed">mdi-pencil</v-icon>
                    <v-icon @click="openDeleteDialog(item)" color="red" size="x-large" :disabled="event.event_closed">mdi-delete</v-icon>
                  </v-list-item-action>
                </template>
              </v-data-table>



            <!-- Dialog pro editaci Entry -->
            <v-dialog v-model="dialogEditEntry" persistent max-width="1200px">
              <v-card>
                <v-card-text>
                  <v-row>

                    <h3 class="my-2">
                      {{ selectedEntry?.last_name }} {{ selectedEntry?.first_name }} ({{ selectedEntry?.competitor_index }})
                    </h3>

                    <v-col cols="12" md="4">
                      <v-autocomplete
                        v-model="selectedRoleId"
                        :items="roleOptions"
                        item-title="label"
                        item-value="value"
                        :loading="rolesLoading"
                        :label="$t('event_settings.entries.assign_account_role')"
                        hide-details
                        clearable
                        density="compact"
                        variant="outlined"
                      />
                      </v-col>
                  </v-row>

                  
                  <v-row>
                    <!-- Checkbox pro půjčení čipu (si_rent) -->
                    <v-col cols="5" md="2" v-if="si_rent.length > 0 && si_rent[0].price !== null">
                      <v-checkbox
                        v-model="siRentChecked"
                        :label="$t('event_settings.entries.si_rent')"
                        hide-details
                        density="compact"
                      ></v-checkbox>
                    </v-col>
                    <!-- Výběr termínu příhlášky -->
                    <v-col cols="7" md="3">
                      <v-select
                        v-model="selectedEntry.termin_prihl"
                        :items="terminPrihlOptions"
                        :label="$t('event_settings.entries.deadline')"
                        hide-details
                        variant="outlined"
                        density="compact"
                      ></v-select>
                    </v-col>
                    <!-- Poznámka k přihlášce -->
                    <v-col cols="12" md="7">
                      <v-text-field
                        v-model="selectedEntry.note"
                        :label="$t('event_settings.entries.note')"
                        maxlength="80"
                        counter
                        variant="outlined"
                        density="compact"
                        class="mb-1"
                      />
                    </v-col>
                  </v-row>
    
                  <div class="mb-3" v-for="(race, index) in allRaces" :key="race.id" :class="{ 'first-row': index === 0 }">
                     <v-row>
                      <v-col cols="12" md="6">
                        <v-select
                          v-model="getEntryRaceData(selectedEntry, race.id).category_id"
                          :items="race.categories"
                          item-title="category_name"
                          item-value="id"
                          :label="index === 0 ? `${$t('event_settings.entries.main_category_for')} ${race.race_name}` : `${$t('event_settings.entries.race_category_for')} ${race.race_name}`"
                          :clearable="index !== 0"
                          hide-details="true"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="getEntryRaceData(selectedEntry, race.id).si_number"
                          :label="index === 0 ? `${$t('event_settings.entries.main_si_for')} ${race.race_name}` : `${$t('event_settings.entries.race_si_for')} ${race.race_name}`"
                          type="number"
                          hide-details="true"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Sekce pro výběr ubytování podle dnů -->
                  <h3 v-if="availableAccommodations && Object.keys(availableAccommodations).length > 0" class="py-2 my-1 bg-entry-surface">{{ $t('event_settings.entries.accommodation_title') }}</h3>

                  <div v-for="variant in accommodationVariants" :key="variant.variant">
                    <span :style="{ color: variant.limit && variant.count >= variant.limit ? 'red' : 'inherit' }">
                      {{ $t('event_settings.entries.accommodation_variant', { variant: variant.variant, count: variant.count }) }} <span v-if="variant.limit">{{ $t('event_settings.entries.accommodation_variant_limit', { limit: variant.limit }) }}</span>
                    </span>
                  </div>




                  <v-row>
                    <!-- Pro každé datum zobrazíme vlastní sloupec -->
                    <v-col
                      v-for="(date, index) in Object.keys(availableAccommodations)"
                      :key="index"
                      cols="12"
                      md="3"
                    >
                      <h4>{{ accommodationDayRangeLabel(date) }}</h4>
                      <div v-if="availableAccommodations[date].length === 1">
                        <v-checkbox
                          v-model="selectedEntry.accommodation[date]"
                          :label="availableAccommodations[date][0].name"
                          :value="availableAccommodations[date][0].id"
                        ></v-checkbox>
                      </div>
                      <div v-else>
                        <v-select
                          v-model="selectedEntry.accommodation[date]"
                          :items="availableAccommodations[date]"
                          item-title="name"
                          item-value="id"
                          :label="$t('event_settings.entries.accommodation_select')"
                          clearable
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>



                  <!-- Sekce pro výběr stravy podle dnů -->
                  <h3 v-if="Object.keys(availableFood).length > 0" class="py-2 my-1 bg-entry-surface">{{ $t('event_settings.entries.food_title') }}:</h3>
                  <v-row>
                    <v-col
                      v-for="(date, index) in Object.keys(availableFood)"
                      :key="index"
                      cols="12"
                      md="3"
                    >
                      <h4>{{ $formatDate(date) }}</h4>

                      <!-- Snídaně -->
                      <template v-if="availableFood[date].breakfasts.length">
                        <span>{{ $t('event_settings.entries.breakfast') }}</span>
                        <div v-if="availableFood[date].breakfasts.length === 1">
                          <v-checkbox
                            v-for="(item, idx) in availableFood[date].breakfasts"
                            :key="`breakfast-${idx}`"
                            v-model="selectedEntry.food[date].breakfasts"
                            :label="item.name"
                            :value="item.id"
                            hide-details
                          ></v-checkbox>
                        </div>
                        <div v-else>
                          <v-select
                            v-model="selectedEntry.food[date].breakfasts"
                            :items="availableFood[date].breakfasts"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.select_breakfast')"
                            clearable
                            hide-details
                          ></v-select>
                        </div>
                      </template>

                      <!-- Obědy -->
                      <template v-if="availableFood[date].lunches.length">
                        <span>{{ $t('event_settings.entries.lunch') }}</span>
                        <div v-if="availableFood[date].lunches.length === 1">
                          <v-checkbox
                            v-for="(item, idx) in availableFood[date].lunches"
                            :key="`lunch-${idx}`"
                            v-model="selectedEntry.food[date].lunches"
                            :label="item.name"
                            :value="item.id"
                            hide-details
                          ></v-checkbox>
                        </div>
                        <div v-else>
                          <v-select
                            v-model="selectedEntry.food[date].lunches"
                            :items="availableFood[date].lunches"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.select_lunch')"
                            clearable
                            hide-details
                          ></v-select>
                        </div>
                      </template>

                      <!-- Večeře -->
                      <template v-if="availableFood[date].dinners.length">
                        <span>{{ $t('event_settings.entries.dinner') }}</span>
                        <div v-if="availableFood[date].dinners.length === 1">
                          <v-checkbox
                            v-for="(item, idx) in availableFood[date].dinners"
                            :key="`dinner-${idx}`"
                            v-model="selectedEntry.food[date].dinners"
                            :label="item.name"
                            :value="item.id"
                            hide-details
                          ></v-checkbox>
                        </div>
                        <div v-else>
                          <v-select
                            v-model="selectedEntry.food[date].dinners"
                            :items="availableFood[date].dinners"
                            item-title="name"
                            item-value="id"
                            :label="$t('event_settings.entries.select_dinner')"
                            clearable
                            hide-details
                          ></v-select>
                        </div>
                      </template>
                    </v-col>
                  </v-row>

                  <h2 v-if="Object.keys(groupedOtherServices).length">{{ $t('event_settings.entries.other_services') }}</h2>
                  <v-row v-if="Object.keys(groupedOtherServices).length">
                    <v-col
                      v-for="(variants, key, idx) in groupedOtherServices"
                      :key="key"
                      cols="12" md="4"
                      class="mb-4"
                    >
                      <h4>{{ $t('event_settings.entries.service') }} {{ idx+1 }}</h4>

                      <v-select
                        v-if="variants.length>1"
                        v-model="selectedOther[key]"
                        :items="variants"
                        item-title="name"
                        item-value="id"
                        :label="$t('event_settings.entries.select_variant')"
                        clearable
                        hide-details="true"
                      />

                      <v-checkbox
                        v-else
                        v-model="selectedOther[key]"
                        :true-value="variants[0].id"
                        :false-value="null"
                        :label="variants[0].name"
                        hide-details="true"
                      />

                      <div class="text-body-2">
                        {{ (variants.find(v=>v.id===selectedOther[key]) || variants[0]).description }}
                      </div>
                    </v-col>
                  </v-row>


                  <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey" text @click="dialogEditEntry = false">{{ $t('general.cancel') }}</v-btn>
                  <v-btn color="green darken-1" :loading="isFormLoading" text @click="editEntry">{{ $t('general.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>



            <!-- Dialog pro potvrzení smazání Entry -->
            <v-dialog v-model="dialogDeleteEntry" persistent max-width="600px">
              <v-card>
                <v-card-title class="text-h5">{{ $t('event_settings.entries.delete_title') }}</v-card-title>
                <v-card-text>
                  <i18n-t keypath="event_settings.entries.delete_text">
                    <strong>{{ selectedEntry?.last_name }} {{ selectedEntry?.first_name }}</strong>
                  </i18n-t>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialogDeleteEntry = false">{{ $t('general.cancel') }}</v-btn>
                  <v-btn color="red darken-1" text @click="deleteEntry">{{ $t('general.delete') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


          </v-window-item>


<!-- ***************************************
 *******************************************
 ********    UBYTOVÁÍ + STRAVA    **********
 *******************************************
 ****************************************-->


          <v-window-item value="acc_food" v-if="isRace0">

            <v-form ref="entryForm">
              <v-row>
                <v-col v-for="(acc, index) in accommodations" :key="index" cols="12" md="3" class="pb-0">
                  <v-row justify="space-between">
                    <v-col cols="auto" class="mb-3">
                      <span>{{ $t('event_settings.acc_food.accommodation_title') }} {{ acc.variant }}</span>
                    </v-col>
                    <v-col cols="auto">
                      <v-icon v-if="acc.name" color="red" title="resetovat formulář a vymazat jeho data" size="x-large" @click="showAccomodationDialog(index)" :disabled="event.event_closed">mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                  <v-text-field v-model="acc.name" :label="$t('event_settings.acc_food.acc_name')" maxlength="40" counter :error-messages="fieldErrors[`acc${index}`]" variant="outlined" density="compact"></v-text-field>
                  <v-text-field v-model="acc.price" :label="$t('event_settings.acc_food.acc_price')" type="number" :error-messages="fieldErrors[`acc${index}`]" variant="outlined" density="compact"></v-text-field>
                  <v-text-field
                    v-model.number="acc.limit"
                    @update:modelValue="val => acc.limit = (val === '' ? null : Number(val))"
                    :label="$t('event_settings.acc_food.acc_limit')"
                    type="number"
                    variant="outlined"
                    density="compact"
                  />
                  <v-text-field v-model="acc.date_from" :disabled="acc.loadedFromAPI" :label="$t('event_settings.acc_food.acc_date_from')" type="date" :error-messages="fieldErrors[`acc${index}`]" variant="outlined" density="compact"></v-text-field>
                  <v-text-field :model-value="shiftIso(acc.date_to, 1)" @update:modelValue="v => acc.date_to = shiftIso(v, -1)" :disabled="acc.loadedFromAPI" :label="$t('event_settings.acc_food.acc_date_to')" type="date" :error-messages="fieldErrors[`acc${index}`]" variant="outlined" density="compact"></v-text-field>
                  <!-- <v-switch v-model="acc.only_all_days" color="primary" label="Přihlášení pouze na všechny dny" density="compact"</v-switch> -->

                  <!-- Dialog pro potvrzení smazání ubytování -->
                  <v-dialog v-model="dialogAccomodations[index]" persistent max-width="600px">
                    <v-card>
                      <v-card-title class="text-h5">{{ $t('event_settings.acc_food.delete_title') }}</v-card-title>
                      <v-card-text>
                        <i18n-t keypath="event_settings.acc_food.delete_text">
                          <strong>{{ acc.name }}</strong>
                        </i18n-t>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogAccomodations[index] = false">Zrušit</v-btn>
                        <v-btn color="red darken-1" text @click="submitEntryService(acc.variant); dialogAccomodations[index] = false;">{{ $t('event_settings.acc_food.delete_confirm') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-col>
              </v-row>

              <!-- Jídla -->
               <v-row class="justify-space-between">
                <v-col cols="12" md="3" order="2" order-md="1" class="d-flex justify-start">
                  <v-btn color="primary" @click="addNewDay" class="w-100 w-md-auto">
                    <v-icon color="green" size="35" @click="addNewDay">mdi-plus</v-icon> {{ $t('event_settings.acc_food.add_food_days') }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="3" order="1" order-md="2" class="d-flex justify-end">
                  <v-btn color="success" class="w-100 w-md-auto" @click="submitEntryService" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('event_settings.acc_food.save_all') }}</v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="4"
                  v-for="(day, index) in days"
                  :key="index"
                  class="food-day-card rounded pa-3"
                  :class="index % 2 === 0 ? 'bg-surface' : 'bg-entry-surface'"
                >
                  <v-text-field v-model="day.date" :error-messages="fieldErrors['date' + day.date]" :label="$t('event_settings.acc_food.day_date')" clearable type="date"></v-text-field>
                  <v-row>
                    <!-- Header for Breakfast -->
                    <v-col cols="12" md="4">
                      <div class="text-center mb-3">{{ $t('event_settings.acc_food.breakfast') }}</div>
                      <div v-for="meal in day.breakfasts" :key="meal.variant">
                        <v-text-field v-model="meal.name" :label="`${$t('event_settings.acc_food.meal_name_variant')} ${meal.variant})`" :error-messages="fieldErrors['sn' + meal.variant]" clearable maxlength="40" counter variant="outlined" density="compact"></v-text-field>
                        <v-text-field v-model="meal.price" :label="$t('event_settings.acc_food.meal_price')" type="number" :error-messages="fieldErrors['sn' + meal.variant]" clearable variant="outlined" density="compact"></v-text-field>
                      </div>
                    </v-col>
                    <!-- Header for Lunch -->
                    <v-col cols="12" md="4">
                      <div class="text-center mb-3">{{ $t('event_settings.acc_food.lunch') }}</div>
                      <div v-for="meal in day.lunches" :key="meal.variant">
                        <v-text-field v-model="meal.name" :label="`${$t('event_settings.acc_food.meal_name_variant')} ${meal.variant})`" :error-messages="fieldErrors['ob' + meal.variant]" clearable maxlength="40" counter variant="outlined" density="compact"></v-text-field>
                        <v-text-field v-model="meal.price" :label="$t('event_settings.acc_food.meal_price')" type="number" :error-messages="fieldErrors['ob' + meal.variant]" clearable variant="outlined" density="compact"></v-text-field>
                      </div>
                    </v-col>
                    <!-- Header for Dinner -->
                    <v-col cols="12" md="4">
                      <div class="text-center mb-3">{{ $t('event_settings.acc_food.dinner') }}</div>
                      <div v-for="meal in day.dinners" :key="meal.variant">
                        <v-text-field v-model="meal.name" :label="`${$t('event_settings.acc_food.meal_name_variant')} ${meal.variant})`" :error-messages="fieldErrors['ve' + meal.variant]" clearable maxlength="40" counter variant="outlined" density="compact"></v-text-field>
                        <v-text-field v-model="meal.price" :label="$t('event_settings.acc_food.meal_price')" type="number" :error-messages="fieldErrors['ve' + meal.variant]" clearable variant="outlined" density="compact"></v-text-field>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>

          </v-window-item>




    <!-- ***************************************
 *******************************************
 ********         SLUŽBY          **********
 *******************************************
 ****************************************-->


 <v-window-item value="services" v-if="isRace0">


  <EventSettingsOtherServices
      :siRent="si_rent" 
      :otherService="other_service"
      :event-closed="event.event_closed" 
      :event-currency="event.event_currency"
      @refresh="fetchRaceServiceData"
    />

 </v-window-item>






<!-- ***************************************
 *******************************************
 ********       STARTOVKA         **********
 *******************************************
 ****************************************-->




          <v-window-item v-if="races.length === 0 || !isRace0" value="startlist">

            <v-row class="justify-space-between">
                <v-col cols="12" md="3" class="d-flex justify-center">
                  <v-btn @click="openStartlistStepperDialog" color="success" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('event_settings.startlist.upload') }}</v-btn>
                </v-col>

                <v-col cols="12" md="2" v-if="startlist.length > 0" class="d-flex justify-center">
                <v-menu offset-y transition="slide-y-transition">
                  <template v-slot:activator="{ props }">
                  <v-btn color="green" text v-bind="props">
                      {{ $t('event_settings.startlist.exports') }}<v-icon end>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="exportStartlistTxt">
                      <v-list-item-title>{{ $t('event.startlist_view.txt') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=pdf&name=startlist_starter&race_id=${currentRaceId}`" ><v-list-item-title>{{ $t('event_settings.startlist.export.starter') }}</v-list-item-title></v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=pdf&name=startlist_clubs&race_id=${currentRaceId}`"><v-list-item-title>{{ $t('event_settings.startlist.export.clubs') }}</v-list-item-title></v-list-item>
                    <v-list-item :href="`${apiBaseUrl}/?type=json&name=race&race_id=${currentRaceId}&dl=1`" :download="`race_${currentRaceId}.json`">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.json_ardf') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=csv&name=startlist&race_id=${currentRaceId}`"><v-list-item-title>{{ $t('event_settings.startlist.export.csv') }}</v-list-item-title></v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=xml&name=startlist&race_id=${currentRaceId}`"><v-list-item-title>{{ $t('event_settings.startlist.export.xml') }}</v-list-item-title></v-list-item>
                    <v-list-item @click="exportGpsCsos">
                      <v-list-item-title>{{ $t('event_settings.startlist.export.gps_csos') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=xml&name=startlist&race_id=${currentRaceId}`"><v-list-item-title>{{ $t('event_settings.startlist.export.o_checklist') }}</v-list-item-title></v-list-item>

                  </v-list>
                </v-menu>
                </v-col>

                <v-col cols="12" md="3" v-if="startlist.length > 0" class="d-flex justify-center">
                  <v-btn color="error" @click="openDeleteAllStartTimesDialog" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('event_settings.startlist.delete_all') }}</v-btn>
                </v-col>
              </v-row>


              <!-- Dialog pro potvrzení smazání všech start_time -->
              <v-dialog v-model="dialogDeleteAllStartTimes" persistent max-width="400px">
                <v-card>
                  <v-card-title class="text-h5">{{ $t('event_settings.startlist.delete_title') }}</v-card-title>
                  <v-card-text>
                    {{ $t('event_settings.startlist.delete_text') }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDeleteAllStartTimes = false">{{ $t('general.cancel') }}</v-btn>
                    <v-btn color="red darken-1" text @click="deleteAllStartTimes">{{ $t('general.delete') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


              <div id="startlistContent">
                <v-data-table
                  v-if="isLoadingStartlist || startlist.length > 0"
                  :items="startlist"
                  :headers="GetStartlistHeaders" 
                  item-key="index" 
                  :items-per-page="100" 
                  :sort-by="StartlistSortBy"
                  @touchstart.stop 
                  @touchmove.stop
                  :loading="isLoadingStartlist"
                  loading-text="general.loading"
                  striped="even"
                  hover
                >

                <template v-slot:[`item.first_name`]="{ item }">
                  {{ item.first_name }}
                </template>

                <template v-slot:[`item.last_name`]="{ item }">
                  {{ item.last_name }}
                </template>

                <template v-slot:[`item.competitor_start_time`]="{ item }">
                  {{ $formatTimeSec(item.competitor_start_time) || 'N/A' }}
                </template>

                <template v-slot:[`item.competitor_category`]="{ item }">
                  {{ item.competitor_category }}
                </template>

                <template v-slot:[`item.competitor_index`]="{ item }">
                  {{ item.competitor_index }}
                </template>

                <template v-slot:[`item.si_number`]="{ item }">
                  {{ item.si_number }}
                </template>

                <template v-slot:[`item.club_name`]="{ item }">
                  {{ item.club_name }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">

                  <v-list-item-action>
                  <!--<v-icon @click="openEditStartlistDialog(item)" color="blue" size="x-large" class="mr-2">mdi-pencil</v-icon>-->
                  <v-icon @click="openDeleteGetStartDialog(item)" color="red" size="x-large" title="smazat start" :disabled="event.event_closed">mdi-delete</v-icon>
                </v-list-item-action>
              </template>

                </v-data-table>
              </div>

              <!-- Dialog pro potvrzení smazání Start -->
              <v-dialog v-model="dialogDeleteStart" persistent max-width="400px">
                <v-card>
                  <v-card-title class="text-h5">{{ $t('event_settings.startlist.delete_title') }}</v-card-title>
                  <v-card-text>
                    {{ $t('event_settings.startlist.delete_text_start') }} <b>{{ selectedStart.last_name }} {{ selectedStart.first_name }}</b>?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDeleteStart = false">{{ $t('general.cancel') }}</v-btn>
                    <v-btn color="red darken-1" text @click="deleteGetStart">{{ $t('general.delete') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


              <v-dialog v-model="dialogAddStartlist" max-width="1200px">
              <v-card>
                <v-icon
                  color="gray"
                  :title="$t('general.close')"
                  size="large"
                  @click="closeStartlistDialog"
                  class="ml-auto"
                  >mdi-close
                </v-icon>


                <v-card-text>
                  <v-stepper hide-actions v-model="stepStart" :items="startlistStepperItems">
                    <template v-slot:[`item.1`]>
                      <v-card>
                        <v-card-text class="mb-3 px-0">
                          Specifikace a formáty dat jsou dostupné v <a :href="`${BaseUrl}/napoveda#dev-startlist`" target="_blank" rel="noopener noreferrer">nápovědě</a>. Po nahrání a uložení se původní startovka v etapě vymaže a poté uloží ze souboru.
                        </v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-select 
                            :items="[
                                { title: 'CSV', value: 'csv' },
                                { title: 'FjwW JSON ', value: 'fjww' },
                              ]"
                              item-text="title" 
                              item-value="value" 
                              v-model="selectedStartlistFileType" 
                              :label="$t('event_settings.startlist.file_type')" 
                              density="compact"
                              :rules="[v => !!v || $t('event_settings.startlist.file_type_required')]"
                              :error-messages="errorStartlistSelectMessage"
                              @change="validateSelectedStartlistFileType"
                              >
                            </v-select>  
                          </v-col>  
                          <v-col cols="12" md="8">                    
                            <v-file-input
                              :label="$t('event_settings.startlist.file_input')"
                              outlined
                              dense
                              density="compact"
                              @change="handleFileUpload"
                              :error-messages="errorStartlistMessage"
                            ></v-file-input>
                          </v-col>
                        </v-row>


                        <v-btn
                          color="primary"
                          @click="uploadStartlistFile"
                          :disabled="!isFileValid"
                          :loading="loadingSubmit"
                          class="mt-4"
                        >
                          {{ $t('general.upload') }}
                        </v-btn>

                        <span v-if="successStartlistMessage" style="color:green; font-size:11px;" class="ma-2">
                          {{ successStartlistMessage }}
                        </span>

                      </v-card>
                    </template>



                    <template v-slot:[`item.2`]>

                      <v-row class="mb-1">
                        <v-col cols="2" style="background:green">{{ $t('event_settings.startlist.ok') }}</v-col>
                        <v-col cols="5" style="background:orange">{{ $t('event_settings.startlist.not_in_entries') }}</v-col>
                        <v-col cols="5" style="background:red">{{ $t('event_settings.startlist.entry_without_start') }}</v-col>

                      </v-row>
                        <v-data-table
                        :headers="startlistHeaders"
                        :items="combinedStarts"
                        item-key="index"
                        class="elevation-1"
                        density="comfortable"
                        items-per-page="-1"
                        :row-props="setRowProps"
                      >

                      <template v-slot:[`item.start_number`]="{ item }">
                          {{ item.start_number }}
                        </template>

                        <template v-slot:[`item.last_name`]="{ item }">
                          {{ item.last_name }}
                        </template>

                        <template v-slot:[`item.first_name`]="{ item }">
                          {{ item.first_name }}
                        </template>

                        <template v-slot:[`item.competitor_index`]="{ item }">
                          {{ item.competitor_index }}
                        </template>

                        <template v-slot:[`item.competitor_category`]="{ item }">
                          {{ item.competitor_category }}
                        </template>


                        <template v-slot:[`item.si_number`]="{ item }">
                          {{ item.si_number }}
                        </template>


                        <template v-slot:[`item.start_time_relative`]="{ item }">
                          {{ item.start_time_relative }}
                        </template>

                        <template v-slot:[`item.start_time_real`]="{ item }">
                          {{ item.start_time_real }}
                        </template>


                        <template v-slot:[`item.actions`]="{ item }">
                          <v-list-item-action>
                            <v-icon @click="openEditStartDialog(item)" color="blue" size="x-large" class="mr-2">mdi-pencil</v-icon>
                            <v-icon @click="openDeleteStartDialog(item)" color="red" size="x-large">mdi-delete</v-icon>
                          </v-list-item-action>
                        </template>
                        <template v-slot:bottom></template>
                      </v-data-table>

                      <!-- Zobrazení chybového hlášení -->
                      <div v-if="errorStartlistSendMessage.length" style="color:red; font-size:11px;" class="ma-2">
                          <div v-for="(error, index) in errorStartlistSendMessage" :key="index">
                            {{ error }}
                          </div>
                        </div>


                        <!-- Dialog pro editaci Start -->
                        <v-dialog v-model="dialogEditStart" persistent max-width="600px">
                          <v-card>
                            <v-card-title>
                              {{ selectedStart.last_name }} {{ selectedStart.first_name }}
                            </v-card-title>
                            <v-card-text>
                              <!-- <v-row>    Příjmení a jméno by se nemělo měnit kvůli přiřazoání
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="selectedStart.last_name"
                                  label="Příjmení"
                                  :rules="[v => !!v || 'Příjmení je povinné']"
                                  dense
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="selectedStart.first_name"
                                  label="Jméno"
                                  :rules="[v => !!v || 'Jméno je povinné']"
                                  dense
                                ></v-text-field>
                              </v-col>
                            </v-row> -->
                            <v-row>
                              <v-col cols="12" md="6">
                              <v-text-field v-model="selectedStart.competitor_index" hide-details :label="$t('event_settings.startlist.index')" />
                              </v-col>
                              <v-col cols="12" md="6">
                              <v-text-field v-model="selectedStart.competitor_category" hide-details :label="$t('event_settings.startlist.category')" />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" md="6">
                              <v-text-field v-model="selectedStart.start_number" hide-details type="number" :label="$t('event_settings.startlist.start_number')" />
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field v-model="selectedStart.si_number" hide-details type="number" :label="$t('event_settings.startlist.si_number')" dense />
                            </v-col>
                          </v-row>
                          <v-row>
                              <v-col cols="12" md="6">
                              <v-text-field v-model="selectedStart.start_time_relative" :value="selectedStart.start_time_relative" hide-details type="time" step="2" :label="$t('event_settings.startlist.start_time_relative')" />
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field v-model="selectedStart.start_time_real" :value="selectedStart.start_time_real" hide-details type="time" step="2" :label="$t('event_settings.startlist.start_time_real')" />
                            </v-col>
                          </v-row>

                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="grey" text @click="dialogEditStart = false">{{ $t('general.cancel') }}</v-btn>
                              <v-btn color="green darken-1" text @click="saveEditStart" :disabled="!selectedStart.first_name || !selectedStart.last_name">{{ $t('general.save') }}</v-btn>
                            </v-card-actions>

                          </v-card>
                        </v-dialog>

                        <!-- Dialog pro potvrzení smazání Start -->
                        <v-dialog v-model="dialogDeleteStart" persistent max-width="400px">
                          <v-card>
                            <v-card-title class="text-h5">{{ $t('event_settings.startlist.delete_title') }}</v-card-title>
                            <v-card-text>
                              {{ $t('event_settings.startlist.delete_text_start') }} <b>{{ selectedStart.last_name }} {{ selectedStart.first_name }}</b>?
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="dialogDeleteStart = false">{{ $t('general.cancel') }}</v-btn>
                              <v-btn color="red darken-1" text @click="deleteStart">{{ $t('general.delete') }}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>


                      </template>


                    <v-stepper-actions>
                      <template v-slot:next>
                        <v-btn color="primary" v-if="stepStart < totalStartSteps" @click="stepStart++">{{ $t('general.next') }}</v-btn>
                        <v-btn color="green darken-1" v-else @click="saveStartData" :disabled="false" :loading = "loadingSubmit">{{ $t('general.save') }}</v-btn>
                      </template>
                      <template v-slot:prev>
                        <v-btn variant="plain" v-if="stepStart > 1" @click="stepStart--">{{ $t('general.back') }}</v-btn>
                        <v-btn variant="plain" v-else>&nbsp;</v-btn>
                      </template>
                    </v-stepper-actions>




                  </v-stepper>
                </v-card-text>
              </v-card>
            </v-dialog>


          </v-window-item>


          <!-- ***************************************
          *******************************************
          ********        VÝSLEDKY         **********
          *******************************************
          ****************************************-->


          <v-window-item value="results" v-if="races.length === 0 || !isRace0">

            <v-row class="justify-space-between">
                <v-col cols="12" md="3" class="d-flex justify-center">
                  <v-btn @click="openResultsStepperDialog" color="success" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('event_settings.results.upload') }}</v-btn>
                </v-col>

                <v-col cols="12" md="2" v-if="results.length > 0" class="d-flex justify-center">
                <v-menu offset-y transition="slide-y-transition">
                  <template v-slot:activator="{ props }">
                    <v-btn color="green" text v-bind="props">
                      {{ $t('event_settings.results.exports') }}<v-icon end>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item :href="`${apiBaseUrl}/?type=json&name=race&race_id=${currentRaceId}&dl=1`" :download="`race_${currentRaceId}.json`" v-if="results.length > 0">
                      <v-list-item-title>{{ $t('event_settings.results.export.json_ardf') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :href="`${BaseUrl}/export/?type=xml&name=results&race_id=${currentRaceId}`" v-if="results.length > 0">
                      <v-list-item-title>{{ $t('event_settings.results.export.xml_iof_ardf') }}</v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item :href="`${BaseUrl}/export/?type=xml&name=results&race_id=${currentRaceId}`" v-if="results.length > 0">
                      <v-list-item-title>{{ $t('event_settings.results.export.xml_iof') }}</v-list-item-title>
                    </v-list-item> -->
                  </v-list>
                </v-menu>
                </v-col>

                <v-col cols="12" md="3" v-if="results.length > 0" class="d-flex justify-center">
                  <v-btn color="error" @click="openDeleteAllResultsDialog" :prepend-icon="event.event_closed ? 'mdi-lock' : undefined"
                        :disabled="event.event_closed">{{ $t('event_settings.results.delete_all') }}</v-btn>
                </v-col>
              </v-row>


              <!-- Dialog pro potvrzení smazání všech start_time -->
              <v-dialog v-model="dialogDeleteAllResults" persistent max-width="400px">
                <v-card>
                  <v-card-title class="text-h5">{{ $t('event_settings.results.title_delete') }}</v-card-title>
                  <v-card-text>
                    {{ $t('event_settings.results.text_delete') }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDeleteAllResults = false">{{ $t('general.cancel') }}</v-btn>
                    <v-btn color="red darken-1" text @click="deleteAllResults">{{ $t('general.delete') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


              <div id="resultsContent">
                <v-data-table
                  v-if="isLoadingResults || results.length > 0"
                  :items="results"
                  :headers="GetResultsHeaders" 
                  item-key="index" 
                  items-per-page="-1" 
                  :sort-by="ResultsSortBy"
                  @touchstart.stop 
                  @touchmove.stop
                  :loading="isLoadingResults"
                  loading-text="general.loading"
                  striped="even"
                  hover
                >

                <template v-slot:[`item.place`]="{ item }">
                  {{ item.place }}
                </template>

                <template v-slot:[`item.first_name`]="{ item }">
                  {{ item.first_name }}
                </template>

                <template v-slot:[`item.last_name`]="{ item }">
                  {{ item.last_name }}
                </template>

                <template v-slot:[`item.run_time`]="{ item }">
                  {{ item.run_time }}
                </template>

                <template v-slot:[`item.result_status`]="{ item }">
                  {{ item.result_status }}
                </template>

                <template v-slot:[`item.punch_count`]="{ item }">
                  {{ item.punch_count }}
                </template>


                <template v-slot:[`item.category_name`]="{ item }">
                  {{ item.category_name }}
                </template>

                <template v-slot:[`item.competitor_index`]="{ item }">
                  {{ item.competitor_index }}
                </template>

                <template v-slot:[`item.actions`]="{ item }">

                  <v-list-item-action>
                  <!--<v-icon @click="openEditStartlistDialog(item)" color="blue" size="x-large" class="mr-2">mdi-pencil</v-icon>-->
                  <v-icon @click="openDeleteGetResultDialog(item)" color="red" size="x-large" title="smazat výsledek" :disabled="event.event_closed">mdi-delete</v-icon>
                </v-list-item-action>
              </template>

                </v-data-table>
              </div>

              <!-- Dialog pro potvrzení smazání Result -->
              <v-dialog v-model="dialogDeleteResult" persistent max-width="400px">
                <v-card>
                  <v-card-title class="text-h5">{{ $t('event_settings.results.title_delete') }}</v-card-title>
                  <v-card-text>
                    {{ $t('event_settings.results.text_delete_single') }} <b>{{ selectedResult.last_name }} {{ selectedResult.first_name }}</b>?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDeleteResult = false">{{ $t('general.cancel') }}</v-btn>
                    <v-btn color="red darken-1" text @click="deleteGetResult">{{ $t('general.delete') }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialogAddResults" max-width="1200px">
              <v-card>
                <v-icon
                  color="gray"
                  :title="$t('general.close')"
                  size="large"
                  @click="closeResultsDialog"
                  class="ml-auto"
                  >mdi-close
                </v-icon>


                <v-card-text>
                  <v-stepper hide-actions v-model="stepResults" :items="resultsStepperItems">
                    <template v-slot:[`item.1`]>
                      <v-card>
                        <v-card-text class="mb-3 px-0">
                          Specifikace a formáty dat jsou dostupné v <a :href="`${BaseUrl}/napoveda#dev-results`" target="_blank" rel="noopener noreferrer">nápovědě</a>. Po nahrání a uložení se původní výsledky v etapě vymažou a poté uloží ze souboru.
                        </v-card-text>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-select 
                            :items="[
                                { title: 'CSV', value: 'csv' },
                                { title: 'OCM CSV', value: 'csv_ocm' },
                                { title: 'XML', value: 'xml' },
                                { title: 'FjwW JSON', value: 'fjww' },
                                { title: 'ARDF JSON', value: 'json' },
                                { title: 'TXT Pavel', value: 'txt_pavel' }
                              ]"
                              item-text="title" 
                              item-value="value" 
                              v-model="selectedFileType" 
                              :label="$t('event_settings.results.file_type')" 
                              density="compact"
                              :rules="[v => !!v || $t('event_settings.results.choose_type')]"
                              :error-messages="errorResultsSelectMessage"
                              @change="validateSelectedFileType"
                              >
                            </v-select>  
                          </v-col>  
                          <v-col cols="12" md="8">                    
                            <v-file-input
                              :label="$t('event_settings.results.file_input')"
                              density="compact"
                              @change="handleResultsFileUpload"
                              :error-messages="errorResultsMessage"
                            ></v-file-input>
                          </v-col>
                        </v-row>

                        <v-btn
                          color="primary"
                          @click="uploadResultsFile"
                          :disabled="!isResultsFileValid"
                          class="mt-4"
                          :loading = "loadingSubmit"
                        >
                          {{ $t('general.upload') }}
                        </v-btn>
                        
                        <span v-if="successResultsMessage" style="color:green; font-size:11px;" class="ma-2">
                          {{ successResultsMessage }}
                        </span>

                      </v-card>
                    </template>

                    <template v-slot:[`item.2`]>

                      <v-row v-for="(category, index) in categoryProperties" :key="index" class="my-2 mr-1">
                        <!-- Název kategorie -->
                        <v-col cols="12" md="2" class="d-flex justify-end align-right text-h6 py-2">
                          {{category.category_name}}
                        </v-col>
                        <!-- Editovatelné kontroly -->
                        <v-col cols="12" md="10" class="pa-2">
                          <v-text-field
                            v-model="category.category_control_points"
                            :label="$t('event_settings.results.label_controls')"
                            variant="outlined"
                            :placeholder="$t('event_settings.results.placeholder_controls')"
                            hide-details
                            density="compact"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                    </template>



                    <template v-slot:[`item.3`]>

                      <v-row class="mb-1">
                        <v-col cols="4" style="background:green">{{ $t('event_settings.results.paired') }}</v-col>
                        <v-col cols="4" style="background:orange">{{ $t('event_settings.results.will_create') }}</v-col>
                        <v-col cols="4" style="background:red">{{ $t('event_settings.results.missing_result') }}</v-col>
                      </v-row>
                      <v-col cols="12">
                        <i18n-t keypath="event_settings.results.sent_total">
                          <strong>{{ resultsEntryOk.length + resultsEntryCreate.length }}</strong>
                          <strong>{{ resultsEntryOk.length + resultsEntryCreate.length + resultsEntryEmpty.length }}</strong>
                        </i18n-t>
                      </v-col>

                      <v-data-table
                        :headers="resultsHeaders"
                        :items="sortedCombinedResults"
                        item-key="index"
                        class="elevation-1"
                        density="comfortable"
                        items-per-page="-1"
                        :row-props="setResultsRowProps"
                        :sort-by="ResultsSortBy"
                      >

                        <template v-slot:[`item.place`]="{ item }">
                          {{ item.result?.place }}
                        </template>

                        <template v-slot:[`item.last_name`]="{ item }">
                          {{ item.last_name }}
                        </template>

                        <template v-slot:[`item.first_name`]="{ item }">
                          {{ item.first_name }}
                        </template>

                        <template v-slot:[`item.competitor_category_name`]="{ item }">
                          {{ item.competitor_category_name }}
                        </template> 
                        
                        <template v-slot:[`item.competitor_index`]="{ item }">
                          {{ item.competitor_index }}
                        </template>

                        <template v-slot:[`item.run_time`]="{ item }">
                          {{ item.result?.run_time }}
                        </template>


                        <template v-slot:[`item.actions`]="{ item }">
                          <v-list-item-action v-if="item.result">
                            <v-icon @click="openEditResultDialog(item)" color="blue" size="x-large" class="mr-2">mdi-pencil</v-icon>
                            <v-icon @click="openDeleteResultDialog(item)" color="red" size="x-large">mdi-delete</v-icon>
                          </v-list-item-action>
                        </template>
                        <template v-slot:bottom></template>
                      </v-data-table>

                      <!-- Zobrazení chybového hlášení -->
                      <div v-if="errorResultsSendMessage.length" style="color:red; font-size:13px; float:right;" class="ma-2">
                          <div v-for="(error, index) in errorResultsSendMessage" :key="index">
                            {{ error }}
                          </div>
                        </div>


                        <!-- Dialog pro editaci Result -->
                        <v-dialog v-model="dialogEditResult" max-width="800px">
                          <v-card>
                            <v-card-title>
                              {{ selectedResult.last_name }} {{ selectedResult.first_name }}
                            </v-card-title>
                            <v-card-text>
                            <v-row v-if="!selectedResult.competitor_id">
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="selectedResult.last_name"
                                  hide-details
                                  density="comfortable"
                                  :label="$t('event_settings.results.last_name')"
                                  :rules="[v => !!v || $t('rules.required')]"
                                />
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-text-field
                                  v-model="selectedResult.first_name"
                                  hide-details
                                  density="comfortable"
                                  :label="$t('event_settings.results.first_name')"
                                  :rules="[v => !!v || $t('rules.required')]"
                                />
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" md="4">
                                <v-text-field v-model="selectedResult.start_number" hide-details type="number" density="comfortable" :label="$t('event_settings.results.start_number')" />
                              </v-col>
                              <v-col cols="12" md="4">
                              <v-text-field v-model="selectedResult.competitor_category_name" hide-details density="comfortable" :label="$t('event_settings.results.category')" />
                              </v-col>
                              <v-col cols="12" md="4">
                                <v-select
                                  v-model="selectedResult.result.result_status"
                                  :items="[
                                    { title: $t('enums.result_status.OK'), value: 'OK' },
                                    { title: $t('enums.result_status.DNS'), value: 'DNS' },
                                    { title: $t('enums.result_status.DNF'), value: 'DNF' },
                                    { title: $t('enums.result_status.DSQ'), value: 'DSQ' },
                                    { title: $t('enums.result_status.OVT'), value: 'OVT' },
                                    { title: $t('enums.result_status.NR'), value: 'NR' },
                                    { title: $t('enums.result_status.UNF'), value: 'UNF' },
                                    { title: $t('enums.result_status.MP'), value: 'MP' },
                                    { title: $t('enums.result_status.ERR'), value: 'ERR' },
                                  ]"
                                  :label="$t('event_settings.results.result_status_edit')"
                                  density="comfortable"
                                  hide-details
                                ></v-select>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" md="3">
                                <v-text-field v-model="selectedResult.result.run_time" :value="selectedResult.result.run_time" hide-details density="comfortable" :label="$t('event_settings.results.run_time_edit')" />
                              </v-col>
                              <v-col cols="12" md="3">
                                <v-text-field v-model="selectedResult.competitor_index" :value="selectedResult.competitor_index" hide-details density="comfortable" :label="$t('event_settings.results.index')" />
                              </v-col>
                              <v-col cols="12" md="3">
                                <v-text-field v-model="selectedResult.result.punch_count" hide-details type="number" density="comfortable" :label="$t('event_settings.results.punch_count')" />
                              </v-col>
                              <v-col cols="12" md="3">
                                <v-text-field v-model="selectedResult.result.place" hide-details density="comfortable" :label="$t('event_settings.results.place')" />
                              </v-col>
                            </v-row>

                            <v-col cols="12" class="mb-1">{{ $t('event_settings.results.splits') }}:</v-col>
                            <v-row v-for="(punch, punchIndex) in selectedResult.result?.punches" :key="punchIndex">
                              <v-col cols="3">
                                <v-text-field
                                  v-model="punch.code"
                                  :label="$t('event_settings.results.split_code')"
                                  hide-details
                                  density="compact"
                                  variant="outlined"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="3">
                                <v-text-field
                                  v-model="punch.split_time"
                                  :label="$t('event_settings.results.split_time')"
                                  hide-details
                                  density="compact"
                                  variant="outlined"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="3">
                                <v-text-field
                                  v-model="punch.alias"
                                  :label="$t('event_settings.results.split_alias')"
                                  hide-details
                                  density="compact"
                                  variant="outlined"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="3">
                                <v-select
                                  v-model="punch.punch_status"
                                  :items="[
                                    { title: $t('enums.punch_status.OK'), value: 'OK' },
                                    { title: $t('enums.punch_status.MP'), value: 'MP' },
                                    { title: $t('enums.punch_status.DP'), value: 'DP' },
                                    { title: $t('enums.punch_status.AP'), value: 'AP' },
                                  ]"
                                  :label="$t('event_settings.results.split_status')"
                                  hide-details
                                  density="compact"
                                  variant="outlined"
                                ></v-select>
                              </v-col>
                            </v-row>
                            </v-card-text>
                            <v-card-actions>
                              <v-btn color="grey" text @click="dialogEditResult = false">{{ $t('general.close') }}</v-btn>
                              <v-btn color="green darken-1" text @click="saveEditResult" :disabled="!selectedResult.first_name || !selectedResult.last_name">{{ $t('general.save') }}</v-btn>
                            </v-card-actions>

                          </v-card>
                        </v-dialog>

                        <!-- Dialog pro potvrzení smazání Result -->
                        <v-dialog v-model="dialogDeleteResult" persistent max-width="400px">
                          <v-card>
                            <v-card-title class="text-h5">{{ $t('event_settings.results.title_delete') }}</v-card-title>
                            <v-card-text>
                              {{ $t('event_settings.results.text_delete_single') }} <b>{{ selectedResult.last_name }} {{ selectedResult.first_name }}</b>?
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="dialogDeleteResult = false">{{ $t('general.cancel') }}</v-btn>
                              <v-btn color="red darken-1" text @click="deleteResult">{{ $t('general.delete') }}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>


                      </template>


                    <v-stepper-actions>
                      <template v-slot:next>
                        <v-btn color="primary" v-if="stepResults < totalResultsSteps" @click="stepResults++">{{ $t('general.next') }}</v-btn>
                        <v-btn color="green darken-1" v-else  @click="saveResultsData" :disabled="loadingSubmit" :loading="loadingSubmit">{{ $t('general.save') }}</v-btn>
                      </template>
                      <template v-slot:prev>
                        <v-btn variant="plain" v-if="stepResults > 1" @click="stepResults--">{{ $t('general.back') }}</v-btn>
                        <v-btn variant="plain" v-else>&nbsp;</v-btn>
                      </template>
                    </v-stepper-actions>




                  </v-stepper>
                </v-card-text>
              </v-card>
            </v-dialog>



          </v-window-item>
      
        </v-window>
      </v-card-text>


    </v-card>
  </v-container>

  <DialogConfirmLeave
    v-model="leaveDialog"
    :text="$t('entry.unsaved_text')"
    @cancel="cancelLeave"
    @confirm="confirmLeave"
  />

  <v-dialog v-model="dialogRaceStartMissing" persistent max-width="520px">
    <v-card>
      <v-card-title class="text-h6">{{ raceStartDialogTitle }}</v-card-title>
      <v-card-text>
        <p class="mb-4">
          {{ raceStartDialogDescription }}
        </p>
        <v-text-field
          v-model="raceStartDialogTime"
          type="time"
          :label="raceStartDialogLabel"
          density="comfortable"
          :disabled="savingRaceStart"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="raceStartDialogContext === 'startlist'"
          variant="text"
          :disabled="savingRaceStart"
          @click="cancelRaceStartDialog"
        >
          {{ $t('general.cancel') }}
        </v-btn>
        <v-btn
          v-if="raceStartDialogContext === 'results'"
          variant="text"
          :disabled="savingRaceStart"
          @click="skipRaceStartDialog"
        >
          {{ $t('event_settings.results.race_start_dialog.skip') }}
        </v-btn>
        <v-btn color="success" :loading="savingRaceStart" :disabled="!raceStartDialogTime" @click="saveRaceStartFromDialog">
          {{ raceStartDialogSaveLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>






<script setup>
import { ref, computed, onMounted, watch, reactive, markRaw, nextTick } from 'vue';
import apiClient from '/api.js';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import { useAuthStore } from '/auth.js';
import { format, addDays, parseISO } from 'date-fns';
import CountrySelect from '@/components/shared/CountrySelect.vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import EventSettingsOtherServices from '@/components/EventSettingsOtherServices.vue';
import { RACE_LEVEL_MAPPING } from '@/utils/raceLevelOptions.js';
import { EventTypes } from '@/utils/eventTypes'
import { RACE_TYPE_ITEMS, CURRENCY_ITEMS, currencySymbol } from '@/components/const/enums.js';
import { useI18n } from 'vue-i18n';
import RadioControlPage from './RadioControlPage.vue';
import DialogConfirmLeave from '@/components/shared/DialogConfirmLeave.vue';
import { printElementById } from '@/utils/print.js';
import { exportToTxt } from '@/utils/exportTxt.js';
import { exportToTxtSplits } from '@/utils/exportTxtSplits.js';

const { t, locale } = useI18n()
const snackbar = useSnackbarStore()

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();
const { eventTypes, eventTypeRule } = EventTypes();
// const isLoadingEvent = ref(true);
const dialogOracon = ref(false)

const event = ref({
  entry_is_open: false,
  entry_deadline_1: ""
});

const visibilityTypes = ref([
  { title: t('enums.visibility_types.PUBLIC'), value: 'PUBLIC' },
  { title: t('enums.visibility_types.CLUB'), value: 'CLUB' },
]);

const races = ref([]); // Seznam etap (Race) získaných z API kromě prvního Race
const race0 = ref({});
const currentRaceId = ref(null); // Zde uchováváme aktuálně vybrané ID závodu
const files = ref([]);
const showAddFileSection = ref(false); // Řídí zobrazení sekce pro přidání nového souboru
const showAddLinkSection = ref(false); // Zobrazit pole pro nový odkaz
const newFile = ref({ name: '', specific: null, location: null }); // Data pro nový soubor
const newLink = ref({ name: '', url: '' }); // data pro nový odkaz
const fileTypes = ref([
  { title: t('home.bulletin'), value: 'bulletin' },
  { title: t('home.info'), value: 'info' },
  { title: t('home.startlist'), value: 'startlist' },
  { title: t('home.results'), value: 'results' }
]);
const newRace = ref({ race_name: '', race_date: '', race_level: '' });

const raceLevel = computed(() => {
  const et = event.value?.event_type
  const levels = RACE_LEVEL_MAPPING[et] || []
  return levels.map(l => ({ value: l, title: t(`enums.race_level.${l}`) }))
})

const race_bands = ref([
  { title: '3,5 MHz', value: 'M80' },
  { title: '144 MHz', value: 'M2' },
  { title: '144 MHz + 3,5 MHz', value: 'COMBINED' },
]);


const categories = ref([]); // Seznam kategorií pro zvolený Race nebo pro Race0 v rámci Eventu
const categoriesToDelete = ref([]);

const categoryHeaders = ref([ // Hlavičky tabulky pro kategorie
  { title: t('event_settings.categories.headers_event.category'), key: 'option' },
  { title: t('event_settings.categories.headers_event.name'), key: 'category_name' },
  { title: t('event_settings.categories.headers_event.fee'), key: 'fee' },
  { title: t('event_settings.categories.headers_event.increased_fee'), key: 'increased_fee' },
  { title: t('event_settings.categories.headers_event.fee_event'), key: 'fee_event' },
  { text: t('event_settings.categories.headers_event.actions'), value: 'actions', sortable: false }
]);

const categoryHeadersEvents = ref([ // Hlavičky tabulky pro kategorie
  { title: t('event_settings.categories.headers_race.option'), key: 'option' },
  { title: t('event_settings.categories.headers_race.name'), key: 'category_name' },
  { title: t('event_settings.categories.headers_race.fee'), key: 'fee' },
  { title: t('event_settings.categories.headers_race.increased_fee'), key: 'increased_fee' },
  { title: t('event_settings.categories.headers_race.control_points'), key: 'category_control_points' },
  { title: t('event_settings.categories.headers_race.level'), key: 'category_level', sortable: false },
  { title: t('event_settings.categories.headers_race.enable_ranking'), key: 'enable_ranking', sortable: false },
  { text: t('event_settings.categories.headers_race.actions'), value: 'actions', sortable: false }
]);


const main = ref('event'); // Přidáno pro inicializaci na první záložku main části
const second = ref('entries'); // Přidáno pro inicializaci na první záložku second části
const BaseUrl = ref(process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, '').replace(/\/api\/?$/, '')); // Odstraní "api/" a nadbytečná lomítka
const apiBaseUrl = computed(() => (process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '')); // Zachování API base URL bez lomítka na konci
const errorMessage = ref('');
const dialogDeleteEvent = ref(false);
const dialogDeleteRace = ref(false);
const dialogAddRace = ref(false);
const dialogCategory = ref(false);
const dialogCategoryRace = ref(false);
const change_allcategories = ref(false);
const dialogCategoryRace0 = ref(false);
const dialogDeleteFile = ref(false);

const CategoryType = markRaw([
        { title: 'D07 (0-7)', value: 'W07' },
        { title: 'D09 (0-9)', value: 'W09' },
        { title: 'D12 (0-12)', value: 'W12' },
        { title: 'D14 (0-14)', value: 'W14' },
        { title: 'D16 (0-16)', value: 'W16' },
        { title: 'D19 (0-19)', value: 'W19' },
        { title: 'D20 (0-99)', value: 'W21' },
        { title: 'D35 (35-99)', value: 'W35' },
        { title: 'D45 (45-99)', value: 'W45' },
        { title: 'D55 (55-99)', value: 'W55' },
        { title: 'D65 (65-99)', value: 'W65' },
        { title: 'M07 (0-7)', value: 'M07' },
        { title: 'M09 (0-9)', value: 'M09' },
        { title: 'M12 (0-12)', value: 'M12' },
        { title: 'M14 (0-14)', value: 'M14' },
        { title: 'M16 (0-16)', value: 'M16' },
        { title: 'M19 (0-19)', value: 'M19' },
        { title: 'M20 (0-99)', value: 'M21' },
        { title: 'M40 (40-99)', value: 'M40' },
        { title: 'M50 (50-99)', value: 'M50' },
        { title: 'M60 (60-99)', value: 'M60' },
        { title: 'M70 (70-99)', value: 'M70' },
        { title: 'MDR (0-13)', value: 'MDR' },
        { title: t('enums.category_type.OTHERS') + '(0-99)', value: 'OTHERS' },
        { title: 'ORG (0-99)', value: 'ORG' },

]);

 // error hlášky
const eventTitle = ref([v => !!v || t('rules.required')]);
const eventDate = ref([v => !!v || t('rules.required')]);
const eventType = ref(eventTypeRule)
const visibilityType = ref([v => !!v || t('rules.required')]);


const nameRules = ref([v => !!v || t('rules.required')]);
// const category_max_ageRules = ref([
//   v => !!v || 'Max věk je povinný',
//   v => (v && v > 0) || 'Věk musí být větší než 0'
// ]);
// const sexRules = ref([v => !!v || 'Pohlaví je povinné']);
const optionRules = ref([v => !!v || t('rules.required')]);

// const fileNameRules = ref([v => !!v || 'Název souboru je povinný']);
// const linkNameRules = ref([v => !!v || 'Název odkazu je povinný']);

const timeRules = computed(() => {
  const required = currentRace.value?.result_publishing === 'DAY_TIME'

  return [
    v => (!required || !!v) || t('rules.required'),
    v => (!required || /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(v || '')) || t('event_settings.time_format_hhmm_hhmmss'),
  ]
});

// const formatDateTimeForInput = (datetime) => {
//   return datetime ? datetime.replace('Z', '').substring(0, 16) : '';
// };

// const parseDateTimeFromInput = (datetime) => {
//   return datetime ? datetime + ':00' : '';
// };


// Oprávnění organizátora, závisí na tom, jestli je organizátor ve stejném klubu jako event nebo je editor
const isOrganizer = computed(() => {
  // Převod Proxy objektu na běžné pole pro jednoduchý přístup
  const isRoleOrganizer = authStore.isOrganizer(event.value.event_organizer);
  // Podmínky pro editora
  const editorsArray = event.value.editors || [];
  const isUserEditor = editorsArray.includes(Number(authStore.userID));
  const isAuthor = Number(event.value.author) === Number(authStore.userID);

  // Oprávnění pro organizátora nebo když je editors prázdné
  console.log('Is Organizer:', isRoleOrganizer, 'Is User Editor:', isUserEditor);
  return isAuthor || isUserEditor || (editorsArray.length === 0 && isRoleOrganizer); // user je editor nebo pokud nejsou editoři, je organizátor
});



// Sledujte změnu v aktuálně vybrané záložce a mění Race ID
watch(main, (newValue) => {
  if (newValue === 'event' && race0.value.id) {
    currentRaceId.value = race0.value.id;
  }
});


const isRace0 = computed(() => currentRaceId.value === race0.value.id); // zjištění, jestli se jedná o hlavní stránku, potom zobraz přihlášené a Raceservices v template

// Filtrování souborů pro zobrazení pouze odkazů
const filesWithLinks = computed(() => files.value.filter(file => file.is_link));
// Filtrování souborů pro zobrazení pouze souborů
const filesWithLocation = computed(() => files.value.filter(file => file.is_file));

function setAccommodationDates() {
  const start = event.value?.event_date_start;
  const end = event.value?.event_date_end;
  if (!start || !end) return;

  accommodations.value.forEach(acc => {
    if (acc.loadedFromAPI) return;

    // Pokud je event jednodenní (start == end), předvyplň ubytování "od" o den dřív,
    // aby šlo zadat přenocování na den závodu (UI "do" je vždy o den víc než ukládaná hodnota).
    const defaultFrom = (start === end) ? shiftIso(start, -1) : start
    if (!acc.date_from) acc.date_from = defaultFrom;

    // do modelu ukládáme backend value (end - 1), UI ukáže end
    if (!acc.date_to) acc.date_to = shiftIso(end, -1);
  });
}

onMounted(async () => {
  await loadEventAndRacesData();
  await fetchEntries();

  const pEditors = fetchEditors();
  const pRaceSvc = fetchRaceServiceData();

  updateSecondTab();

  await Promise.allSettled([pEditors, pRaceSvc]);

  setAccommodationDates();

  // nech doběhnout watchery / DOM flush
  await new Promise(requestAnimationFrame);

  takeSnapshot();
});

// nastavení podle čeho se má zobrazit aktivní záložka v soutěži 
const updateSecondTab = () => {
  console.log(`Entries: ${entries.value.length}, Startlist: ${startlist.value.length}, Results: ${results.value.length}`);

  if (results.value.length > 0) {
    second.value = 'results';
  } else if (startlist.value.length > 0) {
    second.value = 'startlist';
  } else if (entries.value.length > 0) {
    second.value = 'entries';
  } else {
    second.value = 'acc_food';
  }
};


const loadEventAndRacesData = async () => {
  const eventId = route.params.id; // event ID z URL adresy
  try {
    const response = await apiClient.get(`event/edit/?id=${eventId}`);
    event.value = response.data;

    // Seřadit závody podle ID
    const sortedRaces = response.data.races.sort((a, b) => a.id - b.id);
    // uloží hodoty pro první race0
    race0.value = sortedRaces.length > 0 ? sortedRaces[0] : null;
    // Odstranit první závod (s nejnižším ID)
    const racesWithoutFirst = sortedRaces.slice(1);
    // Uložit upravené závody do races v pořadí podle race_date a race_start
    races.value = racesWithoutFirst.sort((a, b) => {
      if (a.race_date < b.race_date) return -1;
      if (a.race_date > b.race_date) return 1;
      if (a.race_start < b.race_start) return -1;
      return a.race_start > b.race_start ? 1 : 0;
    });


    // allRaces data pro editaci přihlášených
    allRaces.value = response.data.races.map((race, competitor_index) => {
      if (competitor_index !== 0) {
        race.categories.push({
          id: null,
          isUnregistered: true,
          code: "unreg", 
          category_name: t('event_settings.entries.unregistered'),
          race: race.id
        });
      }
      race.categories.sort((a, b) => {
        if (a.isUnregistered) return -1
        if (b.isUnregistered) return 1
        return a.category_name.localeCompare(b.category_name)
      })
      return race
    });

    // Seřadit allRaces podle ID
    allRaces.value = allRaces.value.sort((a, b) => a.id - b.id);
    // Uložit první závod a ostatní závody do allRaces v pořadí podle race_date a race_start
    allRaces.value = [
      allRaces.value[0],
      ...allRaces.value.slice(1).sort((a, b) => {
        const dateComparison = new Date(a.race_date) - new Date(b.race_date);
        if (dateComparison !== 0) return dateComparison;
        if (!a.race_start) return 1;
        if (!b.race_start) return -1;
        return a.race_start.localeCompare(b.race_start);
      })
    ];

    // Po vytvoření race0 se toto id přenese do fetchCategories atd., aby se kategorie race0 načetli při otevření nastavení, když je vybraný Event
    if (race0.value && race0.value.id && currentRaceId.value == null) {
      currentRaceId.value = race0.value.id;
    }
    if (currentRaceId.value) {
      // načtení race0 ID po otevření nastavení. Poté se race ID aktualizuje podle kliknutí na záložku podle watcheru
      await fetchCategories(currentRaceId.value);
      await fetchFiles(currentRaceId.value);
    }
    dialogOrganizersList.value = false;
    errorMessage.value = ""
    takeSnapshot()
  } catch (error) {
    console.error("There was an error fetching the event and races data:", error);
  // } finally {
  //   isLoadingEvent.value = false;
  } 
};

// aktualizace date ve startu 00 když se změní datum závodu
const updateRaceStartDate = (race) => {
  if (race.race_start) {
    const timePart = race.race_start.split("T")[1] || ""; // Zachová časovou část
    race.race_start = `${race.race_date}T${timePart}`;
  }
};

// aktualizace date ve startu 00 když se mění pole start00
const updaterace_startTime = (race) => {
  if (!race.race_startTime) {
    race.race_start = null;
  } else {
    const timeValue = race.race_startTime.trim();
    const isValidTime = /^([01]\d|2[0-3]):?([0-5]\d)$/.test(timeValue);

    if (isValidTime) {
      race.race_start = `${race.race_date}T${timeValue}`;
    } else {
      console.error("Invalid time format:", timeValue);
      race.race_start = null;
    }
  }
};


const editors = ref([]);
const selectedEditors = ref([]);

const officials = ref([]);


// Načítání účtů z API
const fetchEditors = async () => {
  try {
    const response = await apiClient.get('account/?list=true'); // Volání API s parametrem simple=true
    editors.value = response.data;
    officials.value = response.data

    // Přiřaď aktuální editory na základě jejich ID z eventu
    selectedEditors.value = editors.value.filter(editor =>
      event.value.editors.includes(editor.id)
    );



  } catch (error) {
    console.error('Chyba při načítání účtů:', error);
  }
};



const validateEntryDeadlines = () => {
  const deadline1 = new Date(race0.value.entry_deadline_1);
  const deadline2 = race0.value.entry_deadline_2 ? new Date(race0.value.entry_deadline_2) : null;
  const eventStartDate = new Date(event.value.event_date_start);

  // Reset time to 00:00:00 for comparison
  const resetTime = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  const deadline1DateOnly = resetTime(deadline1);
  const deadline2DateOnly = deadline2 ? resetTime(deadline2) : null;
  const eventStartDateOnly = resetTime(eventStartDate);

  if (deadline1DateOnly > eventStartDateOnly) {
    errorMessage.value = t('event_settings.deadline1_not_after_start');
    return false;
  }

  if (deadline2DateOnly && deadline2DateOnly > eventStartDateOnly) {
    errorMessage.value = t('event_settings.deadline2_not_after_start');
    return false;
  }

  if (deadline2DateOnly && deadline2DateOnly < deadline1DateOnly) {
    errorMessage.value = t('event_settings.deadline2_not_before_deadline1');
    return false;
  }

  return true;
};



const saveEvent = async () => {
  const eventId = route.params.id;

  // Check if entry is open and the first entry deadline for race0 is not set
  if (event.value.entry_is_open === true && (race0.value.entry_deadline_1 === null || race0.value.entry_deadline_1 === '')) {
    snackbar.error(t('event_settings.entry_open_need_deadline1'));
    console.error(errorMessage.value);
    return; // Předčasné ukončení metody, nepokračovat v uložení
  }

  // Validace termínů přihlášek
  if (!validateEntryDeadlines()) {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrollování nahoru pro zobrazení chybové zprávy
    return;
  }

  // Kontrola, zda datum všech etap jsou v rozmezí dat začátku a konce události
  const startDate = new Date(event.value.event_date_start);
  const endDate = new Date(event.value.event_date_end);

  for (let race of races.value) {
    const raceDate = new Date(race.race_date);
    if (raceDate < startDate || raceDate > endDate) {
      snackbar.error(t('event_settings.races_within_event_dates'));
      return;
    }
  }


  // Aktualizace race_start s přidáním času z inputu
  for (let race of races.value) {
    if (race.race_startTime === undefined) {
      // Pokud nebyl zadán žádný čas, ponecháme původní hodnotu
      continue;
    } else if (!race.race_startTime || race.race_startTime === '') {
      race.race_start = null; // Nastavit na null, pokud není zadán žádný čas
    } else {
      race.race_start = `${race.race_date}T${race.race_startTime}`;
    }
  }
  // Kontrola, zda race.race_start obsahuje stejné datum jako race.race_date
  for (let race of races.value) {
    if (race.race_start && race.race_date) {
      const race_startDate = race.race_start.split('T')[0];
      if (race_startDate !== race.race_date) {
        snackbar.error(t('event_settings.race_start_same_date'));
        return;
      }
    }
  }
  // Přiřazení ID editorů do eventu před odesláním na server
  event.value.editors = [...selectedEditors.value].map(editor => {
    return typeof editor === 'object' && editor !== null ? editor.id : editor;
  });
  isLoading.value = true;
  try {
    const response = await apiClient.put(`event/edit/?id=${eventId}`, event.value);
    event.value = response.data;
    snackbar.success(t('event_settings.updated_success'));
    loadEventAndRacesData();

    dialogOrganizersList.value = false;
    takeSnapshot()
    } catch (error) {
    console.error("There was an error updating the event:", error);

    if (error.response && error.response.status === 423) {
      // Pokud status 423, zobraz zprávu z API
      snackbar.error(error.response.data.error || t('event_settings.update_failed_locked'));
    } else {
      // Obecná chybová zpráva
      snackbar.error(t('event_settings.update_failed_generic'));
    }
    }
    finally {
      isLoading.value = false;
    }
  };

  // Logika pro uzavření soutěže
  const confirmCloseDialog = ref(false)
  const loadingCloseEvent = ref(false)

  const CloseEventDialog = () => {
    confirmCloseDialog.value = true
  }


  const CloseEvent = async () => {
  const eventId = route.params.id;
  loadingCloseEvent.value = true
  try {
    await apiClient.patch(`event/edit/?event_id=${eventId}`);

    confirmCloseDialog.value = false;
    snackbar.success(t('event_settings.closed_success'));
    loadEventAndRacesData();
    } catch (error) {

    if (error.response && error.response.status === 423) {
      // Pokud status 423, zobraz zprávu z API
      snackbar.error(error.response.data.error || t('event_settings.update_failed_generic'))
    } else {
      // Obecná chybová zpráva
      snackbar.error(t('event_settings.update_failed_generic'))
    }

    }
    finally {
      loadingCloseEvent.value = false;
    }
  };




const deleteEvent = async () => {
  try {
    const eventId = route.params.id;
    await apiClient.delete(`event/edit/?id=${eventId}`);
    dialogDeleteEvent.value = false; // Close the confirmation dialog
    snackbar.success(t('event_settings.deleted_success'));
    router.push('/'); // Přesměrování uživatele po úspěšném smazání
  } catch (error) {
    console.error("There was an error deleting the race:", error);
    dialogDeleteEvent.value = false; // Close the confirmation dialog
    if (error.response.status === 423) {
      snackbar.error(t('event_settings.delete_failed_has_entries'));
    } else {
      snackbar.error(t('event_settings.delete_failed_generic'));
    }
  }
};


  const addRace = async () => {
  try {
    const eventId = route.params.id;

    // Kontrola, zda datum závodu je v rozmezí dat začátku a konce události
    const startDate = new Date(event.value.event_date_start);
    const endDate = new Date(event.value.event_date_end);
    const raceDate = new Date(newRace.value.race_date);

    if (raceDate < startDate || raceDate > endDate) {
      snackbar.error(t('errors.stage_date_out_of_range'));
      return;
    }


    const newRaceData = {
      race_name: newRace.value.race_name,
      race_date: newRace.value.race_date,
      race_level: newRace.value.race_level,
      event: route.params.id, // ID eventu, ke kterému se etapa přidává
    };
    await apiClient.post(`event/edit/?id=${eventId}`, newRaceData);
    await loadEventAndRacesData();
    newRace.value = {race_name: '', race_date: '', race_level: ''}; // Resetování formuláře
    snackbar.success(t('event_settings.stage_created'));
    dialogAddRace.value = false;

  } catch (error) {
    console.error("There was an error adding the race:", error);
    snackbar.error(t('rules.required_all'));
    dialogAddRace.value = true;
  }
};

// Zde se odesílá DELETE požadavek na API
const deleteRace = async (eventId, raceId) => {
  try {
    await apiClient.delete(`event/edit/?race_id=${raceId}`);
    // Úspěšné smazání etapy
    snackbar.success(t('event_settings.stage_deleted'));
    await loadEventAndRacesData(); // Znovu načíst data pro aktualizaci UI
  } catch (error) {
    dialogDeleteRace.value = false; // zavřít okno upozornění
    console.error("There was an error deleting the race:", error);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrollování nahoru pro zobrazení chybové zprávy
    if (error.response.status === 423) {
      snackbar.error(t('event_settings.stage_deleted_failed_entry'));
    } else {
      snackbar.error(t('event_settings.stage_deleted_failed'));
    }
  }
};


// watcher na sledování v-model záložek pro event a races a následné načtení dat z api
watch(main, async (newTab) => {
  console.log(`Aktuální záložka: ${newTab}`);
  if (newTab === 'event') {
    if (!race0.value?.id) return
    currentRaceId.value = race0.value.id;
    // Vymazání startlistu a výsledků, protože pro event je nechceme zobrazovat
    startlist.value = [];
    results.value = [];
    
    await fetchFiles(race0.value.id);
    await fetchCategories(race0.value.id);

    console.log('Načítám data pro hlavní záložku.');
  } else if (newTab.startsWith('race-')) {
    const raceId = Number(newTab.split('-')[1]); // Získání race ID ze záložky
    currentRaceId.value = raceId;
    await fetchFiles(raceId);
    await fetchResults(raceId);
    await fetchStartlist(raceId);
    await fetchCategories(raceId);

  }

  updateSecondTab(); // načtení aktivní záložky podle dostupných dat ve všech případech

});



const fetchCategories = async (raceId) => {
  try {
    const response = await apiClient.get(`categories/?race=${raceId}`);
    categories.value = response.data.map(category => ({
      ...category,
      // K výpisu se přidá příznak pro hromadnou úpravu startovného, aby se neupravovaly hodnoty z databáze, ale jen ty prázdné
      feeFromDatabase: category.fee !== null && category.fee !== '',
      increasedFeeFromDatabase: category.increased_fee !== null && category.increased_fee !== '',
      feeEventFromDatabase: category.fee_event !== null && category.fee_event !== ''
    }));
  } catch (error) {
    console.error("There was an error fetching the categories:", error);
  }
};

// Aktivace tlačítka uložit, jen pokud je vyplněné pole name a option
const NotNameOption = () => {
  return categories.value.every(category => category.category_name.trim() !== '' && category.option.trim() !== '');
};

const bulkFee = ref(null);
const bulkIncreasedFee = ref(null);
const bulkFeeEvent = ref(null);
const dialogCategoryOpen = ref(false)

const openCategoryDialog = async (currentRaceId) => {
  dialogCategoryOpen.value = true
}

// Hromadně zvýšit startovné
const applyBulkFee = () => {
  categories.value.forEach(category => {
    if (!category.feeFromDatabase) {
      category.fee = bulkFee.value;
    }
  });
};

// Hromadně zvýšit zvýšené startovné
const applyBulkIncreasedFee = () => {
  categories.value.forEach(category => {
    if (!category.increasedFeeFromDatabase) {
      category.increased_fee = bulkIncreasedFee.value;
    }
  });
};

// Hromadně zvýšit startovné soutěže
const applyBulkFeeEvent = () => {
  categories.value.forEach(category => {
    if (!category.feeEventFromDatabase) {
      category.fee_event = bulkFeeEvent.value;
    }
  });
};

const CATEGORY_LEVELS_ALLOWED = ['NATIONAL','REGIONAL','DISTRICT','OTHER']
const CategoryLevelOptions = computed(() =>
  CATEGORY_LEVELS_ALLOWED.map(v => ({ value: v, title: t(`enums.race_level_short.${v}`) }))
)


const addNewCategory = () => {

  // zjištění race_level a zajištění, že při practice, selections apod. bude other
  const r = [...races.value, race0.value].find(x => x?.id === currentRaceId.value)
  const lvl = r?.race_level || 'OTHER'
  const defaultLevel = CATEGORY_LEVELS_ALLOWED.includes(lvl) ? lvl : 'OTHER'

  const newCategory = {
    id: null, // ID nebude nastaveno pro nově vytvořenou kategorii
    category_name: '',
    category_max_age: null,
    category_gender: '',
    option: '',
    fee: null,
    increased_fee: null,
    reduced_fee: null,
    race: currentRaceId.value, // race je na základě aktuálního vybraného race.id
    category_level: defaultLevel,
    enable_ranking: true 
  };
  categories.value.push(newCategory); // Add the new category to the reactive list
};


// Pokud je switch 'Přepsat i v etapách' true, zobrazí se dialog pro potvrzení
const dialogCategoryRace0show = () => {
  if (change_allcategories.value) {
    dialogCategoryRace0.value = true;
  } else {
    updateCategory();
  }
};

const loadingUpdateCatgory = ref(false)

const updateCategory = async () => {
  loadingUpdateCatgory.value = true
  try {
    const eventId = route.params.id;
    const updatedCategories = categories.value.filter(c => c.id !== null);
    const newCategories = categories.value.filter(c => c.id === null);

    const payload = {
      event_id: eventId,
      change_allcategories: change_allcategories.value, // proměnná pro hromadné uložení kat. do etap
      updated_categories: updatedCategories,
      new_categories: newCategories,
      categories_to_delete: categoriesToDelete.value,
    };

    const response = await apiClient.put('categories/', payload);
    categoriesToDelete.value = []; // Reset seznamu pro smazání
    dialogCategory.value = false; // Zavřete dialog po úspěšné aktualizaci
    dialogCategoryRace.value = false; // Zavřete dialog po úspěšné aktualizaci
    dialogCategoryRace0.value = false; // Zavřete dialog po úspěšné aktualizaci
    // zobrazení hlášky o úspěchu
    if (response.data.not_deleted && response.data.not_deleted.length > 0) {
      // show partial success with list of not deleted categories
      snackbar.successLong(`${t('event_settings.categories.updated_partial')} ${response.data.not_deleted.join(', ')}`);
    } else {
      snackbar.success(t('event_settings.categories.updated'));
    }
    // načtení aktuálních kategorií
    await fetchCategories(currentRaceId.value);
    bulkFee.value = null;
    bulkFeeEvent.value = null;
    bulkIncreasedFee.value = null;
    dialogCategoryOpen.value = false

  } catch (error) {
    console.error("Chyba při aktualizaci kategorií", error);
    // Kontrola na chybu 406 a nastavení errorMessage z odpovědi
    if (error.response && error.response.status === 406) {
      snackbar.error(error.response.data.error || t('event_settings.categories.ave_failed_duplicate'));
    } else {
      snackbar.error(t('event_settings.categories.save_failed'));
    }
  }
  finally {
    loadingUpdateCatgory.value = false
  }
};


// uložení kategorií do proměnné pro smazání
const markCategoryForDeletion = (category) => {
   // 1) Pokud má kategorii existující id, zaznamenej ji k odeslání smazání
  if (category.id) {
    if (!categoriesToDelete.value.includes(category.id)) {
      categoriesToDelete.value.push(category.id);
    }
  }
  // 2) Odstraňme z pole právě tu kategorii:
  categories.value = categories.value.filter(cat => {
    // a) existující položky – podle id
    if (category.id) {
      return cat.id !== category.id;
    }
    // b) nové, ale s názvem – podle category_name
    if (category.category_name) {
      return cat.category_name !== category.category_name;
    }
    // c) nové, bez id i názvu – podle option
    return cat.option !== category.option;
  });
};

// Zobrazení dialogu pro vypsání organizátorů kvůli praxím a bodům
const dialogOrganizersList = ref(false);
// Nešel race z loopu, takže musím pro dialog načítat currentRaceId znovu. Bez dialogu to bylo OK
const currentRace = computed(() => races.value.find((r) => r.id === currentRaceId.value) || {});

const exportRaceHeaderLines = computed(() => {
  const r = currentRace.value;
  if (!r) return [];
  const en = event.value?.event_name || '';
  const rn = r.race_name || '';
  const title = [en, rn].filter(Boolean).join(' - ');
  let d = '';
  try {
    d = r.race_date ? format(parseISO(r.race_date), 'd. M. yyyy') : '';
  } catch (e) {
    d = r.race_date || '';
  }
  return [title, d].filter(Boolean);
});

const exportStartlistTxt = () => {
  exportToTxt('startlistContent', 'startlist.txt', '\t', exportRaceHeaderLines.value);
};

const exportResultsTxt = () => {
  exportToTxt('resultsContent', 'resultst.txt', '\t', exportRaceHeaderLines.value);
};

const exportResultsSplitsTxt = () => {
  exportToTxtSplits('resultsContent', 'results-splits.txt', '\t', exportRaceHeaderLines.value);
};

const dialogOrganizersListCancel = async () => {
    dialogOrganizersList.value = false; // Zavřít dialog
    main.value = 'event'; // Nastavit záložku na první (event)
    await loadEventAndRacesData(); // Načíst data z API
};

const fetchFiles = async (raceId) => {
  try {
    const response = await apiClient.get(`files/?race_id=${raceId}`);
    files.value = response.data; // Update the files array with the fetched data
  } catch (error) {
    console.error("Nepodařilo se načíst soubory", error);
  }
};

const editFile = (file) => {
  file.editing = true; // Přímo nastavíme vlastnost objektu
};

const updateFiles = async (file) => {
  try {
    const formData = new FormData();
    formData.append('id', file.id); // Přidáváme ID souboru pro jeho jednoznačnou identifikaci na serveru
    formData.append('name', file.name);
    formData.append('specific', file.specific);
    formData.append('url', file.url);

    if (file.newFile) { // Kontrola, zda byl přiložen nový soubor
      formData.append('location', file.newFile); 
    }

    // Přidání race_id pouze pokud je explicitně potřeba aktualizovat spojení souboru a závodu
    if (currentRaceId.value) {
      formData.append('race_id', currentRaceId.value);
    }

    if (file.newFile) { // Kontrola, zda byl přiložen nový soubor
      formData.append('location', file.newFile);  // Použití `location` místo `file`
    }


    await apiClient.put(`files/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.editing = false; // zrušení editace souboru
    await fetchFiles(currentRaceId.value); // Obnovení seznamu souborů
    snackbar.success(t('event_settings.saved'));
  } catch (error) {
    console.error("Nepodařilo se aktualizovat soubory", error);
  }
};


const fileError = ref('');  // Reaktivní reference pro chybové zprávy

const handleNewFileChange = (event, file = null) => {
  const selectedFile = event.target.files[0];  // Získání vybraného souboru z inputu
  if (selectedFile) {
    if (selectedFile.size > 10485760) {  // Kontrola velikosti souboru - 10 MB max
      fileError.value = t('event_settings.upload_size_error');
    } else {
      fileError.value = '';  // Resetování chybové zprávy, pokud soubor splňuje podmínky
      
      // Pokud je `file` parametr specifikovaný, jedná se o úpravu existujícího souboru
      if (file) {
        file.newFile = selectedFile;  // Přidání nového souboru do existující položky
      } else {
        newFile.value.file = selectedFile;  // Jinak je to nový soubor v novém záznamu
      }
    }
  }
};


const addNewFile = async () => {
  if (!newFile.value.file || !newFile.value.name) {
    alert(t('event_settings.required_fields'));
    return;
  }

  try {
    const formData = new FormData();
    formData.append('name', newFile.value.name);
    if (newFile.value.specific) formData.append('specific', newFile.value.specific);
    formData.append('location', newFile.value.file);
    formData.append('race_file', currentRaceId.value);

    await apiClient.post('files/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    snackbar.success(t('event_settings.startlist.upload_success'));
    showAddFileSection.value = false; // Close the add file section
    newFile.value = { name: '', specific: '', location: '' }; // Reset the new file object
    await fetchFiles(currentRaceId.value); // Načti soubory
  } catch (error) {
    console.error("Nepodařilo se nahrát soubor", error);
  }
};


const editLink = (file) => {
  editLink.value = { ...file };
  file.editing = true; // zobrazení editačního režimu
};

const deleteFile = async (fileId) => {
  try {
    await apiClient.delete(`files/?id=${fileId}`);
    await fetchFiles(currentRaceId.value); // Obnovení seznamu souborů
    snackbar.success(t('event_settings.deleted'));
    dialogDeleteFile.value = false; // Close any confirmation dialog if open
  } catch (error) {
    console.error("Nepodařilo se smazat soubor", error);
  }
};


 // funkce přidání odkazu. Editace a smazání je pomocí file
const addNewLink = async () => {
  if (!newLink.value.name || !newLink.value.url) {
    alert(t('event_settings.required_fields_url'));
    return;
  }

  try {
    const formData = new FormData();
    formData.append('name', newLink.value.name);
    formData.append('url', newLink.value.url);
    formData.append('race_file', currentRaceId.value);
    formData.append('is_link', true); // Přidání, aby bylo jasné, že se jedná o odkaz, nepoužívá se

    await apiClient.post('files/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    // Zpracování úspěšného přidání
    snackbar.success(t('event_settings.added'));
    showAddLinkSection.value = false; // Zavření sekce přidání odkazu
    newLink.value = { name: '', url: '' }; // Reset the new link object
    await fetchFiles(currentRaceId.value); // Znovu načtení seznamu souborů/odkazů
  } catch (error) {
    console.error("Nepodařilo se přidat odkaz", error);
  }
};


// Kopírování api key a kódu pro zobrazení

const copiedApiKey = ref(false)

function copyKey(race) {
  navigator.clipboard.writeText(race.race_api_key).then(() => {
    copiedApiKey.value = true
    setTimeout(() => {
      copiedApiKey.value = false
    }, 2000)
  })
}

const copiedPassword = ref(false)
function copyPassword(race) {
  navigator.clipboard.writeText(race.result_password).then(() => {
    copiedPassword.value = true
    setTimeout(() => {
      copiedPassword.value = false
    }, 2000)
  })
}


// KOPÍROVÁNÍ ORGANIZÁTORŮ DO JINÉ ETAPY

const copyMenuOpen = ref(false)
const targetRaceId = ref(null)
const dialogConfirmOverwrite = ref(false)
const loadingCopy = ref(false)

// jen etapy bez race0 (races.value už má slice(1))
const raceOptions = computed(() =>
  (races.value || [])
    .filter(r => r.id !== currentRaceId.value) // neukazuj aktuální
    .map(r => ({ title: r.race_name, value: r.id }))
)

const targetRaceTitle = computed(() =>
  (races.value || []).find(r => r.id === targetRaceId.value)?.race_name || ''
)

const onPickTargetRace = (raceId) => {
  targetRaceId.value = raceId         
  copyMenuOpen.value = false           
  dialogConfirmOverwrite.value = true  
}

const buildOrgPayload = (raceId, r) => ({
  race_id: raceId,
  director: r?.director || [],
  main_referee: r?.main_referee || [],
  course_setter: r?.course_setter || [],
  other_referee: r?.other_referee || [],
  jury_members: r?.jury_members || [],
  organizers_avg: r?.organizers_avg || [],
  delegate: r?.delegate ?? null,
})

const copyOrganizersToTargetRace = async () => {
  if (!targetRaceId.value || targetRaceId.value === currentRaceId.value) return

  loadingCopy.value = true
  try {
    // 1) uložit ORG pro ZDROJOVÝ race 
    await apiClient.post('race/org/', buildOrgPayload(currentRaceId.value, currentRace.value))

    // 2) uložit ORG pro CÍLOVÝ race
    await apiClient.post('race/org/', buildOrgPayload(targetRaceId.value, currentRace.value))

    snackbar.success(t('event_settings.copied_api'))
    dialogConfirmOverwrite.value = false
    targetRaceId.value = null
    copyMenuOpen.value = false

    await loadEventAndRacesData()
  } catch (error) {
    snackbar.error(error?.response?.data?.error || t('errors.request_failed'))
  } finally {
    loadingCopy.value = false
  }
}



// ****************** //
// ****************** //          *****************
// UBYTOVÁNÍ A STRAVA //        **********************
// ****************** //          *****************
// ****************** //



const days = ref([createNewDay()]);

// Vytvoření nového dne pro jídla
function addNewDay() {
  days.value.push(createNewDay());
}

const accommodations = ref([
  { id: null, name: '', price: '', limit: null, variant: 1, date_from: '', date_to: '', loadedFromAPI: false },
  { id: null, name: '', price: '', limit: null, variant: 2, date_from: '', date_to: '', loadedFromAPI: false },
  { id: null, name: '', price: '', limit: null, variant: 3, date_from: '', date_to: '', loadedFromAPI: false },
  { id: null, name: '', price: '', limit: null, variant: 4, date_from: '', date_to: '', loadedFromAPI: false }
]);

// Příprava ubytování před odesláním dat do API
function prepareAccommodationsData() {
  const preparedAccommodations = [];
  accommodations.value.forEach(acc => {
    // Předpokládáme, že acc.date_from a acc.date_to jsou správně nastaveny
    if (acc.name && (acc.price !== undefined && acc.price !== null) && acc.date_from && acc.date_to) {  // Zkontrolujte, zda jsou všechna potřebná data k dispozici
      preparedAccommodations.push({
        name: acc.name,
        variant: acc.variant,
        price: acc.price,
        id: acc.id,
        limit: acc.limit,
        date_from: acc.date_from, // Nejranější možné datum
        date_to: acc.date_to, // Nejpozdnější možné datum
        only_all_days: acc.only_all_days,
        type: "accommodation",
        loadedFromAPI: acc.loadedFromAPI,
      });
    }
  });
  return preparedAccommodations;
}

// posun data ve formátu ISO o 1 den
function shiftIso(dateStr, days) {
  if (!dateStr) return '';
  const d = parseISO(dateStr); // očekává 'yyyy-MM-dd'
  return format(addDays(d, days), 'yyyy-MM-dd');
}


// dialog před smazání varianty ubytování
const dialogAccomodations = reactive(accommodations.value.map(() => false));
function showAccomodationDialog(index) {
  dialogAccomodations[index] = true;
}

const fieldErrors = reactive({});


function validateDay(day) {
  let hasError = false;
  for (const meal of day.breakfasts.concat(day.lunches, day.dinners)) {
    if ((meal.name && !meal.price) || (!meal.name && meal.price)) {
      fieldErrors[meal.food_type + meal.variant] = t('event_settings.acc_food.meal_both_required');
      hasError = true;
    } else {
      fieldErrors[meal.food_type + meal.variant] = '';
    }
  }

  if ((day.breakfasts.concat(day.lunches, day.dinners).some(meal => meal.name || meal.price)) && !day.date) {
    fieldErrors['date' + day.date] = t('event_settings.acc_food.date_required_if_meals');
    hasError = true;
  } else {
    fieldErrors['date' + day.date] = '';
  }

  return hasError;
}

function validateAccommodation() {
  let hasError = false;
  accommodations.value.forEach((acc, index) => {
    const isNameFilled = !!acc.name;
    // Umožníme hodnotu 0, takže kontrolujeme null, undefined nebo prázdný řetězec
    const isPriceFilled = acc.price !== undefined && acc.price !== null && acc.price !== '';
    const isDateFromFilled = !!acc.date_from;
    const isDateToFilled = !!acc.date_to;

    // Pokud je vyplněn alespoň jeden z povinných údajů (název nebo cena),
    // musí být vyplněny všechny: název, cena, datum od a datum do.
    if (isNameFilled || isPriceFilled) {
      if (!(isNameFilled && isPriceFilled && isDateFromFilled && isDateToFilled)) {
        fieldErrors[`acc${index}`] = t('event_settings.acc_food.acc_all_required');
        hasError = true;
      } else {
        // date_to v modelu je o 1 den menší (UI ukazuje date_to + 1).
        // UI "Datum do" musí být > "Datum od" (ne stejné a ne menší).
        try {
          const from = parseISO(acc.date_from)
          const toUi = parseISO(shiftIso(acc.date_to, 1))
          if (!(toUi > from)) {
            fieldErrors[`acc${index}`] = t('event_settings.acc_food.acc_date_to_after_from');
            hasError = true;
          } else {
            fieldErrors[`acc${index}`] = '';
          }
        } catch {
          fieldErrors[`acc${index}`] = t('event_settings.acc_food.acc_date_to_after_from');
          hasError = true;
        }
      }
    } else {
      // Pokud nejsou vyplněny žádné údaje, necháme chybovou zprávu prázdnou.
      fieldErrors[`acc${index}`] = '';
    }
  });
  return hasError;
}



// Vytvoření nového dne pro vytvoření jídel
function createNewDay() {
  return {
    date: '',
    breakfasts: [
      { name: '', price: '', food_type: 'sn', variant: 1, type: 'food' },
      { name: '', price: '', food_type: 'sn', variant: 2, type: 'food' },
      { name: '', price: '', food_type: 'sn', variant: 3, type: 'food' },
      { name: '', price: '', food_type: 'sn', variant: 4, type: 'food' }
    ],
    lunches: [
      { name: '', price: '', food_type: 'ob', variant: 1, type: 'food' },
      { name: '', price: '', food_type: 'ob', variant: 2, type: 'food' },
      { name: '', price: '', food_type: 'ob', variant: 3, type: 'food' },
      { name: '', price: '', food_type: 'ob', variant: 4, type: 'food' }
    ],
    dinners: [
      { name: '', price: '', food_type: 've', variant: 1, type: 'food' },
      { name: '', price: '', food_type: 've', variant: 2, type: 'food' },
      { name: '', price: '', food_type: 've', variant: 3, type: 'food' },
      { name: '', price: '', food_type: 've', variant: 4, type: 'food' }
    ]
  };
}

// Načtení dat pro odeslání do api ve formátu date: lunces(), breakfasts(), dinners()
function prepareFoodData() {
  return days.value.map(day => ({
    date: day.date || null,
    breakfasts: day.breakfasts.map(b => ({ ...b, id: b.id || null, date: day.date || null })),
    lunches: day.lunches.map(l => ({ ...l, id: l.id || null, date: day.date || null })),
    dinners: day.dinners.map(d => ({ ...d, id: d.id || null, date: day.date || null }))
  }));
}


const other_service = ref([])
const si_rent = ref([])

// odeslání dat EntryServices do API se zobrazením chyb před odesláním, pokud nejsou vyplněná pole
const submitEntryService = async (deleteVariant = null) => {

  let hasErrors = false;
  // validace jídel
  days.value.forEach(day => {
    if (validateDay(day)) {
      hasErrors = true;
    }
  });

    // Validace ubytování
  if (validateAccommodation()) {
    hasErrors = true;
  }

  if (hasErrors) {
    console.error('Formulář obsahuje chyby a nemůže být odeslán.');
    return; // Ukončí funkci, pokud jsou chyby
  }

   // Připravíme data pro ubytování – pokud máme smazat variantu, tu vyfiltrujeme
   let accommodationsPayload = prepareAccommodationsData();
   if (deleteVariant !== null) {
    accommodationsPayload = accommodationsPayload.filter(acc => acc.variant !== deleteVariant);
  }

  const payload = {
    accommodations: accommodationsPayload,
    food: prepareFoodData(),
  };

  try {
    const eventId = route.params.id; // event ID z URL adresy
    await apiClient.post(`race_service/?event_id=${eventId}`, payload);
    
    snackbar.success(t('event_settings.acc_food.saved'));
    errorMessage.value = "";
    await fetchRaceServiceData();

    } catch (error) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (error.response && error.response.data && error.response.data.error) {
      errorMessage.value = error.response.data.error;
    } else {
      errorMessage.value = t('event_settings.acc_food.save_failed');
    }
  }
};

// Načtení Services pro event
async function fetchRaceServiceData() {
  const eventId = route.params.id;  // ID události z URL
  try {
    const response = await apiClient.get(`race_service/?event_id=${eventId}`);
    if (response.status === 200) {
      accommodations.value = processAccommodationData(response.data.accommodations);
      availableAccommodations.value = groupByDate(response.data.accommodations); // pro editaci entries
      setAccommodationDates(); // přednastavení datumů ze soutěže, pokuid se nenačetlo ubytování z API
      if (response.data.food && Object.keys(response.data.food).length > 0) {
        days.value = processFoodData(response.data.food);
        availableFood.value = groupFoodByDate(response.data.food); // pro editaci entries


      } else {
        days.value = [createNewDay()]; // Vytvoří prázdný den, pokud nejsou načtena žádná data o jídle
        availableFood.value = {};
      }

      // Načtení si_rent dat
      si_rent.value = response.data.si_rent.map(service => ({
        id: service.id,
        price: service.price,
      }));

      other_service.value = response.data.other || []
      
    } else {
      console.error('Failed to fetch data:', response.status);
    }
  } catch (error) {
    console.error('Error fetching Race Service data:', error);
  }
}

// Watcher na sledování event date start a end a inicializaci předvyplněných datumů v ubytování
watch(
  () => [event.value.event_date_start, event.value.event_date_end],
  () => {
    setAccommodationDates(); // Zajistíme aktualizaci datumů
  },
  { immediate: true }
);


// Zpracování ubytování z API na frontend
function processAccommodationData(accommodationsData) {
  const processedAccommodations = { // defaultně 4 varianty ubytování
    1: { id: null, name: '', price: '', limit: null, variant: '1', date_from: '', date_to: '', only_all_days: false, loadedFromAPI: false },
    2: { id: null, name: '', price: '', limit: null, variant: '2', date_from: '', date_to: '', only_all_days: false, loadedFromAPI: false },
    3: { id: null, name: '', price: '', limit: null, variant: '3', date_from: '', date_to: '', only_all_days: false, loadedFromAPI: false },
    4: { id: null, name: '', price: '', limit: null, variant: '4', date_from: '', date_to: '', only_all_days: false, loadedFromAPI: false }
  };

  accommodationsData.forEach(acc => {
    const variant = acc.variant || '1';  // Přiřazení varianty, pokud není specifikováno, použijeme '1'
    let variantData = processedAccommodations[variant];

    // Agregace dat do jedné varianty ubytování, vytvoření date from a date to
    if (!variantData.date_from || new Date(acc.date) < new Date(variantData.date_from)) {
      variantData.date_from = acc.date;
    }
    if (!variantData.date_to || new Date(acc.date) > new Date(variantData.date_to)) {
      variantData.date_to = acc.date;
    }
    variantData.id = acc.id;
    variantData.name = acc.name;
    variantData.price = acc.price;
    variantData.limit = acc.limit || null;  // null kvůli integer field
    variantData.type = "accommodation",
    variantData.only_all_days = acc.only_all_days;
    variantData.loadedFromAPI = true;  // Označení, že tato varianta byla načtena z API a zakáže se manipulace s daty
  });

  return Object.values(processedAccommodations);  // Vrátí pole s vždy čtyřmi variantami ubytování
}




// zpracování jídla tak, aby se rozdělilo a zobrazilo na 3 sloupce a více variantách
function processFoodData(foodData) {
  const dayList = [];
  for (const [date, meals] of Object.entries(foodData)) {
    dayList.push({
      date,
      breakfasts: fillMealsArray(meals.breakfasts, 4, 'sn'),
      lunches: fillMealsArray(meals.lunches, 4, 'ob'),
      dinners: fillMealsArray(meals.dinners, 4, 've')
    });
  }
  return dayList;
}

function fillMealsArray(meals, count, foodType) {
  let result = meals && meals.length > 0 ? meals : [];
  while (result.length < count) {
    result.push({ name: '', price: '', food_type: foodType, type: 'food', variant: result.length + 1 });
  }
  return result;
}


// Služby other dle key
const groupedOtherServices = computed(() => {
  const groups = {}
  other_service.value.forEach(svc => {
    const k = svc.key || `var_${svc.variant}`
    if (!groups[k]) groups[k] = []
    groups[k].push(svc)
  })
  Object.values(groups).forEach(arr => arr.sort((a,b)=>+a.variant - +b.variant))
  return groups
})



///////////////////////////////////
//////                     ////////                     ************
////// Správa přihlášených ////////                  *******************
//////                     ///////                      *************
///////////////////////////////////

 //////   Vytvoření Entry  //////

const isFormLoading = ref(false);


const dialogCreateEntryForm = ref(false);
const newEntry = ref({
  id: null,
  first_name: '',
  last_name: '',
  competitor_index: '',
  email: '',
  si_number: null,
  birth_year: null,
  competitor_gender: '',
  main_category_id: null,  // Kategorie pro hlavní soutěž
  race_categories: {},      // Kategorie pro jednotlivé etapy (races)
  race_services: [],         // Vybrané služby (ubytování, strava, atd.)
  start_preference: {},
  note: '',
  country: '',
  termin_prihl:'',
  competitor_club: null,
});

// Načtení dostupných kategorií, závodů a služeb
const gender = ref([{title: t('enums.gender.male'), value: 'M'}, {title: t('enums.gender.female'), value: 'F'}]);
const terminPrihlOptions = ref([{title: t('event.entry_deadline1_label'), value: '1'}, {title: t('event.entry_deadline2_label'), value: '2'}]);

const startGroups = ref([
  { text: t('enums.start_choice.0'), value: '0' },
  { text: t('enums.start_choice.1'), value: '1' },
  { text: t('enums.start_choice.2'), value: '2' },
  { text: t('enums.start_choice.3'), value: '3' },
  { text: t('enums.start_choice.4'), value: '4' }
]);


// Načtení hlavní kategorie z prvního závodu (race0)
const mainCategories = computed(() => {
  return race0.value && race0.value.categories ? race0.value.categories : [];
});


// Funkce na změnu výběru stravy
function onFoodChange(date, mealType, value) {
  if (mealType === 'breakfast') {
    if (value === null || value === false) {
      // Pokud je checkbox odškrtnutý, smažeme záznam
      delete selectedServices.breakfasts[date];
    } else {
      // Pokud je checkbox zaškrtnutý, přidáme hodnotu
      selectedServices.breakfasts[date] = value;
    }
  } else if (mealType === 'lunch') {
    if (value === null || value === false) {
      delete selectedServices.lunches[date];
    } else {
      selectedServices.lunches[date] = value;
    }
  } else if (mealType === 'dinner') {
    if (value === null || value === false) {
      delete selectedServices.dinners[date];
    } else {
      selectedServices.dinners[date] = value;
    }
  }
}

// Dočasné úložiště pro výběry
const selectedServices = reactive({
  accommodations: {},  // { [date]: accommodationId }
  breakfasts: {},      // { [date]: breakfastId }
  lunches: {},         // { [date]: lunchId }
  dinners: {},         // { [date]: dinnerId }
  si_rent: false,       // Půjčení SI čipu (true/false)
  other: {}
});


const eventId = route.params.id;

const filteredEntries = ref([]);
const isLoading = ref(false);  // Pro zobrazení stavu načítání
const selectedEntryId = ref(null);


// mapa indexu dne (0=NE ... 6=SO) na i18n klíče
const weekdayKey = (d) => {
  const idx = Number(format(d, 'i')) // 1=PO ... 7=NE
  switch (idx) {
    case 1: return 'enums.weekdays.mon'
    case 2: return 'enums.weekdays.tue'
    case 3: return 'enums.weekdays.wed'
    case 4: return 'enums.weekdays.thu'
    case 5: return 'enums.weekdays.fri'
    case 6: return 'enums.weekdays.sat'
    case 7: return 'enums.weekdays.sun'
    default: return 'enums.weekdays.mon'
  }
}

function accommodationDayRangeLabel(dateStr) {
  if (!dateStr) return ''
  const d1 = parseISO(dateStr)          // např. 2026-01-30
  const d2 = addDays(d1, 1)             // následující den
  return `${t(weekdayKey(d1))}–${t(weekdayKey(d2))}`
}


// Funkce pro zpracování změny ve vyhledávání jména/příjmení
const onlast_nameChange = async (searchText) => {
  if (searchText && searchText.trim().length >= 1) {
    try {
      isLoading.value = true;
      const response = await apiClient.get(`/event/${eventId}/entry/create/`, {
        params: { name: searchText.trim() }
      });
      filteredEntries.value = response.data; // Uložení výsledků z API
    } catch (error) {
      console.error('Chyba při volání API:', error);
    } finally {
      isLoading.value = false;
    }
  } else {
    // blur / vymazání search textu:
    // NEmazat list, pokud už je vybraný člověk (jinak se rozbije render title)
    if (!selectedEntryId.value) {
      filteredEntries.value = [];
    }
  }
};

// Watcher pro sledování změny ve vybraném ID a vyplnění formuláře
watch(selectedEntryId, (newId) => {
  if (newId) {
    const selectedEntry = filteredEntries.value.find(entry => entry.id === newId);
    if (selectedEntry) {
      // Naplnění formuláře vybranými daty
      newEntry.value.first_name = selectedEntry.first_name;
      newEntry.value.last_name = selectedEntry.last_name;
      newEntry.value.birth_year = selectedEntry.birth_year;
      newEntry.value.competitor_index = selectedEntry.competitor_index || "";
      newEntry.value.email = selectedEntry.email;
      newEntry.value.si_number = selectedEntry.si_number;
      newEntry.value.competitor_gender = selectedEntry.competitor_gender;
      newEntry.value.id = selectedEntry.id;
      newEntry.value.country = selectedEntry.country;
      newEntry.value.competitor_club = selectedEntry.competitor_club || null;

    }
  }
});

// Funkce pro získání zobrazení "last_name first_name" v autocomplete
const getFullName = (entry) => {
  const competitorIndex = entry.competitor_index || "";
  return `${entry.last_name} ${entry.first_name} ${competitorIndex}`;
};

// Definice pravidel
const rules = {
  last_nameRules: [v => !!v || t('rules.required')],
  firstNameRules: [v => !!v || t('rules.required')],
  mainCategoryRules: [v => !!v || t('rules.required')],
  emailRules: [v => (!v || /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(v)) || t('rules.invalid_email')]
};

// Chybové zprávy pro pole
const errors = reactive({
  last_name: [],
  first_name: [],
  main_category_id: [],
  email: []
});

// Funkce pro validaci a odeslání formuláře
const validateForm = () => {
  // Validace jednotlivých polí a ukládání chybových zpráv
  errors.last_name = rules.last_nameRules.map(rule => rule(newEntry.value.last_name)).filter(error => error !== true);
  errors.first_name = rules.firstNameRules.map(rule => rule(newEntry.value.first_name)).filter(error => error !== true);
  errors.main_category_id = rules.mainCategoryRules.map(rule => rule(newEntry.value.main_category_id)).filter(error => error !== true);
  errors.email = rules.emailRules.map(rule => rule(newEntry.value.email)).filter(error => error !== true);

  // Formulář je platný, pokud nejsou žádné chyby
  return !errors.last_name.length && !errors.first_name.length && !errors.main_category_id.length && !errors.email.length;
};

// Sledování změn ve formuláři a automatické skrytí chybových zpráv
watch(newEntry, (newValues) => {
  errors.last_name = rules.last_nameRules.map(rule => rule(newValues.last_name)).filter(error => error !== true);
  errors.first_name = rules.firstNameRules.map(rule => rule(newValues.first_name)).filter(error => error !== true);
  errors.main_category_id = rules.mainCategoryRules.map(rule => rule(newValues.main_category_id)).filter(error => error !== true);
  errors.email = rules.emailRules.map(rule => rule(newValues.email)).filter(error => error !== true);
}, { deep: true });

const submitEntry = async () => {

  if (!validateForm()) {
    console.log('Formulář obsahuje chyby');
    console.log(errors);
    return;
  }

  isFormLoading.value = true; // spuštění načítání požadavku

  try {
    // Přiřazení vybraných služeb ze selectedServices do newEntry.race_service
    newEntry.value.race_services = [];

    // Přidání ubytování
    Object.values(selectedServices.accommodations).forEach(accommodationId => {
      if (accommodationId) {
        newEntry.value.race_services.push(accommodationId);
      }
    });

    // Přidání stravy
    Object.values(selectedServices.breakfasts).forEach(breakfastId => {
      if (breakfastId) {
        newEntry.value.race_services.push(breakfastId);
      }
    });
    Object.values(selectedServices.lunches).forEach(lunchId => {
      if (lunchId) {
        newEntry.value.race_services.push(lunchId);
      }
    });
    Object.values(selectedServices.dinners).forEach(dinnerId => {
      if (dinnerId) {
        newEntry.value.race_services.push(dinnerId);
      }
    });

    // Přidání SI čipu, pokud je zaškrtnutý
    if (selectedServices.si_rent && si_rent.value.length > 0) {
      newEntry.value.race_services.push(si_rent.value[0].id);
    }

    Object.values(selectedServices.other)
      .filter(id => !!id)
      .forEach(id => newEntry.value.race_services.push(id))

     // Vytvoření payloadu pro přihlášku
    const entriesPayload = {
      races: [
        // Přidání hlavního závodu jako první položky do `races`
        {
          id: newEntry.value.id,
          race: race0.value.id, // Tady přidejte ID hlavního závodu
          competitor_club: newEntry.value.competitor_club,
          competitor_category: newEntry.value.main_category_id || null, // Hlavní kategorie
          first_name: newEntry.value.first_name,
          last_name: newEntry.value.last_name,
          competitor_index: newEntry.value.competitor_index,
          si_number: newEntry.value.si_number || null,
          termin_prihl: newEntry.value.termin_prihl || null,
          competitor_gender: newEntry.value.competitor_gender,
          birth_year: newEntry.value.birth_year || null,
          country: newEntry.value.country,
          start_preference: '', // Můžete přidat start group pro hlavní závod, pokud je potřeba
          note: newEntry.value.note || '',
          email: newEntry.value.email,
          race_services: newEntry.value.race_services,
        },
        // Přidání ostatních závodů
        ...races.value
          .filter(race => newEntry.value.race_categories[race.id]) // Pouze závody s vyplněnou kategorií
          .map(race => ({
            id: newEntry.value.id,
            race: race.id,
            competitor_club: newEntry.value.competitor_club,
            competitor_category: newEntry.value.race_categories[race.id] || null,
            first_name: newEntry.value.first_name,
            last_name: newEntry.value.last_name,
            competitor_index: newEntry.value.competitor_index,
            si_number: newEntry.value.si_number || null,
            termin_prihl: newEntry.value.termin_prihl || null,
            competitor_gender: newEntry.value.competitor_gender,
            birth_year: newEntry.value.birth_year || null,
            country: newEntry.value.country,
            start_preference: newEntry.value.start_preference[race.id] || '',
            note: newEntry.value.note || '',
            email: newEntry.value.email,
          })),
      ],
    };


    // Odeslání na backend jako jeden požadavek s races a race_service
    await apiClient.post(`event/${eventId}/entry/create/`, entriesPayload);

    // Uzavření dialogového okna po úspěšném odeslání
    dialogCreateEntryForm.value = false;
    snackbar.success(t('entry.create_success_anonymous'));
    // Resetování hodnot ve formuláři po úspěšném odeslání
    resetEntryForm();
    fetchEntries()
    fetchRaceServiceData();


    


  } catch (error) {

    console.error('Chyba při odesílání přihlášek:', error);

    if (error.response && (error.response.status === 423 || error.response.status === 409)) {
      // Kontrola, jestli error.response.data obsahuje error zprávu a nastavení errorMessage
      snackbar.error(error.response.data.error || error.response.data.message || error.response.data || t('errors.request_failed'));
    } else {
      snackbar.error(t('event_settings.send_entry_error'));
    }
  } finally {
    isFormLoading.value = false;
  }
};


// Funkce na resetování formuláře
function resetEntryForm() {
  // Resetování hodnot ve newEntry
  newEntry.value = {
    id: null, 
    first_name: '',
    last_name: '',
    competitor_index: '',
    competitor_club: null,
    email: '',
    si_number: null,
    birth_year: null,
    competitor_gender: '',
    main_category_id: null,
    race_categories: {},
    race_services: [],
    start_preference: {},
    note: '',
    country: 'CZE',
    termin_prihl: '',
  };

    // Resetování chybových zpráv
    Object.keys(errors).forEach(key => {
    errors[key] = [];
  });

  // Resetování hodnot v selectedServices
  selectedServices.accommodations = {};
  selectedServices.breakfasts = {};
  selectedServices.lunches = {};
  selectedServices.dinners = {};
  selectedServices.si_rent = false;
  selectedServices.other = {}


  // Resetování vyhledávacího pole
  selectedEntryId.value = null;
}

const entryCreateSource = ref('database');

const registeredUsersForm = computed(() => entryCreateSource.value === 'database');

watch(entryCreateSource, () => {
  resetEntryForm();
});


 //////   Konec vytvoření entry    ///////




// Načtení dostupných Role  ///

const rolesForEntries = ref([])
const selectedRoleId = ref(null)
const rolesLoading = ref(false)

const roleOptions = computed(() => [
  {
    value: null,
    label: '',
  },
  ...rolesForEntries.value.map(r => ({
    value: r.role_id, // = číslo role
    label: `${r.last_name} ${r.first_name} (${r.competitor_index || '-'})`,
  })),
])


const fetchRolesForEntries = async () => {
  try {
    rolesLoading.value = true
    const resp = await apiClient.get(`account/role/?list=true&race_id=${race0.value.id}&role_id=${selectedEntry.value.role || null}`)
    rolesForEntries.value = resp.data || []
  } catch (e) {
    console.error('Chyba při načítání rolí:', e)
  } finally {
    rolesLoading.value = false
  }
}


// Editace přihlášených uživatelů ///
const entries = ref([
  {
    id: '',
    last_name: '',
    first_name: '',
    si_number: null,
    category: '',
    note: ''
    },
  // Přidejte další položky podle potřeby
]);

const emails = ref([]);



// přiřazení ubytování uživatele k dostupným ubytováním v soutěži
function initializeAccommodationData() {
  if (!selectedEntry.value.accommodation) {
    selectedEntry.value.accommodation = {};
  }
  Object.keys(availableAccommodations.value).forEach(date => {
    // Přiřazení již vybraných ubytování na základě ID z `selectedEntry.race_service`
    const selectedAccommodations = availableAccommodations.value[date].filter(acc => selectedEntry.value.race_service.includes(acc.id));
    selectedEntry.value.accommodation[date] = selectedAccommodations.map(acc => acc.id);
  });
}

// přiřřazení stravy uživatele ke stravě, která je v soutěži k dispozici
function initializeFoodData() {
  if (!selectedEntry.value.food) {
    selectedEntry.value.food = {};
  }
  Object.keys(availableFood.value).forEach(date => {
    if (!selectedEntry.value.food[date]) {
      selectedEntry.value.food[date] = { breakfasts: [], lunches: [], dinners: [] };
    }
    const selectedBreakfasts = availableFood.value[date].breakfasts.filter(food => selectedEntry.value.race_service.includes(food.id));
    const selectedLunches = availableFood.value[date].lunches.filter(food => selectedEntry.value.race_service.includes(food.id));
    const selectedDinners = availableFood.value[date].dinners.filter(food => selectedEntry.value.race_service.includes(food.id));

    selectedEntry.value.food[date].breakfasts = selectedBreakfasts.map(food => food.id);
    selectedEntry.value.food[date].lunches = selectedLunches.map(food => food.id);
    selectedEntry.value.food[date].dinners = selectedDinners.map(food => food.id);
  });
}


const allRaces = ref([]);

const getEntryRaceData = (entry, raceId) => {
  let raceData = entry.entry_race_data.find(data => data.race_id === raceId);
  if (!raceData) {
    raceData = { race_id: raceId, category_id: null, si_number: null };
    entry.entry_race_data.push(raceData);
  }
  return raceData;
};



const selectedOther = ref({})
const dialogEditEntry = ref(false);

const openEditDialog = async (entry) => {

  selectedEntry.value = {
    ...entry,
    termin_prihl: entry.termin_prihl,
    entry_race_data: entry.entry_race_data.map(d => ({ ...d })),
    role: entry.role ?? null,
  }

  // načti seznam rolí
  await fetchRolesForEntries()
  
  // předvybraná role v selectu
  selectedRoleId.value = entry.role ?? null

  initializeAccommodationData();
  initializeFoodData();

  // Načtení other services
  Object.entries(groupedOtherServices.value).forEach(([key, variants]) => {
    // defaultně null (nevybráno)
    selectedOther.value[key] = null

    // pokud už je v race_service ID některé varianty:
    const already = variants.find(v => selectedEntry.value.race_service.includes(v.id))
    if (already) {
      selectedOther.value[key] = already.id
    }
  })


  dialogEditEntry.value = true;
};

const dialogDeleteEntry = ref(false);
const openDeleteDialog = (entry) => {
  selectedEntry.value = entry;

  dialogDeleteEntry.value = true;
};



const sortByEntries = [{ key: 'last_name', order: 'asc' }]; // Klíč pro řazení

const selectedEntry = ref(null);

const entryHeaders = ref([
  { title: t('event_settings.entries.headers.last_name'), value: 'last_name', sortable: true},
  { title: t('event_settings.entries.headers.first_name'), value: 'first_name', sortable: true },
  { title: t('event_settings.entries.headers.index'), value: 'competitor_index', sortable: true },
  { title: t('event_settings.entries.headers.si_number'), value: 'si_number', sortable: true },
  { title: t('event_settings.entries.headers.category'), value: 'category_name', sortable: true },
  { title: t('event_settings.entries.headers.deadline'), value: 'termin_prihl', sortable: true, width: '20px' },
  { title: t('event_settings.entries.headers.timestamp'), value: 'timestamp', sortable: true, width: '180px' },
  { title: t('event_settings.entries.note'), value: 'note', sortable: true, width: '200px' },
  { title: t('event_settings.entries.headers.actions'), value: 'actions', sortable: false, width: '100px', align: 'center' }
]);




const availableAccommodations = ref([]);

// Funkce pro seskupení ubytování podle dat
function groupByDate(accommodations) {
  const grouped = {};
  accommodations.forEach(accommodation => {
    if (!grouped[accommodation.date]) {
      grouped[accommodation.date] = [];
    }
    grouped[accommodation.date].push(accommodation);
  });
  return grouped;
}

const availableFood = ref({});

function groupFoodByDate(foodItems) {
  return Object.entries(foodItems).reduce((grouped, [date, meals]) => {
    grouped[date] = {
      breakfasts: meals.breakfasts?.filter(food => food.price !== "") || [],
      lunches: meals.lunches?.filter(food => food.price !== "") || [],
      dinners: meals.dinners?.filter(food => food.price !== "") || []
    };
    return grouped;
  }, {});
}

// Funkce pro resetování vyhledávání
const resetSearch = () => {
  searchSurname.value = '';
  fetchEntries();
};

const searchSurname = ref('');
const isLoadingEntries = ref(true);


const fetchEntries = async () => {
  const eventId = route.params.id;

  try {
    let query = `entries/?event_id=${eventId}`;
    if (searchSurname.value) {
      query += `&name=${encodeURIComponent(searchSurname.value)}`;
    }
    const response = await apiClient.get(query);
    emails.value = response.data.map(entry => entry.email);
    entries.value = response.data.map(entry => {
      allRaces.value.forEach(race => {
        if (!entry.entry_race_data.some(data => data.race_id === race.id)) {
          entry.entry_race_data.push({
            race_id: race.id,
            category_id: null,
            category_name: "unreg",
            isUnregistered: true,
            si_number: null
          });
        }
      });
      entry.entry_race_data.sort((a, b) => {
        if (a.isUnregistered && !b.isUnregistered) return -1
        if (!a.isUnregistered && b.isUnregistered) return 1
        return (a.category_name || '').localeCompare(b.category_name || '')
      })
      return entry;
    });

  } catch (error) {
    console.error("Error fetching entries:", error);
  } finally {
    isLoadingEntries.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }
};




// Počáteční stav si_rent checkboxu
const siRentChecked = computed({
  get() {
    return selectedEntry.value && si_rent.value[0].id && selectedEntry.value.race_service.includes(si_rent.value[0].id);
  },
  set(value) {
    if (value) {
      // Přidá si_rent ID do race_service, pokud je checkbox zaškrtnutý
      if (!selectedEntry.value.race_service.includes(si_rent.value[0].id)) {
        selectedEntry.value.race_service.push(si_rent.value[0].id);
      }
    } else {
      // Odstraní si_rent ID z race_service, pokud není checkbox zaškrtnutý
      selectedEntry.value.race_service = selectedEntry.value.race_service.filter(id => id !== si_rent.value[0].id);
    }
  }
});


// uložení emailů do schránky počítače
const saveEmailsToClipboard = async () => {
  await fetchEntries(); // Fetch the entries first

  // Filtrovat emaily, které neobsahují 'rob-is.cz' a nejsou prázdné
  const filteredEmails = emails.value.filter(email => email && !email.includes('rob-is.cz'));

  const emailString = filteredEmails.join(', ');
  navigator.clipboard.writeText(emailString).then(() => {
    console.log('Emails copied to clipboard:', emailString);
    snackbar.success(t('event_settings.entries.copy_emails_success' ));
  }).catch(err => {
    console.error('Failed to copy emails to clipboard:', err);
  });
};


// Sledování změny v Entry Role a aktualizace selectedEntry
watch(selectedRoleId, (id) => {
  if (!selectedEntry.value) return

  // nepřiřazený účet
  if (id === null) {
    selectedEntry.value.role = null
    selectedEntry.value.competitor_index = ''
    selectedEntry.value.competitor_club = null
    return
  }

  const r = rolesForEntries.value.find(x => x.role_id === id)
  if (!r) return

  // Tohle chceš do entry posílat do API:
  selectedEntry.value.role = r.role_id                
  selectedEntry.value.competitor_index = r.competitor_index || ''
  selectedEntry.value.competitor_club = r.competitor_club ?? null  
})



const editEntry = async () => {
  try {
    isFormLoading.value = true; // spuštění načítání požadavku

    // Filtrujeme pouze ty závodní data, které mají vyplněnou kategorii
    selectedEntry.value.entry_race_data = selectedEntry.value.entry_race_data.filter(data => data.category_id !== null);

     // Sestavení seznamu ID ubytování z objektu accommodation pro každý den
    const accommodationIds = Object.values(selectedEntry.value.accommodation).flat().filter(id => id !== null);

    // Sestavení seznamu ID stravy z objektu food pro každý den
    const foodIds = Object.values(selectedEntry.value.food).flatMap(day =>
      ['breakfasts', 'lunches', 'dinners'].flatMap(mealType => {
        const val = day[mealType]
        if (val == null || val === '') return []
        return Array.isArray(val) ? val : [val]
      })
    ).filter(id => id !== null);

    // Kombinace ID ubytování, stravy a si_rent do race_service
    const raceServiceIds = [...accommodationIds, ...foodIds];

    // Přidání půjčení čipu do raceservices_id, pokud je to vybráno
    if (siRentChecked.value) {
      raceServiceIds.push(si_rent.value[0].id);
    }

    // OTHER služby
    Object
      .values(selectedOther.value)
      .filter(id => !!id)         // jen nenulové
      .forEach(id => raceServiceIds.push(id))

    // Příprava payloadu pro odeslání na server
    const payload = {
      ...selectedEntry.value,
      role: selectedEntry.value.role ?? null,
      competitor_index: selectedEntry.value.competitor_index ?? '',
      competitor_club: selectedEntry.value.competitor_club ?? null,
      termin_prihl: selectedEntry.value.termin_prihl,
      race_service: raceServiceIds  // Přidání aktualizovaného seznamu race_service
    };

    await apiClient.put(`entries/?entry_id=${selectedEntry.value.id}`, payload);
    fetchEntries();
    fetchRaceServiceData();

    snackbar.success(t('event_settings.entries.entry_updated'));
    dialogEditEntry.value = false;
  } catch (error) {
    console.error("There was an error updating the entry:", error);
    if (error.response && error.response.status === 423) {
      snackbar.error(error.response.data.error);
    } else {
      snackbar.error(t('event_settings.entries.entry_updated_error'));
    }
    dialogEditEntry.value = true;
  } finally {
    isFormLoading.value = false;
  }
};


const deleteEntry = async () => {
  try {
    await apiClient.delete(`entries/?entry_id=${selectedEntry.value.id}`);
    fetchEntries();
    snackbar.success(t('event_settings.entries.entry_deleted'));
    dialogDeleteEntry.value = false;
  } catch (error) {
    console.error("There was an error deleting the entry:", error);
    snackbar.error(t('event_settings.entries.entry_deleted_error'));
    dialogDeleteEntry.value = false;

  }
};

const accommodationVariants = computed(() => {
  const variants = {};
  Object.values(availableAccommodations.value).forEach(dateAccommodations => {
    dateAccommodations.forEach(accommodation => {
      if (!variants[accommodation.variant]) {
        variants[accommodation.variant] = {
          variant: accommodation.variant,
          count: accommodation.count,
          limit: accommodation.limit
        };
      }
    });
  });
  return Object.values(variants).filter(variant => variant.count > 0);
});



const loadingSubmit = ref(false); //logika pro ukázání načítání po odeslání nebo nahrání results / startlist

///////////////////////////////////
//////                     ////////                     ************
//////   Správa startovek  ////////                  *******************
//////                     ///////                      *************
///////////////////////////////////

const dialogAddStartlist = ref(false);
const uploadedStartlistFile = ref(null);
const errorStartlistMessage = ref('');
const errorStartlistSendMessage = ref('');
const errorStartlistSelectMessage = ref('');

const isFileValid = ref(false);
const successStartlistMessage = ref('');
const stepStart = ref(1);
const totalStartSteps = 2;

const StartlistSortBy = [{key: 'category_name', order: 'asc'}]; // Klíč pro řazení

const startlist = ref([]);
const isLoadingStartlist = ref(true);

const exportGpsCsos = () => {
  const def = 33
  const input = window.prompt('Zadej počáteční číslo v číslování GPS jednotek:', String(def))
  if (input === null) return // zrušeno

  const start = Number(input)
  if (!Number.isFinite(start) || start < 1) {
    alert('Zadej platné kladné číslo.')
    return
  }
  const url = `${BaseUrl.value}/export/?type=csv&name=gps_csos&race_id=${currentRaceId.value}&start=${encodeURIComponent(start)}`
  window.location.href = url
}

const startlistStepperItems = computed(() => {
  void locale.value
  return [
    t('event_settings.startlist.stepper_upload'),
    t('event_settings.startlist.stepper_checks'),
  ]
})

const GetStartlistHeaders = ref([

      { title: t('event_settings.startlist.last_name'), value: 'last_name', sortable: true },
      { title: t('event_settings.startlist.first_name'), value: 'first_name', sortable: true },
      { title: t('event_settings.startlist.start_time'), value: 'competitor_start_time', sortable: true },
      { title: t('event_settings.startlist.category'), value: 'category_name', sortable: true },
      { title: t('event_settings.startlist.index'), value: 'competitor_index', sortable: true },
      { title: t('event_settings.startlist.si_number'), value: 'si_number', sortable: true },
      { title: t('event_settings.startlist.club'), value: 'club_shortcut', sortable: true },
      { title: t('event_settings.startlist.actions'), value: 'actions', width: '100px', align: 'center', sortable: false },

    ]);

const fetchStartlist = async () => {
    isLoadingStartlist.value = true;
    try {
      const response = await apiClient.get(`/startlist/?race_id=${currentRaceId.value}`);
      startlist.value = response.data;
    } catch (error) {
      console.error('Chyba při načítání dat:', error);
    } finally {
      isLoadingStartlist.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }


  };



const startlistHeaders = [
  { title: t('event_settings.startlist.start_number_short'), value: 'start_number', sortable: true, width: '90px', align: 'center' },
  { title: t('event_settings.startlist.last_name'), value: 'last_name', sortable: true },
  { title: t('event_settings.startlist.first_name'), value: 'first_name', sortable: true },
  { title: t('event_settings.startlist.start_time_relative'), value: 'start_time_relative', sortable: true },
  { title: t('event_settings.startlist.start_time_real'), value: 'start_time_real', sortable: true },
  { title: t('event_settings.startlist.index'), value: 'competitor_index', align: 'center', sortable: true },
  { title: t('event_settings.startlist.category_short'), value: 'competitor_category', sortable: true },
  { title: t('event_settings.startlist.si_number_short'), value: 'si_number', sortable: true },
  { title: t('event_settings.startlist.actions'), value: 'actions', width: '100px', align: 'center', sortable: false },
];

function openStartlistStepperDialog() {
  dialogAddStartlist.value = true;
}

const selectedStartlistFileType = ref(null);


// validace, že je vybraný typ a že přípona souboru sedí v nahrávání Startlist
const validateSelectedStartlistFileType = () => {
  if (!selectedStartlistFileType.value) {
    errorStartlistSelectMessage.value = t('event_settings.startlist.choose_type');
    isFileValid.value = false;
  } else {
    errorStartlistSelectMessage.value = '';
    // tlačítko povoleno až když je vybraný i soubor
    isFileValid.value = !!uploadedStartlistFile.value;
  }
};


const validateSelectedFileType = () => {
  if (!selectedFileType.value) {
    errorResultsSelectMessage.value = t('event_settings.startlist.choose_type');
    isResultsFileValid.value = false;
  } else {
    errorResultsSelectMessage.value = ''; // Chyba je odstraněna
    isResultsFileValid.value = !!uploadedResultsFile.value; // Validace závisí na obou polích
  }
};


// po změně selectu validuj
watch(selectedStartlistFileType, validateSelectedStartlistFileType);

// zpracování nahraného souboru
const handleFileUpload = (e) => {
  uploadedStartlistFile.value = e.target.files[0];
  validateSelectedStartlistFileType();
};


const startlistEntryOk = ref([]);
const startlistEntryCreate = ref([]);
const startlistEntryEmpty = ref([]);
const combinedStarts = ref([]);

const updateCombinedStarts = () => {
  combinedStarts.value = [
    ...startlistEntryOk.value,
    ...startlistEntryCreate.value,
    ...startlistEntryEmpty.value,
  ];
  console.log('Updated combinedStarts:', combinedStarts.value); // Debugging
};

const selectedStart = ref(null);
const dialogEditStart = ref(false);
const dialogDeleteStart = ref(false);

// převod mm:ss na hh:mm:ss aby se to zobrazilo v input field type=time
const convertToTimeFormat = (timeString) => {
  if (!timeString) return '';

  const parts = timeString.split(':');

  if (parts.length === 1) {
    // Formát je jen minuty (např. 125)
    const minutes = parseInt(parts[0], 10);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
  } else if (parts.length === 2) {
    // Formát je MM:SS (např. 125:30)
    const minutes = parseInt(parts[0], 10);
    const seconds = parseInt(parts[1], 10);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  return timeString; // Pokud je už ve správném formátu HH:MM:SS
};

// převod hh:mm:ss na mm:ss
const convertToApiFormat = (timeString) => {
  if (!timeString) return '';

  const parts = timeString.split(':');
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parts.length === 3 ? parseInt(parts[2], 10) : 0;

  // Pokud jsou hodiny přítomné, převedeme na celkové minuty
  const totalMinutes = hours * 60 + minutes;

  if (seconds > 0) {
    return `${totalMinutes}:${String(seconds).padStart(2, '0')}`;
  } else {
    return String(totalMinutes);
  }
};


// Funkce pro formátování času do HH:MM:SS
const formatTime = (timeString) => {
  if (!timeString) return ''; // Pokud není čas k dispozici, vraťte prázdný řetězec

  // Rozdělení časového řetězce na hodiny, minuty a sekundy
  const [hours, minutes, seconds] = timeString.split(':');

  // Ujistěte se, že jsou hodiny a minuty ve správném formátu (dvouciferné)
  const formattedTime = [
    hours.padStart(2, '0'),
    minutes.padStart(2, '0'),
    seconds ? seconds.padStart(2, '0') : '00'  // Zajistí, že sekundy budou také dvouciferné nebo doplněné nulou
  ].join(':');

  return formattedTime; // Vraťte čas ve formátu HH:MM:SS
};

const openEditStartDialog = (start) => {
  selectedStart.value = {
    ...start,
    start_time_real: formatTime(start.start_time_real),
    start_time_relative: convertToTimeFormat(start.start_time_relative)
  };
  dialogEditStart.value = true;
};


const saveEditStart = () => {

  // převod naformátovaných dat na mm:ss do api
  const formattedRelativeTime = convertToApiFormat(selectedStart.value.start_time_relative);
  // Nastavení formátovaných hodnot
  selectedStart.value.start_time_relative = formattedRelativeTime;

  let startIndex = -1;

  // Vyhledání podle indexu, pokud existuje
  if (selectedStart.value.competitor_index) {
    startIndex = combinedStarts.value.findIndex(
      (item) => item.competitor_index === selectedStart.value.competitor_index
    );
  }

  // Pokud index neexistuje nebo nebyl nalezen, vyhledání podle kombinace jména a příjmení
  if (startIndex === -1) {
    startIndex = combinedStarts.value.findIndex(
      (item) =>
        item.first_name.toLowerCase() === selectedStart.value.first_name.toLowerCase() &&
        item.last_name.toLowerCase() === selectedStart.value.last_name.toLowerCase()
    );
  }

  // Pokud byl záznam nalezen, aktualizujeme data
  if (startIndex !== -1) {
    combinedStarts.value[startIndex] = { ...selectedStart.value };

    // Aktualizace jednotlivých seznamů
    startlistEntryOk.value = combinedStarts.value.filter((item) =>
      startlistEntryOk.value.some(
        (okItem) => okItem.competitor_index === item.competitor_index ||
        (okItem.first_name.toLowerCase() === item.first_name.toLowerCase() &&
         okItem.last_name.toLowerCase() === item.last_name.toLowerCase())
      )
    );

    startlistEntryCreate.value = combinedStarts.value.filter((item) =>
      startlistEntryCreate.value.some(
        (createItem) => createItem.competitor_index === item.competitor_index ||
        (createItem.first_name.toLowerCase() === item.first_name.toLowerCase() &&
         createItem.last_name.toLowerCase() === item.last_name.toLowerCase())
      )
    );

    startlistEntryEmpty.value = combinedStarts.value.filter((item) =>
      startlistEntryEmpty.value.some(
        (emptyItem) => emptyItem.competitor_index === item.competitor_index ||
        (emptyItem.first_name.toLowerCase() === item.first_name.toLowerCase() &&
         emptyItem.last_name.toLowerCase() === item.last_name.toLowerCase())
      )
    );
  }

  // Zavření dialogu po uložení
  dialogEditStart.value = false;
};


const openDeleteStartDialog = (start) => {
  selectedStart.value = start;
  dialogDeleteStart.value = true;
};

const deleteStart = () => {
  let startIndex = combinedStarts.value.findIndex(
  (item) => item.competitor_index === selectedStart.value.competitor_index
);
  // Pokud nenalezen podle `competitor_index`, hledáme podle jména a příjmení
  if (startIndex === -1) {
    startIndex = combinedStarts.value.findIndex(
      (item) =>
        item.first_name.toLowerCase() === selectedStart.value.first_name.toLowerCase() &&
        item.last_name.toLowerCase() === selectedStart.value.last_name.toLowerCase()
    );
  }
  // Smazání, pokud byl záznam nalezen
  if (startIndex !== -1) {
    combinedStarts.value.splice(startIndex, 1);
    startlistEntryOk.value = combinedStarts.value.filter(
      (item) => startlistEntryOk.value.some(okItem => okItem.competitor_index === item.competitor_index)
    );
    startlistEntryCreate.value = combinedStarts.value.filter(
      (item) => startlistEntryCreate.value.some(createItem => createItem.competitor_index === item.competitor_index)
    );
    startlistEntryEmpty.value = combinedStarts.value.filter(
      (item) => startlistEntryEmpty.value.some(emptyItem => emptyItem.competitor_index === item.competitor_index)
    );
  }
  dialogDeleteStart.value = false;
};



// Funkce pro nahrání souboru a zpracování do response k editaci
const stageNeedsRaceStart = () => !currentRace.value?.race_start;

const isRaceStartMissingError = (error) => {
  const payload = error?.response?.data?.error;
  if (!payload) return false;
  const text = Array.isArray(payload) ? payload.join(' ') : String(payload);
  return /start\s*00|start 00/i.test(text);
};

const openRaceStartDialog = (context) => {
  raceStartDialogContext.value = context;
  raceStartDialogTime.value = '';
  dialogRaceStartMissing.value = true;
};

const uploadStartlistFile = async () => {
  if (stageNeedsRaceStart()) {
    pendingStartlistUploadAfterRaceStart.value = true;
    openRaceStartDialog('startlist');
    return;
  }

  loadingSubmit.value = true;
  if (uploadedStartlistFile.value) {
    const formData = new FormData();
    formData.append('file', uploadedStartlistFile.value);

    try {
      const response = await apiClient.post(`startlist/?race_id=${currentRaceId.value}&name=${selectedStartlistFileType.value}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      successStartlistMessage.value = t('event_settings.startlist.upload_success');
      errorStartlistMessage.value = '';

      // Zpracování dat z response
      startlistEntryOk.value = response.data.startlist_entry_ok;
      startlistEntryCreate.value = response.data.startlist_entry_create;
      startlistEntryEmpty.value = response.data.startlist_entry_empty;

      loadingSubmit.value = false;
      updateCombinedStarts(); // Aktualizace tabulky po načtení dat

    } catch (error) {
      console.error('Chyba při nahrávání souboru:', error);

      if (isRaceStartMissingError(error)) {
        errorStartlistMessage.value = '';
        pendingStartlistUploadAfterRaceStart.value = true;
        openRaceStartDialog('startlist');
      } else if (error.response && error.response.status === 406) {
        errorStartlistMessage.value = `Chyba: ${error.response.data.error}`;
      } else if (error.response) {
        errorStartlistMessage.value = `Chyba: ${error.response.data.error || t('event_settings.startlist.upload_error')}`;
      } else {
        errorStartlistMessage.value = t('event_settings.startlist.upload_error');
      }

      successStartlistMessage.value = '';
      loadingSubmit.value = false;
    }
  }
};

// Objekt pro uložení barev přiřazených řádkům při jejich inicializaci
const rowColors = ref({});

const setRowProps = ({ item }) => {
  const itemIndex = item.competitor_index || ''; // Získání hodnoty indexu
  const itemName = `${item.last_name.toLowerCase()} ${item.first_name.toLowerCase()}`; // Kombinace příjmení a jména

  // Pokud již existuje barva pro daný řádek, vraťte ji
  if (rowColors.value[itemIndex] || rowColors.value[itemName]) {
    return { class: rowColors.value[itemIndex] || rowColors.value[itemName] };
  }

  console.log('Checking row props for:', itemIndex, itemName);

  let rowClass = '';

  if (itemIndex) {
    // Pokud je přítomný index, kontrolujeme podle indexu
    if (startlistEntryOk.value.some(okItem => okItem.competitor_index === itemIndex)) {
      rowClass = 'bg-ok';
    } else if (startlistEntryCreate.value.some(createItem => createItem.competitor_index === itemIndex)) {
      rowClass = 'bg-create';
    } else if (startlistEntryEmpty.value.some(emptyItem => emptyItem.competitor_index === itemIndex)) {
      rowClass = 'bg-empty';
    }
    rowColors.value[itemIndex] = rowClass; // Uložení barvy pro tento řádek podle indexu
  } else {
    // Pokud index není přítomný, kontrolujeme podle kombinace příjmení a jména
    if (startlistEntryOk.value.some(okItem => `${okItem.last_name.toLowerCase()} ${okItem.first_name.toLowerCase()}` === itemName)) {
      rowClass = 'bg-ok';
    } else if (startlistEntryCreate.value.some(createItem => `${createItem.last_name.toLowerCase()} ${createItem.first_name.toLowerCase()}` === itemName)) {
      rowClass = 'bg-create';
    } else if (startlistEntryEmpty.value.some(emptyItem => `${emptyItem.last_name.toLowerCase()} ${emptyItem.first_name.toLowerCase()}` === itemName)) {
      rowClass = 'bg-empty';
    }
    rowColors.value[itemName] = rowClass; // Uložení barvy pro tento řádek podle kombinace příjmení a jména
  }

  return { class: rowClass };
};


const closeStartlistDialog = () => {
  dialogAddStartlist.value = false;
  errorStartlistMessage.value = '';
  errorStartlistSendMessage.value = '';
  pendingStartlistUploadAfterRaceStart.value = false;
};

// odeslání JSON pro uložení startů
const saveStartData = async () => {
  loadingSubmit.value = true;
  try {
    await apiClient.post(
      `startlist/?race_id=${currentRaceId.value}&valid=True`,
      JSON.stringify(combinedStarts.value),  // Převod dat na JSON formát
      {
        headers: {
          'Content-Type': 'application/json',  // Nastavení správné hlavičky
        },
      }
    );

    snackbar.success(t('event_settings.startlist.startlist_upload_success'));
    errorStartlistSendMessage.value = ""
    dialogAddStartlist.value = false;  // Zavřít dialog po úspěšném odeslání
    combinedStarts.value = [];  // Vynulovat obsah combinedStarts po úspěšném uložení
    rowColors.value = {}; // Resetování barev při úspěšném odeslání
    successStartlistMessage.value = '';

    fetchEntries();
    fetchStartlist();

  } catch (error) {
    console.error('Chyba při odesílání dat:', error);

    // Kontrola kódu 406 a zobrazení specifické chyby
    if (error.response && error.response.status === 406 && error.response.data && Array.isArray(error.response.data.error)) {
      errorStartlistSendMessage.value = error.response.data.error; // Přiřadit celé pole chybových zpráv
      console.log('Error message:', errorStartlistSendMessage.value);
    } else {
      errorStartlistSendMessage.value = [`${t('event_settings.startlist.startlist_upload_error')} ${error.response.data.error}`]; // Přiřadit jako pole
      console.log('Error message:', errorStartlistSendMessage.value);
    }
  } finally {
    loadingSubmit.value = false;
  }
};


const dialogDeleteAllStartTimes = ref(false);

// Funkce pro otevření dialogu pro smazání všech start_time
const openDeleteAllStartTimesDialog = () => {
  dialogDeleteAllStartTimes.value = true;
};

// Funkce pro mazání všech start_time
const deleteAllStartTimes = async () => {
  try {
    await apiClient.delete(`/startlist/?race_id=${currentRaceId.value}`);
    dialogDeleteAllStartTimes.value = false;
    snackbar.success(t('event_settings.startlist.delete_all_success'));
    fetchStartlist(); // Obnovit startovní listinu po smazání
  } catch (error) {
    console.error('Chyba při mazání startovních časů:', error);
    snackbar.error(t('event_settings.startlist.delete_all_error'));
  }
};


// Funkce pro otevření dialogu pro mazání jednoho startu
const openDeleteGetStartDialog = (start) => {
  selectedStart.value = start;
  dialogDeleteStart.value = true;
};


// Funkce pro mazání jednoho start_time podle competitor_id
const deleteGetStart = async () => {
  try {
    await apiClient.delete(`/startlist/?race_id=${currentRaceId.value}&competitor_id=${selectedStart.value.competitor}`);
    dialogDeleteStart.value = false;

    snackbar.success(t('event_settings.startlist.delete_success'));
    fetchStartlist(); // Obnovit startovní listinu po smazání
  } catch (error) {
    console.error('Chyba při mazání startovního času:', error);
    snackbar.error(t('event_settings.startlist.delete_error'));
    dialogDeleteStart.value = false;
  }
};






///////////////////////////////////
//////                     ////////                     ************
//////   Správa výsledků   ////////                  *******************
//////                     ///////                      *************
///////////////////////////////////


const dialogEditResult = ref(false);

const successResultsMessage = ref('');
const stepResults = ref(1);
const totalResultsSteps = 3;
const selectedResult = ref(null);
const dialogDeleteResult = ref(false);

// Funkce pro otevření dialogu pro mazání jednoho výsledku v seznamu na stránce 
const openDeleteGetResultDialog = (start) => {
  selectedResult.value = start;
  dialogDeleteResult.value = true;
};


const resultsStepperItems = computed(() => {
  void locale.value // „dotknu se“ locale, aby se to přepočítalo při změně jazyka
  return [
    t('event_settings.results.stepper_upload'),   // Nahraj výsledky
    t('event_settings.results.stepper_checks'),   // Kontroly
    t('event_settings.results.stepper_results'),  // Výsledky
  ]
})


// Funkce pro mazání jednoho start_time podle competitor_id
const deleteGetResult = async () => {
  try {
    await apiClient.delete(`/results/?race_id=${currentRaceId.value}&competitor_id=${selectedResult.value.competitor_id}`);
    dialogDeleteResult.value = false;
    snackbar.success(t('event_settings.results.delete_success'));
    fetchResults(); // Obnovit startovní listinu po smazání
  } catch (error) {
    console.error('Chyba při mazání výsledku:', error);
    snackbar.error(t('event_settings.results.result_delete_error'));
    dialogDeleteResult.value = false;
  }
};


const GetResultsHeaders = ref([
  { title: t('event_settings.results.place_short'), value: 'place', width: '60px', align: 'center', sortable: true },
  { title: t('event_settings.results.last_name'), value: 'last_name', sortable: true },
  { title: t('event_settings.results.first_name'), value: 'first_name', sortable: true },
  { title: t('event_settings.results.index'), value: 'competitor_index', sortable: true },
  { title: t('event_settings.results.category_short'), value: 'competitor_category_name', sortable: true },
  { title: t('event_settings.results.run_time'), value: 'run_time', sortable: true },
  { title: t('event_settings.results.result_status'), value: 'result_status', sortable: true },
  { title: t('event_settings.results.punch_count_short'), value: 'punch_count', width: '60px', sortable: true },
  { title: t('event_settings.results.actions'), value: 'actions', width: '100px', align: 'center', sortable: false },

]);

const ResultsSortBy = [{key: 'competitor_category_name', order: 'asc'}]; // Klíč pro řazení

const resultsHeaders = [
  { title: t('event_settings.results.place_short'), value: 'place', width: '60px', align: 'center', sortable: true },
  { title: t('event_settings.results.last_name'), value: 'last_name', sortable: true },
  { title: t('event_settings.results.first_name'), value: 'first_name', sortable: true },
  { title: t('event_settings.results.category_short'), value: 'competitor_category_name', sortable: true },
  { title: t('event_settings.results.index'), value: 'competitor_index', align: 'center', sortable: true },
  { title: t('event_settings.results.run_time'), value: 'run_time', sortable: true },
  { title: t('event_settings.results.actions'), value: 'actions', width: '100px', align: 'center', sortable: false },
];

const dialogAddResults = ref(false);


const errorResultsMessage = ref('');
const errorResultsSendMessage = ref('');

const closeResultsDialog = () => {
  dialogAddResults.value = false;
  errorResultsMessage.value = '';
  errorResultsSendMessage.value = '';
  pendingRaceStart.value = null;
  shouldSaveRaceStart.value = false;
  dialogRaceStartMissing.value = false;
  raceStartDialogTime.value = '';
};


const skipRaceStartDialog = () => {
  dialogRaceStartMissing.value = false;
  raceStartDialogTime.value = '';
};

const cancelRaceStartDialog = () => {
  dialogRaceStartMissing.value = false;
  raceStartDialogTime.value = '';
  pendingStartlistUploadAfterRaceStart.value = false;
  loadingSubmit.value = false;
};

const absoluteStartToRelative = (absValue, raceStartIso, raceDate) => {
  if (!absValue || !raceStartIso) return null;
  const day = (raceDate || '').split('T')[0];
  const toMs = (val) => {
    const s = String(val).trim();
    const timePart = s.includes('T') ? s.split('T')[1].slice(0, 8) : (s.length === 5 ? `${s}:00` : s);
    return new Date(`${day}T${timePart}`).getTime();
  };
  const diffSec = Math.round((toMs(absValue) - toMs(raceStartIso)) / 1000);
  if (Number.isNaN(diffSec)) return null;
  const sign = diffSec < 0 ? '-' : '';
  const absSec = Math.abs(diffSec);
  const mins = Math.floor(absSec / 60);
  const secs = absSec % 60;
  return `${sign}${mins}:${String(secs).padStart(2, '0')}`;
};

const recalculateResultStartsAfterRaceStart = (raceStartIso) => {
  const raceDate = (currentRace.value.race_date || '').split('T')[0];
  const apply = (item) => {
    if (!item?.start_time_real || item.competitor_start_time) return item;
    const rel = absoluteStartToRelative(item.start_time_real, raceStartIso, raceDate);
    if (!rel) return item;
    const next = { ...item, competitor_start_time: rel };
    delete next.start_time_real;
    return next;
  };
  resultsEntryOk.value = resultsEntryOk.value.map(apply);
  resultsEntryCreate.value = resultsEntryCreate.value.map(apply);
  updateCombinedResults();
};

const saveRaceStartFromDialog = async () => {
  if (!raceStartDialogTime.value || !currentRaceId.value) return;
  savingRaceStart.value = true;
  const context = raceStartDialogContext.value;
  const retryStartlistUpload = pendingStartlistUploadAfterRaceStart.value;
  try {
    const raceDate = (currentRace.value.race_date || '').split('T')[0];
    const { data } = await apiClient.post(`race/start/?race_id=${currentRaceId.value}`, {
      race_start: `${raceDate}T${raceStartDialogTime.value}`,
    });
    const r = races.value.find((x) => x.id === currentRaceId.value);
    if (r && data.race_start) {
      r.race_start = data.race_start;
      r.race_startTime = raceStartDialogTime.value;
    }
    if (context === 'results') {
      pendingRaceStart.value = data.race_start || null;
      shouldSaveRaceStart.value = false;
      recalculateResultStartsAfterRaceStart(data.race_start);
    }
    dialogRaceStartMissing.value = false;
    raceStartDialogTime.value = '';
    pendingStartlistUploadAfterRaceStart.value = false;
    const savedMsg = context === 'startlist'
      ? t('event_settings.startlist.race_start_dialog.saved_success')
      : t('event_settings.results.race_start_dialog.saved_success');
    snackbar.success(savedMsg);
    if (context === 'startlist' && retryStartlistUpload) {
      await uploadStartlistFile();
    }
  } catch (error) {
    console.error('Chyba při ukládání startu 00:', error);
    const errMsg = context === 'startlist'
      ? t('event_settings.startlist.race_start_dialog.save_error')
      : t('event_settings.results.race_start_dialog.save_error');
    snackbar.error(error.response?.data?.error || errMsg);
  } finally {
    savingRaceStart.value = false;
  }
};



const isLoadingResults = ref(true);
const results = ref([]);
const fetchResults = async () => {
    isLoadingResults.value = true;
    try {
      const response = await apiClient.get(`/results/?race_id=${currentRaceId.value}`);
      results.value = response.data.results;
    } catch (error) {
      console.error('Chyba při načítání dat:', error);
    } finally {
      isLoadingResults.value = false;  // Loading skončí po úspěšném načtení nebo při chybě
  }


  };

function openResultsStepperDialog() {
  dialogAddResults.value = true;
}


const resultsEntryOk = ref([]);
const resultsEntryCreate = ref([]);
const resultsEntryEmpty = ref([]);
const combinedResults = ref([]);
const uploadedResultsFile = ref(null);
const selectedFileType = ref(null);
const categoryProperties = ref([]);
const pendingRaceStart = ref(null);
const shouldSaveRaceStart = ref(false);
const dialogRaceStartMissing = ref(false);
const raceStartDialogContext = ref('results');
const pendingStartlistUploadAfterRaceStart = ref(false);
const raceStartDialogTime = ref('');
const savingRaceStart = ref(false);

const raceStartDialogTitle = computed(() => (
  raceStartDialogContext.value === 'startlist'
    ? t('event_settings.startlist.race_start_dialog.title')
    : t('event_settings.results.race_start_dialog.title')
));

const raceStartDialogDescription = computed(() => (
  raceStartDialogContext.value === 'startlist'
    ? t('event_settings.startlist.race_start_dialog.description')
    : t('event_settings.results.race_start_dialog.description')
));

const raceStartDialogLabel = computed(() => (
  raceStartDialogContext.value === 'startlist'
    ? t('event_settings.startlist.race_start_dialog.label')
    : t('event_settings.results.race_start_dialog.label')
));

const raceStartDialogSaveLabel = computed(() => (
  raceStartDialogContext.value === 'startlist'
    ? t('event_settings.startlist.race_start_dialog.save')
    : t('event_settings.results.race_start_dialog.save')
));

// seřazení kontrolovaných results podle place
const sortedCombinedResults = computed(() => {
  const getCat = (x) => (x.competitor_category_name || '').toLowerCase()
  const getPlace = (x) => {
    const p = Number(x?.result?.place ?? 0)
    return Number.isFinite(p) ? p : 0
  }

  return [...combinedResults.value].sort((a, b) => {
    const c = getCat(a).localeCompare(getCat(b))
    if (c !== 0) return c

    const pa = getPlace(a)
    const pb = getPlace(b)

    // 0 (neznámé) až nakonec
    const za = pa === 0
    const zb = pb === 0
    if (za !== zb) return za ? 1 : -1

    return pa - pb
  })
})

const updateCombinedResults = () => {
  combinedResults.value = [
    ...resultsEntryOk.value,
    ...resultsEntryCreate.value,
    ...resultsEntryEmpty.value,
  ];
};


// Funkce pro nahrání souboru a zpracování do response k editaci
const uploadResultsFile = async () => {
  loadingSubmit.value = true;
  if (uploadedResultsFile.value && selectedFileType.value) {
    const formData = new FormData();
    formData.append('file', uploadedResultsFile.value);

    try {
      const response = await apiClient.post(`results/?race_id=${currentRaceId.value}&name=${selectedFileType.value}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      successResultsMessage.value = t('event_settings.results.upload_success');
      errorResultsMessage.value = '';

      // Zpracování dat z response
      resultsEntryOk.value = response.data.results_entry_ok;
      resultsEntryCreate.value = response.data.results_entry_create;
      resultsEntryEmpty.value = response.data.results_entry_empty;
      const hadRaceStartInDb = !!(currentRace.value?.race_start);
      pendingRaceStart.value = response.data.race_start || null;
      shouldSaveRaceStart.value = !!(response.data.race_start && !hadRaceStartInDb);

      if (!response.data.race_start) {
        raceStartDialogTime.value = '';
        openRaceStartDialog('results');
      } else {
        dialogRaceStartMissing.value = false;
      }

      // Definuj categories z response
      categoryProperties.value = response.data.categories.map((category) => ({
        category_name: category.category_name,
        category_control_points: Array.isArray(category.category_control_points)
        ? category.category_control_points.join(', ')
        : category.category_control_points, // Zkontroluje, jestli je to pole
    })).sort((a, b) => a.category_name.localeCompare(b.category_name));


      updateCombinedResults(); // Aktualizace tabulky po načtení dat

    } catch (error) {
      console.error('Chyba při nahrávání souboru:', error);

      // Ošetření chyby 406 a dalších specifických chybových zpráv
      if (error.response && error.response.status === 406) {
        errorResultsMessage.value = `${t('event_settings.results.errors_list_title')}: ${error.response.data.error}`;
      } else if (error.response) {
        errorResultsMessage.value = `${t('event_settings.results.errors_list_title')}: ${error.response.data.error || t('event_settings.results.upload_error')}`;
      } else {
        errorResultsMessage.value = t('event_settings.results.upload_error');
      }

      successResultsMessage.value = '';
    } finally {
      loadingSubmit.value = false;
    }
  }
};


const isResultsFileValid = ref(false);
const errorResultsSelectMessage = ref('');

const handleResultsFileUpload = (event) => {
  errorResultsMessage.value = '';
  successResultsMessage.value = '';
  const file = event.target.files[0];

  if (file && file.name) {
    const validExtensions = ['.csv', '.xml', '.json', '.txt'];
    const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

    if (validExtensions.includes(fileExtension)) {
      uploadedResultsFile.value = file; // Soubor je validní
    } else {
      uploadedResultsFile.value = null;
      errorResultsMessage.value = t('event_settings.results.file_error');
      return; // Ukončíme kontrolu, protože soubor není validní
    }
  } else {
    uploadedResultsFile.value = null;
    errorResultsMessage.value = t('event_settings.results.file_choose');
    return; // Ukončíme kontrolu, protože soubor není nahrán
  }

  validateSelectedFileType(); // Kontrola, zda je typ vybrán
};

watch(selectedFileType, (newVal) => {
  console.log('selectedFileType changed:', newVal);
  validateSelectedFileType();
});


// Objekt pro uložení barev přiřazených řádkům při jejich inicializaci
const rowResultsColors = ref({});

const setResultsRowProps = ({ item }) => {
  const itemIndex = item.competitor_index || ''; // Získání hodnoty indexu
  const itemName = `${item.last_name.toLowerCase()} ${item.first_name.toLowerCase()}`; // Kombinace příjmení a jména

  // Pokud již existuje barva pro daný řádek, vraťte ji
  if (rowResultsColors.value[itemIndex] || rowResultsColors.value[itemName]) {
    return { class: rowResultsColors.value[itemIndex] || rowResultsColors.value[itemName] };
  }

  let rowResultsClass = '';

  if (itemIndex) {
    // Pokud je přítomný index, kontrolujeme podle indexu
    if (resultsEntryOk.value.some(okItem => okItem.competitor_index === itemIndex)) {
      rowResultsClass = 'bg-ok';
    } else if (resultsEntryCreate.value.some(createItem => createItem.competitor_index === itemIndex)) {
      rowResultsClass = 'bg-create';
    } else if (resultsEntryEmpty.value.some(emptyItem => emptyItem.competitor_index === itemIndex)) {
      rowResultsClass = 'bg-empty';
    }
    rowColors.value[itemIndex] = rowResultsClass; // Uložení barvy pro tento řádek podle indexu
  } else {
    // Pokud index není přítomný, kontrolujeme podle kombinace příjmení a jména
    if (resultsEntryOk.value.some(okItem => `${okItem.last_name.toLowerCase()} ${okItem.first_name.toLowerCase()}` === itemName)) {
      rowResultsClass = 'bg-ok';
    } else if (resultsEntryCreate.value.some(createItem => `${createItem.last_name.toLowerCase()} ${createItem.first_name.toLowerCase()}` === itemName)) {
      rowResultsClass = 'bg-create';
    } else if (resultsEntryEmpty.value.some(emptyItem => `${emptyItem.last_name.toLowerCase()} ${emptyItem.first_name.toLowerCase()}` === itemName)) {
      rowResultsClass = 'bg-empty';
    }
    rowResultsColors.value[itemName] = rowResultsClass; // Uložení barvy pro tento řádek podle kombinace příjmení a jména
  }

  return { class: rowResultsClass };
};



const resultEditItemKey = (item) => {
  if (item?.competitor_id != null && item.competitor_id !== '') return `cid:${item.competitor_id}`;
  if (item?.entry_id != null && item.entry_id !== '') return `eid:${item.entry_id}`;
  if (item?.competitor_index) return `idx:${String(item.competitor_index).toUpperCase()}`;
  return `name:${(item?.last_name || '').toLowerCase()}|${(item?.first_name || '').toLowerCase()}`;
};

const openEditResultDialog = (result) => {
  selectedResult.value = {
    ...result,
    _orig_last_name: result.last_name,
    _orig_first_name: result.first_name,
    _orig_competitor_index: result.competitor_index,
  };
  dialogEditResult.value = true;
};


// Uložení editace výsledku
const saveEditResult = () => {
  const sel = selectedResult.value;
  const origKey = resultEditItemKey({
    competitor_id: sel.competitor_id,
    entry_id: sel.entry_id,
    competitor_index: sel._orig_competitor_index,
    last_name: sel._orig_last_name,
    first_name: sel._orig_first_name,
  });

  let resultIndex = combinedResults.value.findIndex((item) => resultEditItemKey(item) === origKey);

  // fallback na aktuální hodnoty (když se nic nezměnilo u identity)
  if (resultIndex === -1) {
    resultIndex = combinedResults.value.findIndex((item) => resultEditItemKey(item) === resultEditItemKey(sel));
  }

  if (resultIndex !== -1) {
    const { _orig_last_name, _orig_first_name, _orig_competitor_index, ...updated } = sel;
    combinedResults.value[resultIndex] = { ...updated };

    const remapKeys = (list) => {
      const keys = new Set(list.map(resultEditItemKey));
      if (keys.has(origKey)) {
        keys.delete(origKey);
        keys.add(resultEditItemKey(updated));
      }
      return combinedResults.value.filter((item) => keys.has(resultEditItemKey(item)));
    };

    resultsEntryOk.value = remapKeys(resultsEntryOk.value);
    resultsEntryCreate.value = remapKeys(resultsEntryCreate.value);
    resultsEntryEmpty.value = remapKeys(resultsEntryEmpty.value);
  }

  dialogEditResult.value = false;
};



const openDeleteResultDialog = (result) => {
  selectedResult.value = result;
  dialogDeleteResult.value = true;
};

const deleteResult = () => {
  const sel = selectedResult.value
  // 1) najít pozici v combinedResults
  const hasIdx = sel.competitor_index && sel.competitor_index.trim() !== ''
  const resultIndex = hasIdx
    ? combinedResults.value.findIndex(item => item.competitor_index === sel.competitor_index)
    : combinedResults.value.findIndex(item =>
        item.first_name.toLowerCase() === sel.first_name.toLowerCase() &&
        item.last_name.toLowerCase()  === sel.last_name.toLowerCase()
      )

  if (resultIndex === -1) {
    dialogDeleteResult.value = false
    return
  }

  // 2) odebrat z combinedResults a uložit odebraný záznam
  const [removed] = combinedResults.value.splice(resultIndex, 1)

  // pomocná funkce pro porovnání stejného záznamu
  const isSame = item => {
    if (item.competitor_index && item.competitor_index.trim() !== '') {
      return item.competitor_index === removed.competitor_index
    }
    return (
      item.first_name.toLowerCase() === removed.first_name.toLowerCase() &&
      item.last_name.toLowerCase()  === removed.last_name.toLowerCase()
    )
  }

  // 3) z každého pole odstranit položku, která se rovná removed
  resultsEntryOk.value     = resultsEntryOk.value.filter(item => !isSame(item))
  resultsEntryCreate.value = resultsEntryCreate.value.filter(item => !isSame(item))
  resultsEntryEmpty.value  = resultsEntryEmpty.value.filter(item => !isSame(item))

  dialogDeleteResult.value = false
}


// odeslání JSON pro uložení startů
const saveResultsData = async () => {
  loadingSubmit.value = true;
  try {
    const payload = {
      competitors: combinedResults.value, // Obsahuje výsledky včetně skrytých startů
      categories: categoryProperties.value, // Obsahuje vlastnosti kategorií
    };
    if (shouldSaveRaceStart.value && pendingRaceStart.value) {
      payload.race_start = pendingRaceStart.value;
    }

    await apiClient.post(
      `results/?race_id=${currentRaceId.value}&valid=True`,
      JSON.stringify(payload),  // Převod dat na JSON formát
      {
        headers: {
          'Content-Type': 'application/json',  // Nastavení správné hlavičky
        },
      }
    );
    snackbar.success(t('event_settings.results.results_save'));
    errorResultsSendMessage.value = ""
    dialogAddResults.value = false;  // Zavřít dialog po úspěšném odeslání
    combinedResults.value = [];  // Vynulovat obsah combinedResults po úspěšném uložení
    rowResultsColors.value = {}; // Resetování barev při úspěšném odeslání
    categoryProperties.value = {}; // resetování kategorií
    pendingRaceStart.value = null;
    shouldSaveRaceStart.value = false;
    successResultsMessage.value = '';
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scrollování nahoru pro zobrazení chybové zprávy

    fetchEntries();
    fetchResults();

  } catch (error) {
    console.error('Chyba při odesílání dat:', error);

    // Kontrola kódu 406 a zobrazení specifické chyby
    if (error.response && error.response.status === 406 && error.response.data && Array.isArray(error.response.data.error)) {
      errorResultsSendMessage.value = error.response.data.error; // Přiřadit celé pole chybových zpráv
      console.log('Error message:', errorResultsSendMessage.value); // Debugging
    } else {
      errorResultsSendMessage.value = `${t('event_settings.results.results_upload_error')}: ${error.response.data.error}`;
      console.log('Error message:', errorResultsSendMessage.value);
    }
  } finally {
      loadingSubmit.value = false;  // Ukončení načítání po zpracování odpovědi
    }
};


const dialogDeleteAllResults = ref(false);

// Funkce pro otevření dialogu pro smazání všech results
const openDeleteAllResultsDialog = () => {
  dialogDeleteAllResults.value = true;
};

// Funkce pro mazání všech results
const deleteAllResults = async () => {
  try {
    await apiClient.delete(`/results/?race_id=${currentRaceId.value}`);
    dialogDeleteAllResults.value = false;
    snackbar.success(t('event_settings.results.results_delete_all'));
    fetchResults(); // Obnovit list výsledků po smazání
  } catch (error) {
    console.error('Chyba při mazání výsledků:', error);
    snackbar.error(t('event_settings.results.results_delete_all_error'));
  }
};


/////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////



// Stažení docx protokolu soutěže - nastavení pro loading

const loadingDocx = ref(false)

function downloadProtocol() {
  loadingDocx.value = true

  // Jakmile uživatel dokončí dialog stahování a vrátí se zpátky do okna,
  // vypneme loading
  window.addEventListener(
    'focus',
    () => {
      loadingDocx.value = false
    },
    { once: true }
  )
}

// Aktualizace VT
const loadingRecalculate = ref(false)

const recalculateVtRank = async () => {
  const eventId = route.params.id;
  loadingRecalculate.value = true
  try {
    const { data } = await apiClient.post(`event/${eventId}/recalculate/`)
    const changed = data?.results_changed ?? 0
    const races_num = data?.races_processed ?? 0
    snackbar.success(t('event_settings.recalc_vt_success', { count: changed, raceCount: races_num }));
  } catch (e) {
    console.error(e)
  } finally {
    loadingRecalculate.value = false
  }
}


// Zjištění stavu hodnot v polích, jestli uživatel neodchází s neuloženými změnami

// --- helpery ---
const nn = v => (v === '' || v === undefined ? null : v);       // '' -> null
const toMinute = v => (v ? String(v).replace('Z','').slice(0,16) : null); // YYYY-MM-DDTHH:MM
const sortArr = a => Array.isArray(a) ? [...a].sort((x,y)=>(''+x).localeCompare(''+y)) : a;

// stabilní JSON (seřadí klíče)
const stable = (obj) => {
  const rec = (v) => {
    if (Array.isArray(v)) return v.map(rec);
    if (v && typeof v === 'object') {
      return Object.keys(v).sort().reduce((o,k)=> (o[k]=rec(v[k]), o), {});
    }
    return v;
  };
  return JSON.stringify(rec(obj));
};

const getEventRacePayload = () => ({
  event: {
    id: event.value?.id ?? null,
    event_name: event.value?.event_name ?? '',
    event_date_start: event.value?.event_date_start ?? null,
    event_date_end: event.value?.event_date_end ?? null,
    event_type: event.value?.event_type ?? null,
    visibility: event.value?.visibility ?? null,
    event_currency: event.value?.event_currency ?? null,
    auth_entry_only: !!event.value?.auth_entry_only,
    allow_start_choice: !!event.value?.allow_start_choice,
    acc_all_only: !!event.value?.acc_all_only,
    disable_si_cards: !!event.value?.disable_si_cards,
    disable_automodule: !!event.value?.disable_automodule,
    restrict_services: !!event.value?.restrict_services,
    canceled: !!event.value?.canceled,
    event_location: event.value?.event_location ?? null,
    contact: event.value?.contact ?? null,
    event_note: event.value?.event_note ?? null,
    entry_is_open: !!event.value?.entry_is_open,
    editors: (selectedEditors.value || []).map(e => (typeof e === 'object' ? e.id : e)),
  },
  race0: {
    id: race0.value?.id ?? null,
    entry_deadline_1: toMinute(nn(race0.value?.entry_deadline_1)),
    entry_deadline_2: toMinute(nn(race0.value?.entry_deadline_2)),
    message_info: race0.value?.message_info ?? null,
    message_warning: race0.value?.message_warning ?? null,
  },
  races: (races.value || []).map(r => ({
    id: r.id,
    race_name: r.race_name ?? '',
    race_date: r.race_date ?? null,
    race_start: r.race_start ?? null,
    race_level: r.race_level ?? null,
    race_band: r.race_band ?? null,
    race_type: r.race_type ?? null,
    race_time_limit: r.race_time_limit ?? null,
    message_info: r.message_info ?? null,
    message_warning: r.message_warning ?? null,
    race_note: r.race_note ?? null,
  })),
})

// ==== guard ====
const leaveDialog = ref(false)
let _pendingNext = null
const _snapshot = ref('')

const takeSnapshot = () => { _snapshot.value = stable(getEventRacePayload()); };

const isDirty = computed(() => stable(getEventRacePayload()) !== _snapshot.value);


onBeforeRouteLeave((_to, _from, next) => {
  if (!isDirty.value) return next()
  _pendingNext = next
  leaveDialog.value = true
})

const confirmLeave = () => { leaveDialog.value = false; _pendingNext?.(); _pendingNext = null }
const cancelLeave  = () => { leaveDialog.value = false; _pendingNext = null }







</script>



<style scoped>




td {
  min-width: 160px;
}

.dialog-over-dialog .v-dialog__content {
  z-index: 202 !important; /* Standardní z-index pro dialogy Vuetify je 200 */
}

/* zmenšení margin, aby se do okna vešel rám oken */
.v-row {
  margin:-10px;
}

.food-day-card {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

@media (min-width: 600px) {
    .v-btn {
      width: auto !important;
    }
  }


  .first-row {
  background-color: rgb(var(--v-theme-entry-surface));
  border-radius: 4px;
  padding: 0 5px 0 5px;
}

/* Plná šířka + zalamování textu (přepisuje globální width:auto u .v-btn) */
.btn-text-wrap {
  height: auto !important;
  min-height: 36px;
  width: 100% !important;
  white-space: normal !important;
}
.btn-text-wrap :deep(.v-btn__content) {
  white-space: normal;
  text-align: center;
  line-height: 1.3;
}


:deep(.bg-ok) {
  background-color: rgb(var(--v-theme-upload-ok)) !important;
}

:deep(.bg-create) {
  background-color: rgb(var(--v-theme-upload-create)) !important;
}

:deep(.bg-empty) {
  background-color: rgb(var(--v-theme-upload-empty)) !important;
}


/* .v-input {
  max-height: 55px; /* Nastavení minimální výšky */
 /* padding: 4px 12px; /* Nastavení paddingu */
/*} */
</style>